(function () {
	'use strict';

	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function unwrapExports (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	var common = createCommonjsModule(function (module, exports) {
	(function (global, factory) {
		factory(exports);
	}(commonjsGlobal, (function (exports) {
	/**
	 * TODO: Ideally this would be a NodeList.prototype.forEach polyfill
	 * This seems to fail in IE8, requires more investigation.
	 * See: https://github.com/imagitama/nodelist-foreach-polyfill
	 */
	function nodeListForEach (nodes, callback) {
	  if (window.NodeList.prototype.forEach) {
	    return nodes.forEach(callback)
	  }
	  for (var i = 0; i < nodes.length; i++) {
	    callback.call(window, nodes[i], i, nodes);
	  }
	}

	// Used to generate a unique string, allows multiple instances of the component without
	// Them conflicting with each other.
	// https://stackoverflow.com/a/8809472
	function generateUniqueID () {
	  var d = new Date().getTime();
	  if (typeof window.performance !== 'undefined' && typeof window.performance.now === 'function') {
	    d += window.performance.now(); // use high-precision timer if available
	  }
	  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	    var r = (d + Math.random() * 16) % 16 | 0;
	    d = Math.floor(d / 16);
	    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
	  })
	}

	exports.nodeListForEach = nodeListForEach;
	exports.generateUniqueID = generateUniqueID;

	})));
	});

	/*
	  Cookie methods
	  ==============
	  Usage:
	    Setting a cookie:
	    CookieBanner.init('hobnob', 'tasty', { days: 30 });
	    Reading a cookie:
	    CookieBanner.init('hobnob');
	    Deleting a cookie:
	    CookieBanner.init('hobnob', null);
	*/
	var CookieBanner = {
	  init: function (name, value, options) {
	    if (typeof value !== 'undefined') {
	      if (value === false || value === null) {
	        return CookieBanner.setCookie(name, '', { days: -1 })
	      } else {
	        return CookieBanner.setCookie(name, value, options)
	      }
	    } else {
	      return CookieBanner.getCookie(name)
	    }
	  },
	  setCookie: function (name, value, options) {
	    if (typeof options === 'undefined') {
	      options = {};
	    }
	    var cookieString = name + '=' + value + '; path=/';
	    if (options.days) {
	      var date = new Date();
	      date.setTime(date.getTime() + (options.days * 24 * 60 * 60 * 1000));
	      cookieString = cookieString + '; expires=' + date.toGMTString();
	    }
	    if (document.location.protocol === 'https:') {
	      cookieString = cookieString + '; Secure';
	    }
	    document.cookie = cookieString;
	  },
	  getCookie: function (name) {
	    var nameEQ = name + '=';
	    var cookies = document.cookie.split(';');
	    for (var i = 0, len = cookies.length; i < len; i++) {
	      var cookie = cookies[i];
	      while (cookie.charAt(0) === ' ') {
	        cookie = cookie.substring(1, cookie.length);
	      }
	      if (cookie.indexOf(nameEQ) === 0) {
	        return decodeURIComponent(cookie.substring(nameEQ.length))
	      }
	    }
	    return null
	  },
	  addCookieMessage: function () {
	    var message = document.querySelector('.js-cookie-banner');
	    var hasCookieMessage = (message && CookieBanner.init('seen_cookie_message') === null);

	    if (hasCookieMessage) {
	      message.style.display = 'block';
	      CookieBanner.init('seen_cookie_message', 'yes', { days: 28 });
	    }
	  }
	};

	var iframeResizer = createCommonjsModule(function (module) {
	(function(undefined) {

	  if(typeof window === 'undefined') return; // don't run for server side render

	  var
	    count                 = 0,
	    logEnabled            = false,
	    hiddenCheckEnabled    = false,
	    msgHeader             = 'message',
	    msgHeaderLen          = msgHeader.length,
	    msgId                 = '[iFrameSizer]', //Must match iframe msg ID
	    msgIdLen              = msgId.length,
	    pagePosition          = null,
	    requestAnimationFrame = window.requestAnimationFrame,
	    resetRequiredMethods  = {max:1,scroll:1,bodyScroll:1,documentElementScroll:1},
	    settings              = {},
	    timer                 = null,
	    logId                 = 'Host Page',

	    defaults              = {
	      autoResize                : true,
	      bodyBackground            : null,
	      bodyMargin                : null,
	      bodyMarginV1              : 8,
	      bodyPadding               : null,
	      checkOrigin               : true,
	      inPageLinks               : false,
	      enablePublicMethods       : true,
	      heightCalculationMethod   : 'bodyOffset',
	      id                        : 'iFrameResizer',
	      interval                  : 32,
	      log                       : false,
	      maxHeight                 : Infinity,
	      maxWidth                  : Infinity,
	      minHeight                 : 0,
	      minWidth                  : 0,
	      resizeFrom                : 'parent',
	      scrolling                 : false,
	      sizeHeight                : true,
	      sizeWidth                 : false,
	      warningTimeout            : 5000,
	      tolerance                 : 0,
	      widthCalculationMethod    : 'scroll',
	      closedCallback            : function() {},
	      initCallback              : function() {},
	      messageCallback           : function() {warn('MessageCallback function not defined');},
	      resizedCallback           : function() {},
	      scrollCallback            : function() {return true;}
	    };

	  function addEventListener(obj,evt,func) {
	    /* istanbul ignore else */ // Not testable in PhantonJS
	    if ('addEventListener' in window) {
	      obj.addEventListener(evt,func, false);
	    } else if ('attachEvent' in window) {//IE
	      obj.attachEvent('on'+evt,func);
	    }
	  }

	  function removeEventListener(el,evt,func) {
	    /* istanbul ignore else */ // Not testable in phantonJS
	    if ('removeEventListener' in window) {
	      el.removeEventListener(evt,func, false);
	    } else if ('detachEvent' in window) { //IE
	      el.detachEvent('on'+evt,func);
	    }
	  }

	  function setupRequestAnimationFrame() {
	    var
	      vendors = ['moz', 'webkit', 'o', 'ms'],
	      x;

	    // Remove vendor prefixing if prefixed and break early if not
	    for (x = 0; x < vendors.length && !requestAnimationFrame; x += 1) {
	      requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	    }

	    if (!(requestAnimationFrame)) {
	      log('setup','RequestAnimationFrame not supported');
	    }
	  }

	  function getMyID(iframeId) {
	    var retStr = 'Host page: '+iframeId;

	    if (window.top !== window.self) {
	      if (window.parentIFrame && window.parentIFrame.getId) {
	        retStr = window.parentIFrame.getId()+': '+iframeId;
	      } else {
	        retStr = 'Nested host page: '+iframeId;
	      }
	    }

	    return retStr;
	  }

	  function formatLogHeader(iframeId) {
	    return msgId + '[' + getMyID(iframeId) + ']';
	  }

	  function isLogEnabled(iframeId) {
	    return settings[iframeId] ? settings[iframeId].log : logEnabled;
	  }

	  function log(iframeId,msg) {
	    output('log',iframeId,msg,isLogEnabled(iframeId));
	  }

	  function info(iframeId,msg) {
	    output('info',iframeId,msg,isLogEnabled(iframeId));
	  }

	  function warn(iframeId,msg) {
	    output('warn',iframeId,msg,true);
	  }

	  function output(type,iframeId,msg,enabled) {
	    if (true === enabled && 'object' === typeof window.console) {
	      console[type](formatLogHeader(iframeId),msg);
	    }
	  }

	  function iFrameListener(event) {
	    function resizeIFrame() {
	      function resize() {
	        setSize(messageData);
	        setPagePosition(iframeId);
	        callback('resizedCallback',messageData);
	      }

	      ensureInRange('Height');
	      ensureInRange('Width');

	      syncResize(resize,messageData,'init');
	    }

	    function processMsg() {
	      var data = msg.substr(msgIdLen).split(':');

	      return {
	        iframe: settings[data[0]] && settings[data[0]].iframe,
	        id:     data[0],
	        height: data[1],
	        width:  data[2],
	        type:   data[3]
	      };
	    }

	    function ensureInRange(Dimension) {
	      var
	        max  = Number(settings[iframeId]['max' + Dimension]),
	        min  = Number(settings[iframeId]['min' + Dimension]),
	        dimension = Dimension.toLowerCase(),
	        size = Number(messageData[dimension]);

	      log(iframeId,'Checking ' + dimension + ' is in range ' + min + '-' + max);

	      if (size<min) {
	        size=min;
	        log(iframeId,'Set ' + dimension + ' to min value');
	      }

	      if (size>max) {
	        size=max;
	        log(iframeId,'Set ' + dimension + ' to max value');
	      }

	      messageData[dimension] = '' + size;
	    }


	    function isMessageFromIFrame() {
	      function checkAllowedOrigin() {
	        function checkList() {
	          var
	            i = 0,
	            retCode = false;

	          log(iframeId,'Checking connection is from allowed list of origins: ' + checkOrigin);

	          for (; i < checkOrigin.length; i++) {
	            if (checkOrigin[i] === origin) {
	              retCode = true;
	              break;
	            }
	          }
	          return retCode;
	        }

	        function checkSingle() {
	          var remoteHost  = settings[iframeId] && settings[iframeId].remoteHost;
	          log(iframeId,'Checking connection is from: '+remoteHost);
	          return origin === remoteHost;
	        }

	        return checkOrigin.constructor === Array ? checkList() : checkSingle();
	      }

	      var
	        origin      = event.origin,
	        checkOrigin = settings[iframeId] && settings[iframeId].checkOrigin;

	      if (checkOrigin && (''+origin !== 'null') && !checkAllowedOrigin()) {
	        throw new Error(
	          'Unexpected message received from: ' + origin +
	          ' for ' + messageData.iframe.id +
	          '. Message was: ' + event.data +
	          '. This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.'
	        );
	      }

	      return true;
	    }

	    function isMessageForUs() {
	      return msgId === (('' + msg).substr(0,msgIdLen)) && (msg.substr(msgIdLen).split(':')[0] in settings); //''+Protects against non-string msg
	    }

	    function isMessageFromMetaParent() {
	      //Test if this message is from a parent above us. This is an ugly test, however, updating
	      //the message format would break backwards compatibity.
	      var retCode = messageData.type in {'true':1,'false':1,'undefined':1};

	      if (retCode) {
	        log(iframeId,'Ignoring init message from meta parent page');
	      }

	      return retCode;
	    }

	    function getMsgBody(offset) {
	      return msg.substr(msg.indexOf(':')+msgHeaderLen+offset);
	    }

	    function forwardMsgFromIFrame(msgBody) {
	      log(iframeId,'MessageCallback passed: {iframe: '+ messageData.iframe.id + ', message: ' + msgBody + '}');
	      callback('messageCallback',{
	        iframe: messageData.iframe,
	        message: JSON.parse(msgBody)
	      });
	      log(iframeId,'--');
	    }

	    function getPageInfo() {
	      var
	        bodyPosition   = document.body.getBoundingClientRect(),
	        iFramePosition = messageData.iframe.getBoundingClientRect();

	      return JSON.stringify({
	        iframeHeight: iFramePosition.height,
	        iframeWidth:  iFramePosition.width,
	        clientHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
	        clientWidth:  Math.max(document.documentElement.clientWidth,  window.innerWidth  || 0),
	        offsetTop:    parseInt(iFramePosition.top  - bodyPosition.top,  10),
	        offsetLeft:   parseInt(iFramePosition.left - bodyPosition.left, 10),
	        scrollTop:    window.pageYOffset,
	        scrollLeft:   window.pageXOffset
	      });
	    }

	    function sendPageInfoToIframe(iframe,iframeId) {
	      function debouncedTrigger() {
	        trigger(
	          'Send Page Info',
	          'pageInfo:' + getPageInfo(),
	          iframe,
	          iframeId
	        );
	      }

	      debouce(debouncedTrigger,32);
	    }


	    function startPageInfoMonitor() {
	      function setListener(type,func) {
	        function sendPageInfo() {
	          if (settings[id]) {
	            sendPageInfoToIframe(settings[id].iframe,id);
	          } else {
	            stop();
	          }
	        }

	        ['scroll','resize'].forEach(function(evt) {
	          log(id, type +  evt + ' listener for sendPageInfo');
	          func(window,evt,sendPageInfo);
	        });
	      }

	      function stop() {
	        setListener('Remove ', removeEventListener);
	      }

	      function start() {
	        setListener('Add ', addEventListener);
	      }

	      var id = iframeId; //Create locally scoped copy of iFrame ID

	      start();

	      if (settings[id]) {
	        settings[id].stopPageInfo = stop;
	      }
	    }

	    function stopPageInfoMonitor() {
	      if (settings[iframeId] && settings[iframeId].stopPageInfo) {
	        settings[iframeId].stopPageInfo();
	        delete settings[iframeId].stopPageInfo;
	      }
	    }

	    function checkIFrameExists() {
	      var retBool = true;

	      if (null === messageData.iframe) {
	        warn(iframeId,'IFrame ('+messageData.id+') not found');
	        retBool = false;
	      }
	      return retBool;
	    }

	    function getElementPosition(target) {
	      var iFramePosition = target.getBoundingClientRect();

	      getPagePosition(iframeId);

	      return {
	        x: Math.floor( Number(iFramePosition.left) + Number(pagePosition.x) ),
	        y: Math.floor( Number(iFramePosition.top)  + Number(pagePosition.y) )
	      };
	    }

	    function scrollRequestFromChild(addOffset) {
	      /* istanbul ignore next */  //Not testable in Karma
	      function reposition() {
	        pagePosition = newPosition;
	        scrollTo();
	        log(iframeId,'--');
	      }

	      function calcOffset() {
	        return {
	          x: Number(messageData.width) + offset.x,
	          y: Number(messageData.height) + offset.y
	        };
	      }

	      function scrollParent() {
	        if (window.parentIFrame) {
	          window.parentIFrame['scrollTo'+(addOffset?'Offset':'')](newPosition.x,newPosition.y);
	        } else {
	          warn(iframeId,'Unable to scroll to requested position, window.parentIFrame not found');
	        }
	      }

	      var
	        offset = addOffset ? getElementPosition(messageData.iframe) : {x:0,y:0},
	        newPosition = calcOffset();

	      log(iframeId,'Reposition requested from iFrame (offset x:'+offset.x+' y:'+offset.y+')');

	      if(window.top !== window.self) {
	        scrollParent();
	      } else {
	        reposition();
	      }
	    }

	    function scrollTo() {
	      if (false !== callback('scrollCallback',pagePosition)) {
	        setPagePosition(iframeId);
	      } else {
	        unsetPagePosition();
	      }
	    }

	    function findTarget(location) {
	      function jumpToTarget() {
	        var jumpPosition = getElementPosition(target);

	        log(iframeId,'Moving to in page link (#'+hash+') at x: '+jumpPosition.x+' y: '+jumpPosition.y);
	        pagePosition = {
	          x: jumpPosition.x,
	          y: jumpPosition.y
	        };

	        scrollTo();
	        log(iframeId,'--');
	      }

	      function jumpToParent() {
	        if (window.parentIFrame) {
	          window.parentIFrame.moveToAnchor(hash);
	        } else {
	          log(iframeId,'In page link #'+hash+' not found and window.parentIFrame not found');
	        }
	      }

	      var
	        hash     = location.split('#')[1] || '',
	        hashData = decodeURIComponent(hash),
	        target   = document.getElementById(hashData) || document.getElementsByName(hashData)[0];

	      if (target) {
	        jumpToTarget();
	      } else if(window.top!==window.self) {
	        jumpToParent();
	      } else {
	        log(iframeId,'In page link #'+hash+' not found');
	      }
	    }

	    function callback(funcName,val) {
	      return chkCallback(iframeId,funcName,val);
	    }

	    function actionMsg() {

	      if(settings[iframeId] && settings[iframeId].firstRun) firstRun();

	      switch(messageData.type) {
	      case 'close':
	        if(settings[iframeId].closeRequestCallback) chkCallback(iframeId, 'closeRequestCallback', settings[iframeId].iframe);
	        else closeIFrame(messageData.iframe);
	        break;
	      case 'message':
	        forwardMsgFromIFrame(getMsgBody(6));
	        break;
	      case 'scrollTo':
	        scrollRequestFromChild(false);
	        break;
	      case 'scrollToOffset':
	        scrollRequestFromChild(true);
	        break;
	      case 'pageInfo':
	        sendPageInfoToIframe(settings[iframeId] && settings[iframeId].iframe,iframeId);
	        startPageInfoMonitor();
	        break;
	      case 'pageInfoStop':
	        stopPageInfoMonitor();
	        break;
	      case 'inPageLink':
	        findTarget(getMsgBody(9));
	        break;
	      case 'reset':
	        resetIFrame(messageData);
	        break;
	      case 'init':
	        resizeIFrame();
	        callback('initCallback',messageData.iframe);
	        break;
	      default:
	        resizeIFrame();
	      }
	    }

	    function hasSettings(iframeId) {
	      var retBool = true;

	      if (!settings[iframeId]) {
	        retBool = false;
	        warn(messageData.type + ' No settings for ' + iframeId + '. Message was: ' + msg);
	      }

	      return retBool;
	    }

	    function iFrameReadyMsgReceived() {
	      for (var iframeId in settings) {
	        trigger('iFrame requested init',createOutgoingMsg(iframeId),document.getElementById(iframeId),iframeId);
	      }
	    }

	    function firstRun() {
	      if (settings[iframeId]) {
	        settings[iframeId].firstRun = false;
	      }
	    }

	    var
	      msg = event.data,
	      messageData = {},
	      iframeId = null;

	    if('[iFrameResizerChild]Ready' === msg) {
	      iFrameReadyMsgReceived();
	    } else if (isMessageForUs()) {
	      messageData = processMsg();
	      iframeId    = logId = messageData.id;
	      if (settings[iframeId]) {
	        settings[iframeId].loaded = true;
	      }

	      if (!isMessageFromMetaParent() && hasSettings(iframeId)) {
	        log(iframeId,'Received: '+msg);

	        if ( checkIFrameExists() && isMessageFromIFrame() ) {
	          actionMsg();
	        }
	      }
	    } else {
	      info(iframeId,'Ignored: '+msg);
	    }

	  }


	  function chkCallback(iframeId,funcName,val) {
	    var
	      func = null,
	      retVal = null;

	    if(settings[iframeId]) {
	      func = settings[iframeId][funcName];

	      if( 'function' === typeof func) {
	        retVal = func(val);
	      } else {
	        throw new TypeError(funcName+' on iFrame['+iframeId+'] is not a function');
	      }
	    }

	    return retVal;
	  }

	  function closeIFrame(iframe) {
	    var iframeId = iframe.id;

	    log(iframeId,'Removing iFrame: '+iframeId);
	    if (iframe.parentNode) { iframe.parentNode.removeChild(iframe); }
	    chkCallback(iframeId,'closedCallback',iframeId);
	    log(iframeId,'--');
	    delete settings[iframeId];
	  }

	  function getPagePosition(iframeId) {
	    if(null === pagePosition) {
	      pagePosition = {
	        x: (window.pageXOffset !== undefined) ? window.pageXOffset : document.documentElement.scrollLeft,
	        y: (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop
	      };
	      log(iframeId,'Get page position: '+pagePosition.x+','+pagePosition.y);
	    }
	  }

	  function setPagePosition(iframeId) {
	    if(null !== pagePosition) {
	      window.scrollTo(pagePosition.x,pagePosition.y);
	      log(iframeId,'Set page position: '+pagePosition.x+','+pagePosition.y);
	      unsetPagePosition();
	    }
	  }

	  function unsetPagePosition() {
	    pagePosition = null;
	  }

	  function resetIFrame(messageData) {
	    function reset() {
	      setSize(messageData);
	      trigger('reset','reset',messageData.iframe,messageData.id);
	    }

	    log(messageData.id,'Size reset requested by '+('init'===messageData.type?'host page':'iFrame'));
	    getPagePosition(messageData.id);
	    syncResize(reset,messageData,'reset');
	  }

	  function setSize(messageData) {
	    function setDimension(dimension) {
	      messageData.iframe.style[dimension] = messageData[dimension] + 'px';
	      log(
	        messageData.id,
	        'IFrame (' + iframeId +
	        ') ' + dimension +
	        ' set to ' + messageData[dimension] + 'px'
	      );
	    }

	    function chkZero(dimension) {
	      //FireFox sets dimension of hidden iFrames to zero.
	      //So if we detect that set up an event to check for
	      //when iFrame becomes visible.

	      /* istanbul ignore next */  //Not testable in PhantomJS
	      if (!hiddenCheckEnabled && '0' === messageData[dimension]) {
	        hiddenCheckEnabled = true;
	        log(iframeId,'Hidden iFrame detected, creating visibility listener');
	        fixHiddenIFrames();
	      }
	    }

	    function processDimension(dimension) {
	      setDimension(dimension);
	      chkZero(dimension);
	    }

	    var iframeId = messageData.iframe.id;

	    if(settings[iframeId]) {
	      if( settings[iframeId].sizeHeight) { processDimension('height'); }
	      if( settings[iframeId].sizeWidth ) { processDimension('width'); }
	    }
	  }

	  function syncResize(func,messageData,doNotSync) {
	    /* istanbul ignore if */  //Not testable in PhantomJS
	    if(doNotSync!==messageData.type && requestAnimationFrame) {
	      log(messageData.id,'Requesting animation frame');
	      requestAnimationFrame(func);
	    } else {
	      func();
	    }
	  }

	  function trigger(calleeMsg, msg, iframe, id, noResponseWarning) {
	    function postMessageToIFrame() {
	      var target = settings[id] && settings[id].targetOrigin;
	      log(id,'[' + calleeMsg + '] Sending msg to iframe['+id+'] ('+msg+') targetOrigin: '+target);
	      iframe.contentWindow.postMessage( msgId + msg, target );
	    }

	    function iFrameNotFound() {
	      warn(id,'[' + calleeMsg + '] IFrame('+id+') not found');
	    }

	    function chkAndSend() {
	      if(iframe && 'contentWindow' in iframe && (null !== iframe.contentWindow)) { //Null test for PhantomJS
	        postMessageToIFrame();
	      } else {
	        iFrameNotFound();
	      }
	    }

	    function warnOnNoResponse() {
	      function warning() {
	        if (settings[id] && !settings[id].loaded && !errorShown) {
	          errorShown = true;
	          warn(id, 'IFrame has not responded within '+ settings[id].warningTimeout/1000 +' seconds. Check iFrameResizer.contentWindow.js has been loaded in iFrame. This message can be ingored if everything is working, or you can set the warningTimeout option to a higher value or zero to suppress this warning.');
	        }
	      }

	      if (!!noResponseWarning && settings[id] && !!settings[id].warningTimeout) {
	        settings[id].msgTimeout = setTimeout(warning, settings[id].warningTimeout);
	      }
	    }

	    var errorShown = false;

	    id = id || iframe.id;

	    if(settings[id]) {
	      chkAndSend();
	      warnOnNoResponse();
	    }

	  }

	  function createOutgoingMsg(iframeId) {
	    return iframeId +
	      ':' + settings[iframeId].bodyMarginV1 +
	      ':' + settings[iframeId].sizeWidth +
	      ':' + settings[iframeId].log +
	      ':' + settings[iframeId].interval +
	      ':' + settings[iframeId].enablePublicMethods +
	      ':' + settings[iframeId].autoResize +
	      ':' + settings[iframeId].bodyMargin +
	      ':' + settings[iframeId].heightCalculationMethod +
	      ':' + settings[iframeId].bodyBackground +
	      ':' + settings[iframeId].bodyPadding +
	      ':' + settings[iframeId].tolerance +
	      ':' + settings[iframeId].inPageLinks +
	      ':' + settings[iframeId].resizeFrom +
	      ':' + settings[iframeId].widthCalculationMethod;
	  }

	  function setupIFrame(iframe,options) {
	    function setLimits() {
	      function addStyle(style) {
	        if ((Infinity !== settings[iframeId][style]) && (0 !== settings[iframeId][style])) {
	          iframe.style[style] = settings[iframeId][style] + 'px';
	          log(iframeId,'Set '+style+' = '+settings[iframeId][style]+'px');
	        }
	      }

	      function chkMinMax(dimension) {
	        if (settings[iframeId]['min'+dimension]>settings[iframeId]['max'+dimension]) {
	          throw new Error('Value for min'+dimension+' can not be greater than max'+dimension);
	        }
	      }

	      chkMinMax('Height');
	      chkMinMax('Width');

	      addStyle('maxHeight');
	      addStyle('minHeight');
	      addStyle('maxWidth');
	      addStyle('minWidth');
	    }

	    function newId() {
	      var id = ((options && options.id) || defaults.id + count++);
	      if  (null !== document.getElementById(id)) {
	        id = id + count++;
	      }
	      return id;
	    }

	    function ensureHasId(iframeId) {
	      logId=iframeId;
	      if (''===iframeId) {
	        iframe.id = iframeId =  newId();
	        logEnabled = (options || {}).log;
	        logId=iframeId;
	        log(iframeId,'Added missing iframe ID: '+ iframeId +' (' + iframe.src + ')');
	      }


	      return iframeId;
	    }

	    function setScrolling() {
	      log(iframeId,'IFrame scrolling ' + (settings[iframeId] && settings[iframeId].scrolling ? 'enabled' : 'disabled') + ' for ' + iframeId);
	      iframe.style.overflow = false === (settings[iframeId] && settings[iframeId].scrolling) ? 'hidden' : 'auto';
	      switch(settings[iframeId] && settings[iframeId].scrolling) {
	        case true:
	          iframe.scrolling = 'yes';
	          break;
	        case false:
	          iframe.scrolling = 'no';
	          break;
	        default:
	          iframe.scrolling = settings[iframeId] ? settings[iframeId].scrolling : 'no';
	      }
	    }

	    //The V1 iFrame script expects an int, where as in V2 expects a CSS
	    //string value such as '1px 3em', so if we have an int for V2, set V1=V2
	    //and then convert V2 to a string PX value.
	    function setupBodyMarginValues() {
	      if (('number'===typeof(settings[iframeId] && settings[iframeId].bodyMargin)) || ('0'===(settings[iframeId] && settings[iframeId].bodyMargin))) {
	        settings[iframeId].bodyMarginV1 = settings[iframeId].bodyMargin;
	        settings[iframeId].bodyMargin   = '' + settings[iframeId].bodyMargin + 'px';
	      }
	    }

	    function checkReset() {
	      // Reduce scope of firstRun to function, because IE8's JS execution
	      // context stack is borked and this value gets externally
	      // changed midway through running this function!!!
	      var
	        firstRun           = settings[iframeId] && settings[iframeId].firstRun,
	        resetRequertMethod = settings[iframeId] && settings[iframeId].heightCalculationMethod in resetRequiredMethods;

	      if (!firstRun && resetRequertMethod) {
	        resetIFrame({iframe:iframe, height:0, width:0, type:'init'});
	      }
	    }

	    function setupIFrameObject() {
	      if(Function.prototype.bind && settings[iframeId]) { //Ignore unpolyfilled IE8.
	        settings[iframeId].iframe.iFrameResizer = {

	          close        : closeIFrame.bind(null,settings[iframeId].iframe),

	          resize       : trigger.bind(null,'Window resize', 'resize', settings[iframeId].iframe),

	          moveToAnchor : function(anchor) {
	            trigger('Move to anchor','moveToAnchor:'+anchor, settings[iframeId].iframe,iframeId);
	          },

	          sendMessage  : function(message) {
	            message = JSON.stringify(message);
	            trigger('Send Message','message:'+message, settings[iframeId].iframe, iframeId);
	          }
	        };
	      }
	    }

	    //We have to call trigger twice, as we can not be sure if all
	    //iframes have completed loading when this code runs. The
	    //event listener also catches the page changing in the iFrame.
	    function init(msg) {
	      function iFrameLoaded() {
	        trigger('iFrame.onload', msg, iframe, undefined , true);
	        checkReset();
	      }

	      addEventListener(iframe,'load',iFrameLoaded);
	      trigger('init', msg, iframe, undefined, true);
	    }

	    function checkOptions(options) {
	      if ('object' !== typeof options) {
	        throw new TypeError('Options is not an object');
	      }
	    }

	    function copyOptions(options) {
	      for (var option in defaults) {
	        if (defaults.hasOwnProperty(option)) {
	          settings[iframeId][option] = options.hasOwnProperty(option) ? options[option] : defaults[option];
	        }
	      }
	    }

	    function getTargetOrigin (remoteHost) {
	      return ('' === remoteHost || 'file://' === remoteHost) ? '*' : remoteHost;
	    }

	    function processOptions(options) {
	      options = options || {};
	      settings[iframeId] = {
	        firstRun	: true,
	        iframe		: iframe,
	        remoteHost	: iframe.src.split('/').slice(0,3).join('/')
	      };

	      checkOptions(options);
	      copyOptions(options);

	      if (settings[iframeId]) {
	        settings[iframeId].targetOrigin = true === settings[iframeId].checkOrigin ? getTargetOrigin(settings[iframeId].remoteHost) : '*';
	      }
	    }

	    function beenHere() {
	      return (iframeId in settings && 'iFrameResizer' in iframe);
	    }

	    var iframeId = ensureHasId(iframe.id);

	    if (!beenHere()) {
	      processOptions(options);
	      setScrolling();
	      setLimits();
	      setupBodyMarginValues();
	      init(createOutgoingMsg(iframeId));
	      setupIFrameObject();
	    } else {
	      warn(iframeId,'Ignored iFrame, already setup.');
	    }
	  }

	  function debouce(fn,time) {
	    if (null === timer) {
	      timer = setTimeout(function() {
	        timer = null;
	        fn();
	      }, time);
	    }
	  }

	  /* istanbul ignore next */  //Not testable in PhantomJS
	  function fixHiddenIFrames() {
	    function checkIFrames() {
	      function checkIFrame(settingId) {
	        function chkDimension(dimension) {
	          return '0px' === (settings[settingId] && settings[settingId].iframe.style[dimension]);
	        }

	        function isVisible(el) {
	          return (null !== el.offsetParent);
	        }

	        if (settings[settingId] && isVisible(settings[settingId].iframe) && (chkDimension('height') || chkDimension('width'))) {
	          trigger('Visibility change', 'resize', settings[settingId].iframe, settingId);
	        }
	      }

	      for (var settingId in settings) {
	        checkIFrame(settingId);
	      }
	    }

	    function mutationObserved(mutations) {
	      log('window','Mutation observed: ' + mutations[0].target + ' ' + mutations[0].type);
	      debouce(checkIFrames,16);
	    }

	    function createMutationObserver() {
	      var
	        target = document.querySelector('body'),

	        config = {
	          attributes            : true,
	          attributeOldValue     : false,
	          characterData         : true,
	          characterDataOldValue : false,
	          childList             : true,
	          subtree               : true
	        },

	        observer = new MutationObserver(mutationObserved);

	      observer.observe(target, config);
	    }

	    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

	    if (MutationObserver) createMutationObserver();
	  }


	  function resizeIFrames(event) {
	    function resize() {
	      sendTriggerMsg('Window '+event,'resize');
	    }

	    log('window','Trigger event: '+event);
	    debouce(resize,16);
	  }

	  /* istanbul ignore next */  //Not testable in PhantomJS
	  function tabVisible() {
	    function resize() {
	      sendTriggerMsg('Tab Visable','resize');
	    }

	    if('hidden' !== document.visibilityState) {
	      log('document','Trigger event: Visiblity change');
	      debouce(resize,16);
	    }
	  }

	  function sendTriggerMsg(eventName,event) {
	    function isIFrameResizeEnabled(iframeId) {
	      return	settings[iframeId] &&
	          'parent' === settings[iframeId].resizeFrom &&
	          settings[iframeId].autoResize &&
	          !settings[iframeId].firstRun;
	    }

	    for (var iframeId in settings) {
	      if(isIFrameResizeEnabled(iframeId)) {
	        trigger(eventName, event, document.getElementById(iframeId), iframeId);
	      }
	    }
	  }

	  function setupEventListeners() {
	    addEventListener(window,'message',iFrameListener);

	    addEventListener(window,'resize', function() {resizeIFrames('resize');});

	    addEventListener(document,'visibilitychange',tabVisible);
	    addEventListener(document,'-webkit-visibilitychange',tabVisible); //Andriod 4.4
	    addEventListener(window,'focusin',function() {resizeIFrames('focus');}); //IE8-9
	    addEventListener(window,'focus',function() {resizeIFrames('focus');});
	  }


	  function factory() {
	    function init(options,element) {
	      function chkType() {
	        if(!element.tagName) {
	          throw new TypeError('Object is not a valid DOM element');
	        } else if ('IFRAME' !== element.tagName.toUpperCase()) {
	          throw new TypeError('Expected <IFRAME> tag, found <'+element.tagName+'>');
	        }
	      }

	      if(element) {
	        chkType();
	        setupIFrame(element, options);
	        iFrames.push(element);
	      }
	    }

	    function warnDeprecatedOptions(options) {
	      if (options && options.enablePublicMethods) {
	        warn('enablePublicMethods option has been removed, public methods are now always available in the iFrame');
	      }
	    }

	    var iFrames;

	    setupRequestAnimationFrame();
	    setupEventListeners();

	    return function iFrameResizeF(options,target) {
	      iFrames = []; //Only return iFrames past in on this call

	      warnDeprecatedOptions(options);

	      switch (typeof(target)) {
	      case 'undefined':
	      case 'string':
	        Array.prototype.forEach.call(
	          document.querySelectorAll( target || 'iframe' ),
	          init.bind(undefined, options)
	        );
	        break;
	      case 'object':
	        init(options,target);
	        break;
	      default:
	        throw new TypeError('Unexpected data type ('+typeof(target)+')');
	      }

	      return iFrames;
	    };
	  }

	  function createJQueryPublicMethod($) {
	    if (!$.fn) {
	      info('','Unable to bind to jQuery, it is not fully loaded.');
	    } else if (!$.fn.iFrameResize) {
	      $.fn.iFrameResize = function $iFrameResizeF(options) {
	        function init(index, element) {
	          setupIFrame(element, options);
	        }

	        return this.filter('iframe').each(init).end();
	      };
	    }
	  }

	  if (window.jQuery) { createJQueryPublicMethod(window.jQuery); }

	  if (typeof undefined === 'function' && undefined.amd) {
	    undefined([],factory);
	  } else { //Node for browserfy
	    module.exports = factory();
	  }

	})();
	});

	var iframeResizer_contentWindow = createCommonjsModule(function (module) {
	(function(undefined) {

	  if(typeof window === 'undefined') return; // don't run for server side render

	  var 
	    autoResize            = true,
	    base                  = 10,
	    bodyBackground        = '',
	    bodyMargin            = 0,
	    bodyMarginStr         = '',
	    bodyObserver          = null,
	    bodyPadding           = '',
	    calculateWidth        = false,
	    doubleEventList       = {'resize':1,'click':1},
	    eventCancelTimer      = 128,
	    firstRun              = true,
	    height                = 1,
	    heightCalcModeDefault = 'bodyOffset',
	    heightCalcMode        = heightCalcModeDefault,
	    initLock              = true,
	    initMsg               = '',
	    inPageLinks           = {},
	    interval              = 32,
	    intervalTimer         = null,
	    logging               = false,
	    msgID                 = '[iFrameSizer]',  //Must match host page msg ID
	    msgIdLen              = msgID.length,
	    myID                  = '',
	    resetRequiredMethods  = {max:1,min:1,bodyScroll:1,documentElementScroll:1},
	    resizeFrom            = 'child',
	    sendPermit            = true,
	    target                = window.parent,
	    targetOriginDefault   = '*',
	    tolerance             = 0,
	    triggerLocked         = false,
	    triggerLockedTimer    = null,
	    throttledTimer        = 16,
	    width                 = 1,
	    widthCalcModeDefault  = 'scroll',
	    widthCalcMode         = widthCalcModeDefault,
	    win                   = window,
	    messageCallback       = function() { warn('MessageCallback function not defined'); },
	    readyCallback         = function() {},
	    pageInfoCallback      = function() {},
	    customCalcMethods     = {
	      height: function() {
	        warn('Custom height calculation function not defined');
	        return document.documentElement.offsetHeight;
	      },
	      width: function() {
	        warn('Custom width calculation function not defined');
	        return document.body.scrollWidth;
	      }
	    },
	    eventHandlersByName   = {};


	  function addEventListener(el,evt,func) {
	    /* istanbul ignore else */ // Not testable in phantonJS
	    if ('addEventListener' in window) {
	      el.addEventListener(evt,func, false);
	    } else if ('attachEvent' in window) { //IE
	      el.attachEvent('on'+evt,func);
	    }
	  }

	  function removeEventListener(el,evt,func) {
	    /* istanbul ignore else */ // Not testable in phantonJS
	    if ('removeEventListener' in window) {
	      el.removeEventListener(evt,func, false);
	    } else if ('detachEvent' in window) { //IE
	      el.detachEvent('on'+evt,func);
	    }
	  }

	  function capitalizeFirstLetter(string) {
	    return string.charAt(0).toUpperCase() + string.slice(1);
	  }

	  //Based on underscore.js
	  function throttle(func) {
	    var
	      context, args, result,
	      timeout = null,
	      previous = 0,
	      later = function() {
	        previous = getNow();
	        timeout = null;
	        result = func.apply(context, args);
	        if (!timeout) {
	          context = args = null;
	        }
	      };

	    return function() {
	      var now = getNow();

	      if (!previous) {
	        previous = now;
	      }

	      var remaining = throttledTimer - (now - previous);

	      context = this;
	      args = arguments;

	      if (remaining <= 0 || remaining > throttledTimer) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }

	        previous = now;
	        result = func.apply(context, args);

	        if (!timeout) {
	          context = args = null;
	        }

	      } else if (!timeout) {
	        timeout = setTimeout(later, remaining);
	      }

	      return result;
	    };
	  }

	  var getNow = Date.now || function() {
	    /* istanbul ignore next */ // Not testable in PhantonJS
	    return new Date().getTime();
	  };

	  function formatLogMsg(msg) {
	    return msgID + '[' + myID + ']' + ' ' + msg;
	  }

	  function log(msg) {
	    if (logging && ('object' === typeof window.console)) {
	      console.log(formatLogMsg(msg));
	    }
	  }

	  function warn(msg) {
	    if ('object' === typeof window.console) {
	      console.warn(formatLogMsg(msg));
	    }
	  }


	  function init() {
	    readDataFromParent();
	    log('Initialising iFrame ('+location.href+')');
	    readDataFromPage();
	    setMargin();
	    setBodyStyle('background',bodyBackground);
	    setBodyStyle('padding',bodyPadding);
	    injectClearFixIntoBodyElement();
	    checkHeightMode();
	    checkWidthMode();
	    stopInfiniteResizingOfIFrame();
	    setupPublicMethods();
	    startEventListeners();
	    inPageLinks = setupInPageLinks();
	    sendSize('init','Init message from host page');
	    readyCallback();
	  }

	  function readDataFromParent() {

	    function strBool(str) {
	      return 'true' === str ? true : false;
	    }

	    var data = initMsg.substr(msgIdLen).split(':');

	    myID               = data[0];
	    bodyMargin         = (undefined !== data[1]) ? Number(data[1])   : bodyMargin; //For V1 compatibility
	    calculateWidth     = (undefined !== data[2]) ? strBool(data[2])  : calculateWidth;
	    logging            = (undefined !== data[3]) ? strBool(data[3])  : logging;
	    interval           = (undefined !== data[4]) ? Number(data[4])   : interval;
	    autoResize         = (undefined !== data[6]) ? strBool(data[6])  : autoResize;
	    bodyMarginStr      = data[7];
	    heightCalcMode     = (undefined !== data[8]) ? data[8]           : heightCalcMode;
	    bodyBackground     = data[9];
	    bodyPadding        = data[10];
	    tolerance          = (undefined !== data[11]) ? Number(data[11]) : tolerance;
	    inPageLinks.enable = (undefined !== data[12]) ? strBool(data[12]): false;
	    resizeFrom         = (undefined !== data[13]) ? data[13]         : resizeFrom;
	    widthCalcMode      = (undefined !== data[14]) ? data[14]         : widthCalcMode;
	  }

	  function readDataFromPage() {
	    function readData() {
	      var data = window.iFrameResizer;

	      log('Reading data from page: ' + JSON.stringify(data));

	      messageCallback     = ('messageCallback'         in data) ? data.messageCallback         : messageCallback;
	      readyCallback       = ('readyCallback'           in data) ? data.readyCallback           : readyCallback;
	      targetOriginDefault = ('targetOrigin'            in data) ? data.targetOrigin            : targetOriginDefault;
	      heightCalcMode      = ('heightCalculationMethod' in data) ? data.heightCalculationMethod : heightCalcMode;
	      widthCalcMode       = ('widthCalculationMethod'  in data) ? data.widthCalculationMethod  : widthCalcMode;
	    }

	    function setupCustomCalcMethods(calcMode, calcFunc) {
	      if ('function' === typeof calcMode) {
	        log('Setup custom ' + calcFunc + 'CalcMethod');
	        customCalcMethods[calcFunc] = calcMode;
	        calcMode = 'custom';
	      }

	      return calcMode;
	    }

	    if(('iFrameResizer' in window) && (Object === window.iFrameResizer.constructor)) {
	      readData();
	      heightCalcMode = setupCustomCalcMethods(heightCalcMode, 'height');
	      widthCalcMode  = setupCustomCalcMethods(widthCalcMode,  'width');
	    }

	    log('TargetOrigin for parent set to: ' + targetOriginDefault);
	  }


	  function chkCSS(attr,value) {
	    if (-1 !== value.indexOf('-')) {
	      warn('Negative CSS value ignored for '+attr);
	      value='';
	    }
	    return value;
	  }

	  function setBodyStyle(attr,value) {
	    if ((undefined !== value) && ('' !== value) && ('null' !== value)) {
	      document.body.style[attr] = value;
	      log('Body '+attr+' set to "'+value+'"');
	    }
	  }

	  function setMargin() {
	    //If called via V1 script, convert bodyMargin from int to str
	    if (undefined === bodyMarginStr) {
	      bodyMarginStr = bodyMargin+'px';
	    }

	    setBodyStyle('margin',chkCSS('margin',bodyMarginStr));
	  }

	  function stopInfiniteResizingOfIFrame() {
	    document.documentElement.style.height = '';
	    document.body.style.height = '';
	    log('HTML & body height set to "auto"');
	  }


	  function manageTriggerEvent(options) {

	    var listener = {
	      add:    function(eventName) {
	        function handleEvent() {
	          sendSize(options.eventName,options.eventType);
	        }

	        eventHandlersByName[eventName] = handleEvent;

	        addEventListener(window,eventName,handleEvent);
	      },
	      remove: function(eventName) {
	        var handleEvent = eventHandlersByName[eventName];
	        delete eventHandlersByName[eventName];

	        removeEventListener(window,eventName,handleEvent);
	      }
	    };

	    if(options.eventNames && Array.prototype.map) {
	      options.eventName = options.eventNames[0];
	      options.eventNames.map(listener[options.method]);
	    } else {
	      listener[options.method](options.eventName);
	    }

	    log(capitalizeFirstLetter(options.method) + ' event listener: ' + options.eventType);
	  }

	  function manageEventListeners(method) {
	    manageTriggerEvent({method:method, eventType: 'Animation Start',           eventNames: ['animationstart','webkitAnimationStart'] });
	    manageTriggerEvent({method:method, eventType: 'Animation Iteration',       eventNames: ['animationiteration','webkitAnimationIteration'] });
	    manageTriggerEvent({method:method, eventType: 'Animation End',             eventNames: ['animationend','webkitAnimationEnd'] });
	    manageTriggerEvent({method:method, eventType: 'Input',                     eventName:  'input' });
	    manageTriggerEvent({method:method, eventType: 'Mouse Up',                  eventName:  'mouseup' });
	    manageTriggerEvent({method:method, eventType: 'Mouse Down',                eventName:  'mousedown' });
	    manageTriggerEvent({method:method, eventType: 'Orientation Change',        eventName:  'orientationchange' });
	    manageTriggerEvent({method:method, eventType: 'Print',                     eventName:  ['afterprint', 'beforeprint'] });
	    manageTriggerEvent({method:method, eventType: 'Ready State Change',        eventName:  'readystatechange' });
	    manageTriggerEvent({method:method, eventType: 'Touch Start',               eventName:  'touchstart' });
	    manageTriggerEvent({method:method, eventType: 'Touch End',                 eventName:  'touchend' });
	    manageTriggerEvent({method:method, eventType: 'Touch Cancel',              eventName:  'touchcancel' });
	    manageTriggerEvent({method:method, eventType: 'Transition Start',          eventNames: ['transitionstart','webkitTransitionStart','MSTransitionStart','oTransitionStart','otransitionstart'] });
	    manageTriggerEvent({method:method, eventType: 'Transition Iteration',      eventNames: ['transitioniteration','webkitTransitionIteration','MSTransitionIteration','oTransitionIteration','otransitioniteration'] });
	    manageTriggerEvent({method:method, eventType: 'Transition End',            eventNames: ['transitionend','webkitTransitionEnd','MSTransitionEnd','oTransitionEnd','otransitionend'] });
	    if('child' === resizeFrom) {
	      manageTriggerEvent({method:method, eventType: 'IFrame Resized',        eventName:  'resize' });
	    }
	  }

	  function checkCalcMode(calcMode,calcModeDefault,modes,type) {
	    if (calcModeDefault !== calcMode) {
	      if (!(calcMode in modes)) {
	        warn(calcMode + ' is not a valid option for '+type+'CalculationMethod.');
	        calcMode=calcModeDefault;
	      }
	      log(type+' calculation method set to "'+calcMode+'"');
	    }

	    return calcMode;
	  }

	  function checkHeightMode() {
	    heightCalcMode = checkCalcMode(heightCalcMode,heightCalcModeDefault,getHeight,'height');
	  }

	  function checkWidthMode() {
	    widthCalcMode = checkCalcMode(widthCalcMode,widthCalcModeDefault,getWidth,'width');
	  }

	  function startEventListeners() {
	    if ( true === autoResize ) {
	      manageEventListeners('add');
	      setupMutationObserver();
	    }
	    else {
	      log('Auto Resize disabled');
	    }
	  }

	  function stopMsgsToParent() {
	    log('Disable outgoing messages');
	    sendPermit = false;
	  }

	  function removeMsgListener() {
	    log('Remove event listener: Message');
	    removeEventListener(window, 'message', receiver);
	  }

	  function disconnectMutationObserver() {
	    if (null !== bodyObserver) {
	      /* istanbul ignore next */ // Not testable in PhantonJS
	      bodyObserver.disconnect();
	    }
	  }

	  function stopEventListeners() {
	    manageEventListeners('remove');
	    disconnectMutationObserver();
	    clearInterval(intervalTimer);
	  }

	  function teardown() {
	    stopMsgsToParent();
	    removeMsgListener();
	    if (true === autoResize) stopEventListeners();
	  }

	  function injectClearFixIntoBodyElement() {
	    var clearFix = document.createElement('div');
	    clearFix.style.clear   = 'both';
	    clearFix.style.display = 'block'; //Guard against this having been globally redefined in CSS.
	    document.body.appendChild(clearFix);
	  }

	  function setupInPageLinks() {

	    function getPagePosition () {
	      return {
	        x: (window.pageXOffset !== undefined) ? window.pageXOffset : document.documentElement.scrollLeft,
	        y: (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop
	      };
	    }

	    function getElementPosition(el) {
	      var
	        elPosition   = el.getBoundingClientRect(),
	        pagePosition = getPagePosition();

	      return {
	        x: parseInt(elPosition.left,10) + parseInt(pagePosition.x,10),
	        y: parseInt(elPosition.top,10)  + parseInt(pagePosition.y,10)
	      };
	    }

	    function findTarget(location) {
	      function jumpToTarget(target) {
	        var jumpPosition = getElementPosition(target);

	        log('Moving to in page link (#'+hash+') at x: '+jumpPosition.x+' y: '+jumpPosition.y);
	        sendMsg(jumpPosition.y, jumpPosition.x, 'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
	      }

	      var
	        hash     = location.split('#')[1] || location, //Remove # if present
	        hashData = decodeURIComponent(hash),
	        target   = document.getElementById(hashData) || document.getElementsByName(hashData)[0];

	      if (undefined !== target) {
	        jumpToTarget(target);
	      } else {
	        log('In page link (#' + hash + ') not found in iFrame, so sending to parent');
	        sendMsg(0,0,'inPageLink','#'+hash);
	      }
	    }

	    function checkLocationHash() {
	      if ('' !== location.hash && '#' !== location.hash) {
	        findTarget(location.href);
	      }
	    }

	    function bindAnchors() {
	      function setupLink(el) {
	        function linkClicked(e) {
	          e.preventDefault();

	          /*jshint validthis:true */
	          findTarget(this.getAttribute('href'));
	        }

	        if ('#' !== el.getAttribute('href')) {
	          addEventListener(el,'click',linkClicked);
	        }
	      }

	      Array.prototype.forEach.call( document.querySelectorAll( 'a[href^="#"]' ), setupLink );
	    }

	    function bindLocationHash() {
	      addEventListener(window,'hashchange',checkLocationHash);
	    }

	    function initCheck() { //check if page loaded with location hash after init resize
	      setTimeout(checkLocationHash,eventCancelTimer);
	    }

	    function enableInPageLinks() {
	      /* istanbul ignore else */ // Not testable in phantonJS
	      if(Array.prototype.forEach && document.querySelectorAll) {
	        log('Setting up location.hash handlers');
	        bindAnchors();
	        bindLocationHash();
	        initCheck();
	      } else {
	        warn('In page linking not fully supported in this browser! (See README.md for IE8 workaround)');
	      }
	    }

	    if(inPageLinks.enable) {
	      enableInPageLinks();
	    } else {
	      log('In page linking not enabled');
	    }

	    return {
	      findTarget:findTarget
	    };
	  }

	  function setupPublicMethods() {
	    log('Enable public methods');

	    win.parentIFrame = {

	      autoResize: function autoResizeF(resize) {
	        if (true === resize && false === autoResize) {
	          autoResize=true;
	          startEventListeners();
	          //sendSize('autoResize','Auto Resize enabled');
	        } else if (false === resize && true === autoResize) {
	          autoResize=false;
	          stopEventListeners();
	        }

	        return autoResize;
	      },

	      close: function closeF() {
	        sendMsg(0,0,'close');
	        teardown();
	      },

	      getId: function getIdF() {
	        return myID;
	      },

	      getPageInfo: function getPageInfoF(callback) {
	        if ('function' === typeof callback) {
	          pageInfoCallback = callback;
	          sendMsg(0,0,'pageInfo');
	        } else {
	          pageInfoCallback = function() {};
	          sendMsg(0,0,'pageInfoStop');
	        }
	      },

	      moveToAnchor: function moveToAnchorF(hash) {
	        inPageLinks.findTarget(hash);
	      },

	      reset: function resetF() {
	        resetIFrame('parentIFrame.reset');
	      },

	      scrollTo: function scrollToF(x,y) {
	        sendMsg(y,x,'scrollTo'); // X&Y reversed at sendMsg uses height/width
	      },

	      scrollToOffset: function scrollToF(x,y) {
	        sendMsg(y,x,'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
	      },

	      sendMessage: function sendMessageF(msg,targetOrigin) {
	        sendMsg(0,0,'message',JSON.stringify(msg),targetOrigin);
	      },

	      setHeightCalculationMethod: function setHeightCalculationMethodF(heightCalculationMethod) {
	        heightCalcMode = heightCalculationMethod;
	        checkHeightMode();
	      },

	      setWidthCalculationMethod: function setWidthCalculationMethodF(widthCalculationMethod) {
	        widthCalcMode = widthCalculationMethod;
	        checkWidthMode();
	      },

	      setTargetOrigin: function setTargetOriginF(targetOrigin) {
	        log('Set targetOrigin: '+targetOrigin);
	        targetOriginDefault = targetOrigin;
	      },

	      size: function sizeF(customHeight, customWidth) {
	        var valString = ''+(customHeight?customHeight:'')+(customWidth?','+customWidth:'');
	        //lockTrigger();
	        sendSize('size','parentIFrame.size('+valString+')', customHeight, customWidth);
	      }
	    };
	  }

	  function initInterval() {
	    if ( 0 !== interval ) {
	      log('setInterval: '+interval+'ms');
	      intervalTimer = setInterval(function() {
	        sendSize('interval','setInterval: '+interval);
	      },Math.abs(interval));
	    }
	  }

	  /* istanbul ignore next */  //Not testable in PhantomJS
	  function setupBodyMutationObserver() {
	    function addImageLoadListners(mutation) {
	      function addImageLoadListener(element) {
	        if (false === element.complete) {
	          log('Attach listeners to ' + element.src);
	          element.addEventListener('load', imageLoaded, false);
	          element.addEventListener('error', imageError, false);
	          elements.push(element);
	        }
	      }

	      if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
	        addImageLoadListener(mutation.target);
	      } else if (mutation.type === 'childList') {
	        Array.prototype.forEach.call(
	          mutation.target.querySelectorAll('img'),
	          addImageLoadListener
	        );
	      }
	    }

	    function removeFromArray(element) {
	      elements.splice(elements.indexOf(element),1);
	    }

	    function removeImageLoadListener(element) {
	      log('Remove listeners from ' + element.src);
	      element.removeEventListener('load', imageLoaded, false);
	      element.removeEventListener('error', imageError, false);
	      removeFromArray(element);
	    }

	    function imageEventTriggered(event,type,typeDesc) {
	      removeImageLoadListener(event.target);
	      sendSize(type, typeDesc + ': ' + event.target.src, undefined, undefined);
	    }

	    function imageLoaded(event) {
	      imageEventTriggered(event,'imageLoad','Image loaded');
	    }

	    function imageError(event) {
	      imageEventTriggered(event,'imageLoadFailed','Image load failed');
	    }

	    function mutationObserved(mutations) {
	      sendSize('mutationObserver','mutationObserver: ' + mutations[0].target + ' ' + mutations[0].type);

	      //Deal with WebKit asyncing image loading when tags are injected into the page
	      mutations.forEach(addImageLoadListners);
	    }

	    function createMutationObserver() {
	      var
	        target = document.querySelector('body'),

	        config = {
	          attributes            : true,
	          attributeOldValue     : false,
	          characterData         : true,
	          characterDataOldValue : false,
	          childList             : true,
	          subtree               : true
	        };

	      observer = new MutationObserver(mutationObserved);

	      log('Create body MutationObserver');
	      observer.observe(target, config);

	      return observer;
	    }

	    var
	      elements         = [],
	      MutationObserver = window.MutationObserver || window.WebKitMutationObserver,
	      observer         = createMutationObserver();

	    return {
	      disconnect: function () {
	        if ('disconnect' in observer) {
	          log('Disconnect body MutationObserver');
	          observer.disconnect();
	          elements.forEach(removeImageLoadListener);
	        }
	      }
	    };
	  }

	  function setupMutationObserver() {
	    var	forceIntervalTimer = 0 > interval;

	    /* istanbul ignore if */ // Not testable in PhantomJS
	    if (window.MutationObserver || window.WebKitMutationObserver) {
	      if (forceIntervalTimer) {
	        initInterval();
	      } else {
	        bodyObserver = setupBodyMutationObserver();
	      }
	    } else {
	      log('MutationObserver not supported in this browser!');
	      initInterval();
	    }
	  }


	  // document.documentElement.offsetHeight is not reliable, so
	  // we have to jump through hoops to get a better value.
	  function getComputedStyle(prop,el) {
	    /* istanbul ignore next */  //Not testable in PhantomJS
	    function convertUnitsToPxForIE8(value) {
	      var PIXEL = /^\d+(px)?$/i;

	      if (PIXEL.test(value)) {
	        return parseInt(value,base);
	      }

	      var
	        style = el.style.left,
	        runtimeStyle = el.runtimeStyle.left;

	      el.runtimeStyle.left = el.currentStyle.left;
	      el.style.left = value || 0;
	      value = el.style.pixelLeft;
	      el.style.left = style;
	      el.runtimeStyle.left = runtimeStyle;

	      return value;
	    }

	    var retVal = 0;
	    el =  el || document.body;

	    /* istanbul ignore else */ // Not testable in phantonJS
	    if (('defaultView' in document) && ('getComputedStyle' in document.defaultView)) {
	      retVal = document.defaultView.getComputedStyle(el, null);
	      retVal = (null !== retVal) ? retVal[prop] : 0;
	    } else {//IE8
	      retVal =  convertUnitsToPxForIE8(el.currentStyle[prop]);
	    }

	    return parseInt(retVal,base);
	  }

	  function chkEventThottle(timer) {
	    if(timer > throttledTimer/2) {
	      throttledTimer = 2*timer;
	      log('Event throttle increased to ' + throttledTimer + 'ms');
	    }
	  }

	  //Idea from https://github.com/guardian/iframe-messenger
	  function getMaxElement(side,elements) {
	    var
	      elementsLength = elements.length,
	      elVal          = 0,
	      maxVal         = 0,
	      Side           = capitalizeFirstLetter(side),
	      timer          = getNow();

	    for (var i = 0; i < elementsLength; i++) {
	      elVal = elements[i].getBoundingClientRect()[side] + getComputedStyle('margin'+Side,elements[i]);
	      if (elVal > maxVal) {
	        maxVal = elVal;
	      }
	    }

	    timer = getNow() - timer;

	    log('Parsed '+elementsLength+' HTML elements');
	    log('Element position calculated in ' + timer + 'ms');

	    chkEventThottle(timer);

	    return maxVal;
	  }

	  function getAllMeasurements(dimention) {
	    return [
	      dimention.bodyOffset(),
	      dimention.bodyScroll(),
	      dimention.documentElementOffset(),
	      dimention.documentElementScroll()
	    ];
	  }

	  function getTaggedElements(side,tag) {
	    function noTaggedElementsFound() {
	      warn('No tagged elements ('+tag+') found on page');
	      return document.querySelectorAll('body *');
	    }

	    var elements = document.querySelectorAll('['+tag+']');

	    if (0 === elements.length) noTaggedElementsFound();

	    return getMaxElement(side,elements);
	  }

	  function getAllElements() {
	    return document.querySelectorAll('body *');
	  }

	  var
	    getHeight = {
	      bodyOffset: function getBodyOffsetHeight() {
	        return  document.body.offsetHeight + getComputedStyle('marginTop') + getComputedStyle('marginBottom');
	      },

	      offset: function() {
	        return getHeight.bodyOffset(); //Backwards compatability
	      },

	      bodyScroll: function getBodyScrollHeight() {
	        return document.body.scrollHeight;
	      },

	      custom: function getCustomWidth() {
	        return customCalcMethods.height();
	      },

	      documentElementOffset: function getDEOffsetHeight() {
	        return document.documentElement.offsetHeight;
	      },

	      documentElementScroll: function getDEScrollHeight() {
	        return document.documentElement.scrollHeight;
	      },

	      max: function getMaxHeight() {
	        return Math.max.apply(null,getAllMeasurements(getHeight));
	      },

	      min: function getMinHeight() {
	        return Math.min.apply(null,getAllMeasurements(getHeight));
	      },

	      grow: function growHeight() {
	        return getHeight.max(); //Run max without the forced downsizing
	      },

	      lowestElement: function getBestHeight() {
	        return Math.max(getHeight.bodyOffset(), getMaxElement('bottom',getAllElements()));
	      },

	      taggedElement: function getTaggedElementsHeight() {
	        return getTaggedElements('bottom','data-iframe-height');
	      }
	    },

	    getWidth = {
	      bodyScroll: function getBodyScrollWidth() {
	        return document.body.scrollWidth;
	      },

	      bodyOffset: function getBodyOffsetWidth() {
	        return document.body.offsetWidth;
	      },

	      custom: function getCustomWidth() {
	        return customCalcMethods.width();
	      },

	      documentElementScroll: function getDEScrollWidth() {
	        return document.documentElement.scrollWidth;
	      },

	      documentElementOffset: function getDEOffsetWidth() {
	        return document.documentElement.offsetWidth;
	      },

	      scroll: function getMaxWidth() {
	        return Math.max(getWidth.bodyScroll(), getWidth.documentElementScroll());
	      },

	      max: function getMaxWidth() {
	        return Math.max.apply(null,getAllMeasurements(getWidth));
	      },

	      min: function getMinWidth() {
	        return Math.min.apply(null,getAllMeasurements(getWidth));
	      },

	      rightMostElement: function rightMostElement() {
	        return getMaxElement('right', getAllElements());
	      },

	      taggedElement: function getTaggedElementsWidth() {
	        return getTaggedElements('right', 'data-iframe-width');
	      }
	    };


	  function sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth) {

	    function resizeIFrame() {
	      height = currentHeight;
	      width  = currentWidth;

	      sendMsg(height,width,triggerEvent);
	    }

	    function isSizeChangeDetected() {
	      function checkTolarance(a,b) {
	        var retVal = Math.abs(a-b) <= tolerance;
	        return !retVal;
	      }

	      currentHeight = (undefined !== customHeight)  ? customHeight : getHeight[heightCalcMode]();
	      currentWidth  = (undefined !== customWidth )  ? customWidth  : getWidth[widthCalcMode]();

	      return	checkTolarance(height,currentHeight) || (calculateWidth && checkTolarance(width,currentWidth));
	    }

	    function isForceResizableEvent() {
	      return !(triggerEvent in {'init':1,'interval':1,'size':1});
	    }

	    function isForceResizableCalcMode() {
	      return (heightCalcMode in resetRequiredMethods) || (calculateWidth && widthCalcMode in resetRequiredMethods);
	    }

	    function logIgnored() {
	      log('No change in size detected');
	    }

	    function checkDownSizing() {
	      if (isForceResizableEvent() && isForceResizableCalcMode()) {
	        resetIFrame(triggerEventDesc);
	      } else if (!(triggerEvent in {'interval':1})) {
	        logIgnored();
	      }
	    }

	    var	currentHeight,currentWidth;

	    if (isSizeChangeDetected() || 'init' === triggerEvent) {
	      lockTrigger();
	      resizeIFrame();
	    } else {
	      checkDownSizing();
	    }
	  }

	  var sizeIFrameThrottled = throttle(sizeIFrame);

	  function sendSize(triggerEvent, triggerEventDesc, customHeight, customWidth) {
	    function recordTrigger() {
	      if (!(triggerEvent in {'reset':1,'resetPage':1,'init':1})) {
	        log( 'Trigger event: ' + triggerEventDesc );
	      }
	    }

	    function isDoubleFiredEvent() {
	      return  triggerLocked && (triggerEvent in doubleEventList);
	    }

	    if (!isDoubleFiredEvent()) {
	      recordTrigger();
	      if (triggerEvent === 'init') {
	        sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth);
	      } else {
	        sizeIFrameThrottled(triggerEvent, triggerEventDesc, customHeight, customWidth);
	      }
	    } else {
	      log('Trigger event cancelled: '+triggerEvent);
	    }
	  }

	  function lockTrigger() {
	    if (!triggerLocked) {
	      triggerLocked = true;
	      log('Trigger event lock on');
	    }
	    clearTimeout(triggerLockedTimer);
	    triggerLockedTimer = setTimeout(function() {
	      triggerLocked = false;
	      log('Trigger event lock off');
	      log('--');
	    },eventCancelTimer);
	  }

	  function triggerReset(triggerEvent) {
	    height = getHeight[heightCalcMode]();
	    width  = getWidth[widthCalcMode]();

	    sendMsg(height,width,triggerEvent);
	  }

	  function resetIFrame(triggerEventDesc) {
	    var hcm = heightCalcMode;
	    heightCalcMode = heightCalcModeDefault;

	    log('Reset trigger event: ' + triggerEventDesc);
	    lockTrigger();
	    triggerReset('reset');

	    heightCalcMode = hcm;
	  }

	  function sendMsg(height,width,triggerEvent,msg,targetOrigin) {
	    function setTargetOrigin() {
	      if (undefined === targetOrigin) {
	        targetOrigin = targetOriginDefault;
	      } else {
	        log('Message targetOrigin: '+targetOrigin);
	      }
	    }

	    function sendToParent() {
	      var
	        size  = height + ':' + width,
	        message = myID + ':' +  size + ':' + triggerEvent + (undefined !== msg ? ':' + msg : '');

	      log('Sending message to host page (' + message + ')');
	      target.postMessage( msgID + message, targetOrigin);
	    }

	    if(true === sendPermit) {
	      setTargetOrigin();
	      sendToParent();
	    }
	  }

	  function receiver(event) {
	    var processRequestFromParent = {
	      init: function initFromParent() {
	        function fireInit() {
	          initMsg = event.data;
	          target  = event.source;

	          init();
	          firstRun = false;
	          setTimeout(function() { initLock = false;},eventCancelTimer);
	        }

	        if (document.readyState === "interactive" || document.readyState === "complete") {
	          fireInit();
	        } else {
	          log('Waiting for page ready');
	          addEventListener(window,'readystatechange',processRequestFromParent.initFromParent);
	        }
	      },

	      reset: function resetFromParent() {
	        if (!initLock) {
	          log('Page size reset by host page');
	          triggerReset('resetPage');
	        } else {
	          log('Page reset ignored by init');
	        }
	      },

	      resize: function resizeFromParent() {
	        sendSize('resizeParent','Parent window requested size check');
	      },

	      moveToAnchor: function moveToAnchorF() {
	        inPageLinks.findTarget(getData());
	      },
	      inPageLink: function inPageLinkF() {this.moveToAnchor();}, //Backward compatability

	      pageInfo: function pageInfoFromParent() {
	        var msgBody = getData();
	        log('PageInfoFromParent called from parent: ' + msgBody );
	        pageInfoCallback(JSON.parse(msgBody));
	        log(' --');
	      },

	      message: function messageFromParent() {
	        var msgBody = getData();

	        log('MessageCallback called from parent: ' + msgBody );
	        messageCallback(JSON.parse(msgBody));
	        log(' --');
	      }
	    };

	    function isMessageForUs() {
	      return msgID === (''+event.data).substr(0,msgIdLen); //''+ Protects against non-string messages
	    }

	    function getMessageType() {
	      return event.data.split(']')[1].split(':')[0];
	    }

	    function getData() {
	      return event.data.substr(event.data.indexOf(':')+1);
	    }

	    function isMiddleTier() {
	      return !(module.exports) && ('iFrameResize' in window);
	    }

	    function isInitMsg() {
	      //Test if this message is from a child below us. This is an ugly test, however, updating
	      //the message format would break backwards compatibity.
	      return event.data.split(':')[2] in {'true':1,'false':1};
	    }

	    function callFromParent() {
	      var messageType = getMessageType();

	      if (messageType in processRequestFromParent) {
	        processRequestFromParent[messageType]();
	      } else if (!isMiddleTier() && !isInitMsg()) {
	        warn('Unexpected message ('+event.data+')');
	      }
	    }

	    function processMessage() {
	      if (false === firstRun) {
	        callFromParent();
	      } else if (isInitMsg()) {
	        processRequestFromParent.init();
	      } else {
	        log('Ignored message of type "' + getMessageType() + '". Received before initialization.');
	      }
	    }

	    if (isMessageForUs()) {
	      processMessage();
	    }
	  }

	  //Normally the parent kicks things off when it detects the iFrame has loaded.
	  //If this script is async-loaded, then tell parent page to retry init.
	  function chkLateLoaded() {
	    if('loading' !== document.readyState) {
	      window.parent.postMessage('[iFrameResizerChild]Ready','*');
	    }
	  }

	  addEventListener(window, 'message', receiver);
	  chkLateLoaded();

	  

	})();
	});

	var iframeResizer$1 = iframeResizer;
	var iframeResizerContentWindow = iframeResizer_contentWindow;

	var js = {
		iframeResizer: iframeResizer$1,
		iframeResizerContentWindow: iframeResizerContentWindow
	};

	var iframeResizer$2 = js;

	// The iframe-resizer module seems to export it's methods in an odd way

	function Example ($module) {
	  this.$module = $module;
	}

	Example.prototype.init = function () {
	  var $module = this.$module;
	  if (!$module) {
	    return
	  }
	  this.resize();
	};
	Example.prototype.resize = function () {
	  var $module = this.$module;

	  try {
	    // Example iframe; set the height equal to the body height
	    iframeResizer$2.iframeResizer({ scrolling: 'auto', autoResize: true }, $module);
	  } catch (err) {
	    if (err) {
	      console.error(err.message);
	    }
	  }
	};

	var bind = createCommonjsModule(function (module, exports) {
	(function (global, factory) {
		factory();
	}(commonjsGlobal, (function () {
	(function(undefined) {

	// Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Object/defineProperty/detect.js
	var detect = (
	  // In IE8, defineProperty could only act on DOM elements, so full support
	  // for the feature requires the ability to set a property on an arbitrary object
	  'defineProperty' in Object && (function() {
	  	try {
	  		var a = {};
	  		Object.defineProperty(a, 'test', {value:42});
	  		return true;
	  	} catch(e) {
	  		return false
	  	}
	  }())
	);

	if (detect) return

	// Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Object.defineProperty&flags=always
	(function (nativeDefineProperty) {

		var supportsAccessors = Object.prototype.hasOwnProperty('__defineGetter__');
		var ERR_ACCESSORS_NOT_SUPPORTED = 'Getters & setters cannot be defined on this javascript engine';
		var ERR_VALUE_ACCESSORS = 'A property cannot both have accessors and be writable or have a value';

		Object.defineProperty = function defineProperty(object, property, descriptor) {

			// Where native support exists, assume it
			if (nativeDefineProperty && (object === window || object === document || object === Element.prototype || object instanceof Element)) {
				return nativeDefineProperty(object, property, descriptor);
			}

			if (object === null || !(object instanceof Object || typeof object === 'object')) {
				throw new TypeError('Object.defineProperty called on non-object');
			}

			if (!(descriptor instanceof Object)) {
				throw new TypeError('Property description must be an object');
			}

			var propertyString = String(property);
			var hasValueOrWritable = 'value' in descriptor || 'writable' in descriptor;
			var getterType = 'get' in descriptor && typeof descriptor.get;
			var setterType = 'set' in descriptor && typeof descriptor.set;

			// handle descriptor.get
			if (getterType) {
				if (getterType !== 'function') {
					throw new TypeError('Getter must be a function');
				}
				if (!supportsAccessors) {
					throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
				}
				if (hasValueOrWritable) {
					throw new TypeError(ERR_VALUE_ACCESSORS);
				}
				Object.__defineGetter__.call(object, propertyString, descriptor.get);
			} else {
				object[propertyString] = descriptor.value;
			}

			// handle descriptor.set
			if (setterType) {
				if (setterType !== 'function') {
					throw new TypeError('Setter must be a function');
				}
				if (!supportsAccessors) {
					throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
				}
				if (hasValueOrWritable) {
					throw new TypeError(ERR_VALUE_ACCESSORS);
				}
				Object.__defineSetter__.call(object, propertyString, descriptor.set);
			}

			// OK to define value unconditionally - if a getter has been specified as well, an error would be thrown above
			if ('value' in descriptor) {
				object[propertyString] = descriptor.value;
			}

			return object;
		};
	}(Object.defineProperty));
	})
	.call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof commonjsGlobal && commonjsGlobal || {});

	(function(undefined) {
	  // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Function/prototype/bind/detect.js
	  var detect = 'bind' in Function.prototype;

	  if (detect) return

	  // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Function.prototype.bind&flags=always
	  Object.defineProperty(Function.prototype, 'bind', {
	      value: function bind(that) { // .length is 1
	          // add necessary es5-shim utilities
	          var $Array = Array;
	          var $Object = Object;
	          var ObjectPrototype = $Object.prototype;
	          var ArrayPrototype = $Array.prototype;
	          var Empty = function Empty() {};
	          var to_string = ObjectPrototype.toString;
	          var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	          var isCallable; /* inlined from https://npmjs.com/is-callable */ var fnToStr = Function.prototype.toString, tryFunctionObject = function tryFunctionObject(value) { try { fnToStr.call(value); return true; } catch (e) { return false; } }, fnClass = '[object Function]', genClass = '[object GeneratorFunction]'; isCallable = function isCallable(value) { if (typeof value !== 'function') { return false; } if (hasToStringTag) { return tryFunctionObject(value); } var strClass = to_string.call(value); return strClass === fnClass || strClass === genClass; };
	          var array_slice = ArrayPrototype.slice;
	          var array_concat = ArrayPrototype.concat;
	          var array_push = ArrayPrototype.push;
	          var max = Math.max;
	          // /add necessary es5-shim utilities

	          // 1. Let Target be the this value.
	          var target = this;
	          // 2. If IsCallable(Target) is false, throw a TypeError exception.
	          if (!isCallable(target)) {
	              throw new TypeError('Function.prototype.bind called on incompatible ' + target);
	          }
	          // 3. Let A be a new (possibly empty) internal list of all of the
	          //   argument values provided after thisArg (arg1, arg2 etc), in order.
	          // XXX slicedArgs will stand in for "A" if used
	          var args = array_slice.call(arguments, 1); // for normal call
	          // 4. Let F be a new native ECMAScript object.
	          // 11. Set the [[Prototype]] internal property of F to the standard
	          //   built-in Function prototype object as specified in 15.3.3.1.
	          // 12. Set the [[Call]] internal property of F as described in
	          //   15.3.4.5.1.
	          // 13. Set the [[Construct]] internal property of F as described in
	          //   15.3.4.5.2.
	          // 14. Set the [[HasInstance]] internal property of F as described in
	          //   15.3.4.5.3.
	          var bound;
	          var binder = function () {

	              if (this instanceof bound) {
	                  // 15.3.4.5.2 [[Construct]]
	                  // When the [[Construct]] internal method of a function object,
	                  // F that was created using the bind function is called with a
	                  // list of arguments ExtraArgs, the following steps are taken:
	                  // 1. Let target be the value of F's [[TargetFunction]]
	                  //   internal property.
	                  // 2. If target has no [[Construct]] internal method, a
	                  //   TypeError exception is thrown.
	                  // 3. Let boundArgs be the value of F's [[BoundArgs]] internal
	                  //   property.
	                  // 4. Let args be a new list containing the same values as the
	                  //   list boundArgs in the same order followed by the same
	                  //   values as the list ExtraArgs in the same order.
	                  // 5. Return the result of calling the [[Construct]] internal
	                  //   method of target providing args as the arguments.

	                  var result = target.apply(
	                      this,
	                      array_concat.call(args, array_slice.call(arguments))
	                  );
	                  if ($Object(result) === result) {
	                      return result;
	                  }
	                  return this;

	              } else {
	                  // 15.3.4.5.1 [[Call]]
	                  // When the [[Call]] internal method of a function object, F,
	                  // which was created using the bind function is called with a
	                  // this value and a list of arguments ExtraArgs, the following
	                  // steps are taken:
	                  // 1. Let boundArgs be the value of F's [[BoundArgs]] internal
	                  //   property.
	                  // 2. Let boundThis be the value of F's [[BoundThis]] internal
	                  //   property.
	                  // 3. Let target be the value of F's [[TargetFunction]] internal
	                  //   property.
	                  // 4. Let args be a new list containing the same values as the
	                  //   list boundArgs in the same order followed by the same
	                  //   values as the list ExtraArgs in the same order.
	                  // 5. Return the result of calling the [[Call]] internal method
	                  //   of target providing boundThis as the this value and
	                  //   providing args as the arguments.

	                  // equiv: target.call(this, ...boundArgs, ...args)
	                  return target.apply(
	                      that,
	                      array_concat.call(args, array_slice.call(arguments))
	                  );

	              }

	          };

	          // 15. If the [[Class]] internal property of Target is "Function", then
	          //     a. Let L be the length property of Target minus the length of A.
	          //     b. Set the length own property of F to either 0 or L, whichever is
	          //       larger.
	          // 16. Else set the length own property of F to 0.

	          var boundLength = max(0, target.length - args.length);

	          // 17. Set the attributes of the length own property of F to the values
	          //   specified in 15.3.5.1.
	          var boundArgs = [];
	          for (var i = 0; i < boundLength; i++) {
	              array_push.call(boundArgs, '$' + i);
	          }

	          // XXX Build a dynamic function with desired amount of arguments is the only
	          // way to set the length property of a function.
	          // In environments where Content Security Policies enabled (Chrome extensions,
	          // for ex.) all use of eval or Function costructor throws an exception.
	          // However in all of these environments Function.prototype.bind exists
	          // and so this code will never be executed.
	          bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this, arguments); }')(binder);

	          if (target.prototype) {
	              Empty.prototype = target.prototype;
	              bound.prototype = new Empty();
	              // Clean up dangling references.
	              Empty.prototype = null;
	          }

	          // TODO
	          // 18. Set the [[Extensible]] internal property of F to true.

	          // TODO
	          // 19. Let thrower be the [[ThrowTypeError]] function Object (13.2.3).
	          // 20. Call the [[DefineOwnProperty]] internal method of F with
	          //   arguments "caller", PropertyDescriptor {[[Get]]: thrower, [[Set]]:
	          //   thrower, [[Enumerable]]: false, [[Configurable]]: false}, and
	          //   false.
	          // 21. Call the [[DefineOwnProperty]] internal method of F with
	          //   arguments "arguments", PropertyDescriptor {[[Get]]: thrower,
	          //   [[Set]]: thrower, [[Enumerable]]: false, [[Configurable]]: false},
	          //   and false.

	          // TODO
	          // NOTE Function objects created using Function.prototype.bind do not
	          // have a prototype property or the [[Code]], [[FormalParameters]], and
	          // [[Scope]] internal properties.
	          // XXX can't delete prototype in pure-js.

	          // 22. Return F.
	          return bound;
	      }
	  });
	})
	.call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof commonjsGlobal && commonjsGlobal || {});

	})));
	});

	var classList = createCommonjsModule(function (module, exports) {
	(function (global, factory) {
		factory();
	}(commonjsGlobal, (function () {
	(function(undefined) {

	// Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Object/defineProperty/detect.js
	var detect = (
	  // In IE8, defineProperty could only act on DOM elements, so full support
	  // for the feature requires the ability to set a property on an arbitrary object
	  'defineProperty' in Object && (function() {
	  	try {
	  		var a = {};
	  		Object.defineProperty(a, 'test', {value:42});
	  		return true;
	  	} catch(e) {
	  		return false
	  	}
	  }())
	);

	if (detect) return

	// Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Object.defineProperty&flags=always
	(function (nativeDefineProperty) {

		var supportsAccessors = Object.prototype.hasOwnProperty('__defineGetter__');
		var ERR_ACCESSORS_NOT_SUPPORTED = 'Getters & setters cannot be defined on this javascript engine';
		var ERR_VALUE_ACCESSORS = 'A property cannot both have accessors and be writable or have a value';

		Object.defineProperty = function defineProperty(object, property, descriptor) {

			// Where native support exists, assume it
			if (nativeDefineProperty && (object === window || object === document || object === Element.prototype || object instanceof Element)) {
				return nativeDefineProperty(object, property, descriptor);
			}

			if (object === null || !(object instanceof Object || typeof object === 'object')) {
				throw new TypeError('Object.defineProperty called on non-object');
			}

			if (!(descriptor instanceof Object)) {
				throw new TypeError('Property description must be an object');
			}

			var propertyString = String(property);
			var hasValueOrWritable = 'value' in descriptor || 'writable' in descriptor;
			var getterType = 'get' in descriptor && typeof descriptor.get;
			var setterType = 'set' in descriptor && typeof descriptor.set;

			// handle descriptor.get
			if (getterType) {
				if (getterType !== 'function') {
					throw new TypeError('Getter must be a function');
				}
				if (!supportsAccessors) {
					throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
				}
				if (hasValueOrWritable) {
					throw new TypeError(ERR_VALUE_ACCESSORS);
				}
				Object.__defineGetter__.call(object, propertyString, descriptor.get);
			} else {
				object[propertyString] = descriptor.value;
			}

			// handle descriptor.set
			if (setterType) {
				if (setterType !== 'function') {
					throw new TypeError('Setter must be a function');
				}
				if (!supportsAccessors) {
					throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
				}
				if (hasValueOrWritable) {
					throw new TypeError(ERR_VALUE_ACCESSORS);
				}
				Object.__defineSetter__.call(object, propertyString, descriptor.set);
			}

			// OK to define value unconditionally - if a getter has been specified as well, an error would be thrown above
			if ('value' in descriptor) {
				object[propertyString] = descriptor.value;
			}

			return object;
		};
	}(Object.defineProperty));
	})
	.call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof commonjsGlobal && commonjsGlobal || {});

	(function(undefined) {

	    // Detection from https://raw.githubusercontent.com/Financial-Times/polyfill-service/master/packages/polyfill-library/polyfills/DOMTokenList/detect.js
	    var detect = (
	      'DOMTokenList' in this && (function (x) {
	        return 'classList' in x ? !x.classList.toggle('x', false) && !x.className : true;
	      })(document.createElement('x'))
	    );

	    if (detect) return

	    // Polyfill from https://raw.githubusercontent.com/Financial-Times/polyfill-service/master/packages/polyfill-library/polyfills/DOMTokenList/polyfill.js
	    (function (global) {
	      var nativeImpl = "DOMTokenList" in global && global.DOMTokenList;

	      if (
	          !nativeImpl ||
	          (
	            !!document.createElementNS &&
	            !!document.createElementNS('http://www.w3.org/2000/svg', 'svg') &&
	            !(document.createElementNS("http://www.w3.org/2000/svg", "svg").classList instanceof DOMTokenList)
	          )
	        ) {
	        global.DOMTokenList = (function() { // eslint-disable-line no-unused-vars
	          var dpSupport = true;
	          var defineGetter = function (object, name, fn, configurable) {
	            if (Object.defineProperty)
	              Object.defineProperty(object, name, {
	                configurable: false === dpSupport ? true : !!configurable,
	                get: fn
	              });

	            else object.__defineGetter__(name, fn);
	          };

	          /** Ensure the browser allows Object.defineProperty to be used on native JavaScript objects. */
	          try {
	            defineGetter({}, "support");
	          }
	          catch (e) {
	            dpSupport = false;
	          }


	          var _DOMTokenList = function (el, prop) {
	            var that = this;
	            var tokens = [];
	            var tokenMap = {};
	            var length = 0;
	            var maxLength = 0;
	            var addIndexGetter = function (i) {
	              defineGetter(that, i, function () {
	                preop();
	                return tokens[i];
	              }, false);

	            };
	            var reindex = function () {

	              /** Define getter functions for array-like access to the tokenList's contents. */
	              if (length >= maxLength)
	                for (; maxLength < length; ++maxLength) {
	                  addIndexGetter(maxLength);
	                }
	            };

	            /** Helper function called at the start of each class method. Internal use only. */
	            var preop = function () {
	              var error;
	              var i;
	              var args = arguments;
	              var rSpace = /\s+/;

	              /** Validate the token/s passed to an instance method, if any. */
	              if (args.length)
	                for (i = 0; i < args.length; ++i)
	                  if (rSpace.test(args[i])) {
	                    error = new SyntaxError('String "' + args[i] + '" ' + "contains" + ' an invalid character');
	                    error.code = 5;
	                    error.name = "InvalidCharacterError";
	                    throw error;
	                  }


	              /** Split the new value apart by whitespace*/
	              if (typeof el[prop] === "object") {
	                tokens = ("" + el[prop].baseVal).replace(/^\s+|\s+$/g, "").split(rSpace);
	              } else {
	                tokens = ("" + el[prop]).replace(/^\s+|\s+$/g, "").split(rSpace);
	              }

	              /** Avoid treating blank strings as single-item token lists */
	              if ("" === tokens[0]) tokens = [];

	              /** Repopulate the internal token lists */
	              tokenMap = {};
	              for (i = 0; i < tokens.length; ++i)
	                tokenMap[tokens[i]] = true;
	              length = tokens.length;
	              reindex();
	            };

	            /** Populate our internal token list if the targeted attribute of the subject element isn't empty. */
	            preop();

	            /** Return the number of tokens in the underlying string. Read-only. */
	            defineGetter(that, "length", function () {
	              preop();
	              return length;
	            });

	            /** Override the default toString/toLocaleString methods to return a space-delimited list of tokens when typecast. */
	            that.toLocaleString =
	              that.toString = function () {
	                preop();
	                return tokens.join(" ");
	              };

	            that.item = function (idx) {
	              preop();
	              return tokens[idx];
	            };

	            that.contains = function (token) {
	              preop();
	              return !!tokenMap[token];
	            };

	            that.add = function () {
	              preop.apply(that, args = arguments);

	              for (var args, token, i = 0, l = args.length; i < l; ++i) {
	                token = args[i];
	                if (!tokenMap[token]) {
	                  tokens.push(token);
	                  tokenMap[token] = true;
	                }
	              }

	              /** Update the targeted attribute of the attached element if the token list's changed. */
	              if (length !== tokens.length) {
	                length = tokens.length >>> 0;
	                if (typeof el[prop] === "object") {
	                  el[prop].baseVal = tokens.join(" ");
	                } else {
	                  el[prop] = tokens.join(" ");
	                }
	                reindex();
	              }
	            };

	            that.remove = function () {
	              preop.apply(that, args = arguments);

	              /** Build a hash of token names to compare against when recollecting our token list. */
	              for (var args, ignore = {}, i = 0, t = []; i < args.length; ++i) {
	                ignore[args[i]] = true;
	                delete tokenMap[args[i]];
	              }

	              /** Run through our tokens list and reassign only those that aren't defined in the hash declared above. */
	              for (i = 0; i < tokens.length; ++i)
	                if (!ignore[tokens[i]]) t.push(tokens[i]);

	              tokens = t;
	              length = t.length >>> 0;

	              /** Update the targeted attribute of the attached element. */
	              if (typeof el[prop] === "object") {
	                el[prop].baseVal = tokens.join(" ");
	              } else {
	                el[prop] = tokens.join(" ");
	              }
	              reindex();
	            };

	            that.toggle = function (token, force) {
	              preop.apply(that, [token]);

	              /** Token state's being forced. */
	              if (undefined !== force) {
	                if (force) {
	                  that.add(token);
	                  return true;
	                } else {
	                  that.remove(token);
	                  return false;
	                }
	              }

	              /** Token already exists in tokenList. Remove it, and return FALSE. */
	              if (tokenMap[token]) {
	                that.remove(token);
	                return false;
	              }

	              /** Otherwise, add the token and return TRUE. */
	              that.add(token);
	              return true;
	            };

	            return that;
	          };

	          return _DOMTokenList;
	        }());
	      }

	      // Add second argument to native DOMTokenList.toggle() if necessary
	      (function () {
	        var e = document.createElement('span');
	        if (!('classList' in e)) return;
	        e.classList.toggle('x', false);
	        if (!e.classList.contains('x')) return;
	        e.classList.constructor.prototype.toggle = function toggle(token /*, force*/) {
	          var force = arguments[1];
	          if (force === undefined) {
	            var add = !this.contains(token);
	            this[add ? 'add' : 'remove'](token);
	            return add;
	          }
	          force = !!force;
	          this[force ? 'add' : 'remove'](token);
	          return force;
	        };
	      }());

	      // Add multiple arguments to native DOMTokenList.add() if necessary
	      (function () {
	        var e = document.createElement('span');
	        if (!('classList' in e)) return;
	        e.classList.add('a', 'b');
	        if (e.classList.contains('b')) return;
	        var native = e.classList.constructor.prototype.add;
	        e.classList.constructor.prototype.add = function () {
	          var args = arguments;
	          var l = arguments.length;
	          for (var i = 0; i < l; i++) {
	            native.call(this, args[i]);
	          }
	        };
	      }());

	      // Add multiple arguments to native DOMTokenList.remove() if necessary
	      (function () {
	        var e = document.createElement('span');
	        if (!('classList' in e)) return;
	        e.classList.add('a');
	        e.classList.add('b');
	        e.classList.remove('a', 'b');
	        if (!e.classList.contains('b')) return;
	        var native = e.classList.constructor.prototype.remove;
	        e.classList.constructor.prototype.remove = function () {
	          var args = arguments;
	          var l = arguments.length;
	          for (var i = 0; i < l; i++) {
	            native.call(this, args[i]);
	          }
	        };
	      }());

	    }(this));

	}).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof commonjsGlobal && commonjsGlobal || {});

	(function(undefined) {

	// Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Document/detect.js
	var detect = ("Document" in this);

	if (detect) return

	// Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Document&flags=always
	if ((typeof WorkerGlobalScope === "undefined") && (typeof importScripts !== "function")) {

		if (this.HTMLDocument) { // IE8

			// HTMLDocument is an extension of Document.  If the browser has HTMLDocument but not Document, the former will suffice as an alias for the latter.
			this.Document = this.HTMLDocument;

		} else {

			// Create an empty function to act as the missing constructor for the document object, attach the document object as its prototype.  The function needs to be anonymous else it is hoisted and causes the feature detect to prematurely pass, preventing the assignments below being made.
			this.Document = this.HTMLDocument = document.constructor = (new Function('return function Document() {}')());
			this.Document.prototype = document;
		}
	}


	})
	.call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof commonjsGlobal && commonjsGlobal || {});

	(function(undefined) {

	// Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Element/detect.js
	var detect = ('Element' in this && 'HTMLElement' in this);

	if (detect) return

	// Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Element&flags=always
	(function () {

		// IE8
		if (window.Element && !window.HTMLElement) {
			window.HTMLElement = window.Element;
			return;
		}

		// create Element constructor
		window.Element = window.HTMLElement = new Function('return function Element() {}')();

		// generate sandboxed iframe
		var vbody = document.appendChild(document.createElement('body'));
		var frame = vbody.appendChild(document.createElement('iframe'));

		// use sandboxed iframe to replicate Element functionality
		var frameDocument = frame.contentWindow.document;
		var prototype = Element.prototype = frameDocument.appendChild(frameDocument.createElement('*'));
		var cache = {};

		// polyfill Element.prototype on an element
		var shiv = function (element, deep) {
			var
			childNodes = element.childNodes || [],
			index = -1,
			key, value, childNode;

			if (element.nodeType === 1 && element.constructor !== Element) {
				element.constructor = Element;

				for (key in cache) {
					value = cache[key];
					element[key] = value;
				}
			}

			while (childNode = deep && childNodes[++index]) {
				shiv(childNode, deep);
			}

			return element;
		};

		var elements = document.getElementsByTagName('*');
		var nativeCreateElement = document.createElement;
		var interval;
		var loopLimit = 100;

		prototype.attachEvent('onpropertychange', function (event) {
			var
			propertyName = event.propertyName,
			nonValue = !cache.hasOwnProperty(propertyName),
			newValue = prototype[propertyName],
			oldValue = cache[propertyName],
			index = -1,
			element;

			while (element = elements[++index]) {
				if (element.nodeType === 1) {
					if (nonValue || element[propertyName] === oldValue) {
						element[propertyName] = newValue;
					}
				}
			}

			cache[propertyName] = newValue;
		});

		prototype.constructor = Element;

		if (!prototype.hasAttribute) {
			// <Element>.hasAttribute
			prototype.hasAttribute = function hasAttribute(name) {
				return this.getAttribute(name) !== null;
			};
		}

		// Apply Element prototype to the pre-existing DOM as soon as the body element appears.
		function bodyCheck() {
			if (!(loopLimit--)) clearTimeout(interval);
			if (document.body && !document.body.prototype && /(complete|interactive)/.test(document.readyState)) {
				shiv(document, true);
				if (interval && document.body.prototype) clearTimeout(interval);
				return (!!document.body.prototype);
			}
			return false;
		}
		if (!bodyCheck()) {
			document.onreadystatechange = bodyCheck;
			interval = setInterval(bodyCheck, 25);
		}

		// Apply to any new elements created after load
		document.createElement = function createElement(nodeName) {
			var element = nativeCreateElement(String(nodeName).toLowerCase());
			return shiv(element);
		};

		// remove sandboxed iframe
		document.removeChild(vbody);
	}());

	})
	.call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof commonjsGlobal && commonjsGlobal || {});

	(function(undefined) {

	    // Detection from https://raw.githubusercontent.com/Financial-Times/polyfill-service/8717a9e04ac7aff99b4980fbedead98036b0929a/packages/polyfill-library/polyfills/Element/prototype/classList/detect.js
	    var detect = (
	      'document' in this && "classList" in document.documentElement && 'Element' in this && 'classList' in Element.prototype && (function () {
	        var e = document.createElement('span');
	        e.classList.add('a', 'b');
	        return e.classList.contains('b');
	      }())
	    );

	    if (detect) return

	    // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Element.prototype.classList&flags=always
	    (function (global) {
	      var dpSupport = true;
	      var defineGetter = function (object, name, fn, configurable) {
	        if (Object.defineProperty)
	          Object.defineProperty(object, name, {
	            configurable: false === dpSupport ? true : !!configurable,
	            get: fn
	          });

	        else object.__defineGetter__(name, fn);
	      };
	      /** Ensure the browser allows Object.defineProperty to be used on native JavaScript objects. */
	      try {
	        defineGetter({}, "support");
	      }
	      catch (e) {
	        dpSupport = false;
	      }
	      /** Polyfills a property with a DOMTokenList */
	      var addProp = function (o, name, attr) {

	        defineGetter(o.prototype, name, function () {
	          var tokenList;

	          var THIS = this,

	          /** Prevent this from firing twice for some reason. What the hell, IE. */
	          gibberishProperty = "__defineGetter__" + "DEFINE_PROPERTY" + name;
	          if(THIS[gibberishProperty]) return tokenList;
	          THIS[gibberishProperty] = true;

	          /**
	           * IE8 can't define properties on native JavaScript objects, so we'll use a dumb hack instead.
	           *
	           * What this is doing is creating a dummy element ("reflection") inside a detached phantom node ("mirror")
	           * that serves as the target of Object.defineProperty instead. While we could simply use the subject HTML
	           * element instead, this would conflict with element types which use indexed properties (such as forms and
	           * select lists).
	           */
	          if (false === dpSupport) {

	            var visage;
	            var mirror = addProp.mirror || document.createElement("div");
	            var reflections = mirror.childNodes;
	            var l = reflections.length;

	            for (var i = 0; i < l; ++i)
	              if (reflections[i]._R === THIS) {
	                visage = reflections[i];
	                break;
	              }

	            /** Couldn't find an element's reflection inside the mirror. Materialise one. */
	            visage || (visage = mirror.appendChild(document.createElement("div")));

	            tokenList = DOMTokenList.call(visage, THIS, attr);
	          } else tokenList = new DOMTokenList(THIS, attr);

	          defineGetter(THIS, name, function () {
	            return tokenList;
	          });
	          delete THIS[gibberishProperty];

	          return tokenList;
	        }, true);
	      };

	      addProp(global.Element, "classList", "className");
	      addProp(global.HTMLElement, "classList", "className");
	      addProp(global.HTMLLinkElement, "relList", "rel");
	      addProp(global.HTMLAnchorElement, "relList", "rel");
	      addProp(global.HTMLAreaElement, "relList", "rel");
	    }(this));

	}).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof commonjsGlobal && commonjsGlobal || {});

	})));
	});

	var Event_1 = createCommonjsModule(function (module, exports) {
	(function (global, factory) {
		factory();
	}(commonjsGlobal, (function () {
	(function(undefined) {

	// Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Window/detect.js
	var detect = ('Window' in this);

	if (detect) return

	// Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Window&flags=always
	if ((typeof WorkerGlobalScope === "undefined") && (typeof importScripts !== "function")) {
		(function (global) {
			if (global.constructor) {
				global.Window = global.constructor;
			} else {
				(global.Window = global.constructor = new Function('return function Window() {}')()).prototype = this;
			}
		}(this));
	}

	})
	.call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof commonjsGlobal && commonjsGlobal || {});

	(function(undefined) {

	// Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Document/detect.js
	var detect = ("Document" in this);

	if (detect) return

	// Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Document&flags=always
	if ((typeof WorkerGlobalScope === "undefined") && (typeof importScripts !== "function")) {

		if (this.HTMLDocument) { // IE8

			// HTMLDocument is an extension of Document.  If the browser has HTMLDocument but not Document, the former will suffice as an alias for the latter.
			this.Document = this.HTMLDocument;

		} else {

			// Create an empty function to act as the missing constructor for the document object, attach the document object as its prototype.  The function needs to be anonymous else it is hoisted and causes the feature detect to prematurely pass, preventing the assignments below being made.
			this.Document = this.HTMLDocument = document.constructor = (new Function('return function Document() {}')());
			this.Document.prototype = document;
		}
	}


	})
	.call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof commonjsGlobal && commonjsGlobal || {});

	(function(undefined) {

	// Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Element/detect.js
	var detect = ('Element' in this && 'HTMLElement' in this);

	if (detect) return

	// Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Element&flags=always
	(function () {

		// IE8
		if (window.Element && !window.HTMLElement) {
			window.HTMLElement = window.Element;
			return;
		}

		// create Element constructor
		window.Element = window.HTMLElement = new Function('return function Element() {}')();

		// generate sandboxed iframe
		var vbody = document.appendChild(document.createElement('body'));
		var frame = vbody.appendChild(document.createElement('iframe'));

		// use sandboxed iframe to replicate Element functionality
		var frameDocument = frame.contentWindow.document;
		var prototype = Element.prototype = frameDocument.appendChild(frameDocument.createElement('*'));
		var cache = {};

		// polyfill Element.prototype on an element
		var shiv = function (element, deep) {
			var
			childNodes = element.childNodes || [],
			index = -1,
			key, value, childNode;

			if (element.nodeType === 1 && element.constructor !== Element) {
				element.constructor = Element;

				for (key in cache) {
					value = cache[key];
					element[key] = value;
				}
			}

			while (childNode = deep && childNodes[++index]) {
				shiv(childNode, deep);
			}

			return element;
		};

		var elements = document.getElementsByTagName('*');
		var nativeCreateElement = document.createElement;
		var interval;
		var loopLimit = 100;

		prototype.attachEvent('onpropertychange', function (event) {
			var
			propertyName = event.propertyName,
			nonValue = !cache.hasOwnProperty(propertyName),
			newValue = prototype[propertyName],
			oldValue = cache[propertyName],
			index = -1,
			element;

			while (element = elements[++index]) {
				if (element.nodeType === 1) {
					if (nonValue || element[propertyName] === oldValue) {
						element[propertyName] = newValue;
					}
				}
			}

			cache[propertyName] = newValue;
		});

		prototype.constructor = Element;

		if (!prototype.hasAttribute) {
			// <Element>.hasAttribute
			prototype.hasAttribute = function hasAttribute(name) {
				return this.getAttribute(name) !== null;
			};
		}

		// Apply Element prototype to the pre-existing DOM as soon as the body element appears.
		function bodyCheck() {
			if (!(loopLimit--)) clearTimeout(interval);
			if (document.body && !document.body.prototype && /(complete|interactive)/.test(document.readyState)) {
				shiv(document, true);
				if (interval && document.body.prototype) clearTimeout(interval);
				return (!!document.body.prototype);
			}
			return false;
		}
		if (!bodyCheck()) {
			document.onreadystatechange = bodyCheck;
			interval = setInterval(bodyCheck, 25);
		}

		// Apply to any new elements created after load
		document.createElement = function createElement(nodeName) {
			var element = nativeCreateElement(String(nodeName).toLowerCase());
			return shiv(element);
		};

		// remove sandboxed iframe
		document.removeChild(vbody);
	}());

	})
	.call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof commonjsGlobal && commonjsGlobal || {});

	(function(undefined) {

	// Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Object/defineProperty/detect.js
	var detect = (
	  // In IE8, defineProperty could only act on DOM elements, so full support
	  // for the feature requires the ability to set a property on an arbitrary object
	  'defineProperty' in Object && (function() {
	  	try {
	  		var a = {};
	  		Object.defineProperty(a, 'test', {value:42});
	  		return true;
	  	} catch(e) {
	  		return false
	  	}
	  }())
	);

	if (detect) return

	// Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Object.defineProperty&flags=always
	(function (nativeDefineProperty) {

		var supportsAccessors = Object.prototype.hasOwnProperty('__defineGetter__');
		var ERR_ACCESSORS_NOT_SUPPORTED = 'Getters & setters cannot be defined on this javascript engine';
		var ERR_VALUE_ACCESSORS = 'A property cannot both have accessors and be writable or have a value';

		Object.defineProperty = function defineProperty(object, property, descriptor) {

			// Where native support exists, assume it
			if (nativeDefineProperty && (object === window || object === document || object === Element.prototype || object instanceof Element)) {
				return nativeDefineProperty(object, property, descriptor);
			}

			if (object === null || !(object instanceof Object || typeof object === 'object')) {
				throw new TypeError('Object.defineProperty called on non-object');
			}

			if (!(descriptor instanceof Object)) {
				throw new TypeError('Property description must be an object');
			}

			var propertyString = String(property);
			var hasValueOrWritable = 'value' in descriptor || 'writable' in descriptor;
			var getterType = 'get' in descriptor && typeof descriptor.get;
			var setterType = 'set' in descriptor && typeof descriptor.set;

			// handle descriptor.get
			if (getterType) {
				if (getterType !== 'function') {
					throw new TypeError('Getter must be a function');
				}
				if (!supportsAccessors) {
					throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
				}
				if (hasValueOrWritable) {
					throw new TypeError(ERR_VALUE_ACCESSORS);
				}
				Object.__defineGetter__.call(object, propertyString, descriptor.get);
			} else {
				object[propertyString] = descriptor.value;
			}

			// handle descriptor.set
			if (setterType) {
				if (setterType !== 'function') {
					throw new TypeError('Setter must be a function');
				}
				if (!supportsAccessors) {
					throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
				}
				if (hasValueOrWritable) {
					throw new TypeError(ERR_VALUE_ACCESSORS);
				}
				Object.__defineSetter__.call(object, propertyString, descriptor.set);
			}

			// OK to define value unconditionally - if a getter has been specified as well, an error would be thrown above
			if ('value' in descriptor) {
				object[propertyString] = descriptor.value;
			}

			return object;
		};
	}(Object.defineProperty));
	})
	.call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof commonjsGlobal && commonjsGlobal || {});

	(function(undefined) {

	// Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Event/detect.js
	var detect = (
	  (function(global) {

	  	if (!('Event' in global)) return false;
	  	if (typeof global.Event === 'function') return true;

	  	try {

	  		// In IE 9-11, the Event object exists but cannot be instantiated
	  		new Event('click');
	  		return true;
	  	} catch(e) {
	  		return false;
	  	}
	  }(this))
	);

	if (detect) return

	// Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Event&flags=always
	(function () {
		var unlistenableWindowEvents = {
			click: 1,
			dblclick: 1,
			keyup: 1,
			keypress: 1,
			keydown: 1,
			mousedown: 1,
			mouseup: 1,
			mousemove: 1,
			mouseover: 1,
			mouseenter: 1,
			mouseleave: 1,
			mouseout: 1,
			storage: 1,
			storagecommit: 1,
			textinput: 1
		};

		// This polyfill depends on availability of `document` so will not run in a worker
		// However, we asssume there are no browsers with worker support that lack proper
		// support for `Event` within the worker
		if (typeof document === 'undefined' || typeof window === 'undefined') return;

		function indexOf(array, element) {
			var
			index = -1,
			length = array.length;

			while (++index < length) {
				if (index in array && array[index] === element) {
					return index;
				}
			}

			return -1;
		}

		var existingProto = (window.Event && window.Event.prototype) || null;
		window.Event = Window.prototype.Event = function Event(type, eventInitDict) {
			if (!type) {
				throw new Error('Not enough arguments');
			}

			var event;
			// Shortcut if browser supports createEvent
			if ('createEvent' in document) {
				event = document.createEvent('Event');
				var bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
				var cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;

				event.initEvent(type, bubbles, cancelable);

				return event;
			}

			event = document.createEventObject();

			event.type = type;
			event.bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
			event.cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;

			return event;
		};
		if (existingProto) {
			Object.defineProperty(window.Event, 'prototype', {
				configurable: false,
				enumerable: false,
				writable: true,
				value: existingProto
			});
		}

		if (!('createEvent' in document)) {
			window.addEventListener = Window.prototype.addEventListener = Document.prototype.addEventListener = Element.prototype.addEventListener = function addEventListener() {
				var
				element = this,
				type = arguments[0],
				listener = arguments[1];

				if (element === window && type in unlistenableWindowEvents) {
					throw new Error('In IE8 the event: ' + type + ' is not available on the window object. Please see https://github.com/Financial-Times/polyfill-service/issues/317 for more information.');
				}

				if (!element._events) {
					element._events = {};
				}

				if (!element._events[type]) {
					element._events[type] = function (event) {
						var
						list = element._events[event.type].list,
						events = list.slice(),
						index = -1,
						length = events.length,
						eventElement;

						event.preventDefault = function preventDefault() {
							if (event.cancelable !== false) {
								event.returnValue = false;
							}
						};

						event.stopPropagation = function stopPropagation() {
							event.cancelBubble = true;
						};

						event.stopImmediatePropagation = function stopImmediatePropagation() {
							event.cancelBubble = true;
							event.cancelImmediate = true;
						};

						event.currentTarget = element;
						event.relatedTarget = event.fromElement || null;
						event.target = event.target || event.srcElement || element;
						event.timeStamp = new Date().getTime();

						if (event.clientX) {
							event.pageX = event.clientX + document.documentElement.scrollLeft;
							event.pageY = event.clientY + document.documentElement.scrollTop;
						}

						while (++index < length && !event.cancelImmediate) {
							if (index in events) {
								eventElement = events[index];

								if (indexOf(list, eventElement) !== -1 && typeof eventElement === 'function') {
									eventElement.call(element, event);
								}
							}
						}
					};

					element._events[type].list = [];

					if (element.attachEvent) {
						element.attachEvent('on' + type, element._events[type]);
					}
				}

				element._events[type].list.push(listener);
			};

			window.removeEventListener = Window.prototype.removeEventListener = Document.prototype.removeEventListener = Element.prototype.removeEventListener = function removeEventListener() {
				var
				element = this,
				type = arguments[0],
				listener = arguments[1],
				index;

				if (element._events && element._events[type] && element._events[type].list) {
					index = indexOf(element._events[type].list, listener);

					if (index !== -1) {
						element._events[type].list.splice(index, 1);

						if (!element._events[type].list.length) {
							if (element.detachEvent) {
								element.detachEvent('on' + type, element._events[type]);
							}
							delete element._events[type];
						}
					}
				}
			};

			window.dispatchEvent = Window.prototype.dispatchEvent = Document.prototype.dispatchEvent = Element.prototype.dispatchEvent = function dispatchEvent(event) {
				if (!arguments.length) {
					throw new Error('Not enough arguments');
				}

				if (!event || typeof event.type !== 'string') {
					throw new Error('DOM Events Exception 0');
				}

				var element = this, type = event.type;

				try {
					if (!event.bubbles) {
						event.cancelBubble = true;

						var cancelBubbleEvent = function (event) {
							event.cancelBubble = true;

							(element || window).detachEvent('on' + type, cancelBubbleEvent);
						};

						this.attachEvent('on' + type, cancelBubbleEvent);
					}

					this.fireEvent('on' + type, event);
				} catch (error) {
					event.target = element;

					do {
						event.currentTarget = element;

						if ('_events' in element && typeof element._events[type] === 'function') {
							element._events[type].call(element, event);
						}

						if (typeof element['on' + type] === 'function') {
							element['on' + type].call(element, event);
						}

						element = element.nodeType === 9 ? element.parentWindow : element.parentNode;
					} while (element && !event.cancelBubble);
				}

				return true;
			};

			// Add the DOMContentLoaded Event
			document.attachEvent('onreadystatechange', function() {
				if (document.readyState === 'complete') {
					document.dispatchEvent(new Event('DOMContentLoaded', {
						bubbles: true
					}));
				}
			});
		}
	}());

	})
	.call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof commonjsGlobal && commonjsGlobal || {});

	})));
	});

	var nodeListForEach = common.nodeListForEach;

	var tabsItemClass = 'app-tabs__item';
	var tabsItemCurrentClass = tabsItemClass + '--current';
	var tabsItemJsClass = 'js-tabs__item';
	var headingItemClass = 'app-tabs__heading';
	var headingItemCurrentClass = headingItemClass + '--current';
	var headingItemJsClass = 'js-tabs__heading';
	var tabContainerHiddenClass = 'app-tabs__container--hidden';
	var tabContainerJsClass = '.js-tabs__container';
	var tabContainerNoTabsJsClass = 'js-tabs__container--no-tabs';
	var allTabTogglers = '.' + tabsItemJsClass + ' a, ' + '.' + headingItemJsClass + ' a';
	var tabTogglersMarkedOpenClass = '.js-tabs__item--open a';

	function AppTabs ($module) {
	  this.$module = $module;
	  this.$allTabContainers = this.$module.querySelectorAll(tabContainerJsClass);
	  this.$allTabTogglers = this.$module.querySelectorAll(allTabTogglers);
	  this.$allTabTogglersMarkedOpen = this.$module.querySelectorAll(tabTogglersMarkedOpenClass);
	}

	AppTabs.prototype.init = function () {
	  if (!this.$module) {
	    return
	  }
	  // reset all tabs
	  this.resetTabs();
	  // add close to each tab
	  this.$module.addEventListener('click', this.handleClick.bind(this));

	  nodeListForEach(this.$allTabTogglersMarkedOpen, function ($tabToggler) {
	    $tabToggler.click();
	  });
	};

	// expand and collapse functionality
	AppTabs.prototype.activateAndToggle = function (event) {
	  event.preventDefault();
	  var $currentToggler = event.target;
	  var $currentTogglerSiblings = this.$module.querySelectorAll('[href="' + $currentToggler.hash + '"]');
	  var $tabContainer = this.$module.querySelector($currentToggler.hash);
	  var isTabAlreadyOpen = $currentToggler.getAttribute('aria-expanded') === 'true';

	  if (isTabAlreadyOpen) {
	    $tabContainer.classList.add(tabContainerHiddenClass);
	    $tabContainer.setAttribute('aria-hidden', 'true');
	    nodeListForEach($currentTogglerSiblings, function ($tabToggler) {
	      $tabToggler.setAttribute('aria-expanded', 'false');
	      // desktop and mobile
	      $tabToggler.parentNode.classList.remove(tabsItemCurrentClass, headingItemCurrentClass);
	    });
	  } else {
	    // Reset tabs
	    this.resetTabs();
	    // make current active
	    $tabContainer.classList.remove(tabContainerHiddenClass);
	    $tabContainer.setAttribute('aria-hidden', 'false');

	    nodeListForEach($currentTogglerSiblings, function ($tabToggler) {
	      $tabToggler.setAttribute('aria-expanded', 'true');
	      if ($tabToggler.parentNode.classList.contains(tabsItemClass)) {
	        $tabToggler.parentNode.classList.add(tabsItemCurrentClass);
	      } else if ($tabToggler.parentNode.classList.contains(headingItemClass)) {
	        $tabToggler.parentNode.classList.add(headingItemCurrentClass);
	      }
	    });
	  }
	};
	// reset aria attributes to default and close the tab content container
	AppTabs.prototype.resetTabs = function () {
	  nodeListForEach(this.$allTabContainers, function ($tabContainer) {
	    // unless the tab content has not tabs and it's been set as open
	    if (!$tabContainer.classList.contains(tabContainerNoTabsJsClass)) {
	      $tabContainer.classList.add(tabContainerHiddenClass);
	      $tabContainer.setAttribute('aria-hidden', 'true');
	    }
	  });

	  nodeListForEach(this.$allTabTogglers, function ($tabToggler) {
	    $tabToggler.setAttribute('aria-expanded', 'false');
	    // desktop and mobile
	    $tabToggler.parentNode.classList.remove(tabsItemCurrentClass, headingItemCurrentClass);
	  });
	};

	// Close current container on click
	AppTabs.prototype.clickCloseContainer = function (event) {
	  event.preventDefault();
	  this.resetTabs();
	};

	AppTabs.prototype.handleClick = function (event) {
	  // toggle and active selected tab and heading (on mobile)
	  if (event.target.parentNode.classList.contains(tabsItemJsClass) ||
	    event.target.parentNode.classList.contains(headingItemJsClass)) {
	    this.activateAndToggle(event);
	  }
	};

	var clipboard = createCommonjsModule(function (module, exports) {
	/*!
	 * clipboard.js v2.0.1
	 * https://zenorocha.github.io/clipboard.js
	 * 
	 * Licensed MIT © Zeno Rocha
	 */
	(function webpackUniversalModuleDefinition(root, factory) {
		module.exports = factory();
	})(commonjsGlobal, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 3);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(7)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
					__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
					(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	})(this, function (module, _select) {

	    var _select2 = _interopRequireDefault(_select);

	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }

	    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	        return typeof obj;
	    } : function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };

	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }

	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }

	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();

	    var ClipboardAction = function () {
	        /**
	         * @param {Object} options
	         */
	        function ClipboardAction(options) {
	            _classCallCheck(this, ClipboardAction);

	            this.resolveOptions(options);
	            this.initSelection();
	        }

	        /**
	         * Defines base properties passed from constructor.
	         * @param {Object} options
	         */


	        _createClass(ClipboardAction, [{
	            key: 'resolveOptions',
	            value: function resolveOptions() {
	                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	                this.action = options.action;
	                this.container = options.container;
	                this.emitter = options.emitter;
	                this.target = options.target;
	                this.text = options.text;
	                this.trigger = options.trigger;

	                this.selectedText = '';
	            }
	        }, {
	            key: 'initSelection',
	            value: function initSelection() {
	                if (this.text) {
	                    this.selectFake();
	                } else if (this.target) {
	                    this.selectTarget();
	                }
	            }
	        }, {
	            key: 'selectFake',
	            value: function selectFake() {
	                var _this = this;

	                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

	                this.removeFake();

	                this.fakeHandlerCallback = function () {
	                    return _this.removeFake();
	                };
	                this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

	                this.fakeElem = document.createElement('textarea');
	                // Prevent zooming on iOS
	                this.fakeElem.style.fontSize = '12pt';
	                // Reset box model
	                this.fakeElem.style.border = '0';
	                this.fakeElem.style.padding = '0';
	                this.fakeElem.style.margin = '0';
	                // Move element out of screen horizontally
	                this.fakeElem.style.position = 'absolute';
	                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
	                // Move element to the same position vertically
	                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
	                this.fakeElem.style.top = yPosition + 'px';

	                this.fakeElem.setAttribute('readonly', '');
	                this.fakeElem.value = this.text;

	                this.container.appendChild(this.fakeElem);

	                this.selectedText = (0, _select2.default)(this.fakeElem);
	                this.copyText();
	            }
	        }, {
	            key: 'removeFake',
	            value: function removeFake() {
	                if (this.fakeHandler) {
	                    this.container.removeEventListener('click', this.fakeHandlerCallback);
	                    this.fakeHandler = null;
	                    this.fakeHandlerCallback = null;
	                }

	                if (this.fakeElem) {
	                    this.container.removeChild(this.fakeElem);
	                    this.fakeElem = null;
	                }
	            }
	        }, {
	            key: 'selectTarget',
	            value: function selectTarget() {
	                this.selectedText = (0, _select2.default)(this.target);
	                this.copyText();
	            }
	        }, {
	            key: 'copyText',
	            value: function copyText() {
	                var succeeded = void 0;

	                try {
	                    succeeded = document.execCommand(this.action);
	                } catch (err) {
	                    succeeded = false;
	                }

	                this.handleResult(succeeded);
	            }
	        }, {
	            key: 'handleResult',
	            value: function handleResult(succeeded) {
	                this.emitter.emit(succeeded ? 'success' : 'error', {
	                    action: this.action,
	                    text: this.selectedText,
	                    trigger: this.trigger,
	                    clearSelection: this.clearSelection.bind(this)
	                });
	            }
	        }, {
	            key: 'clearSelection',
	            value: function clearSelection() {
	                if (this.trigger) {
	                    this.trigger.focus();
	                }

	                window.getSelection().removeAllRanges();
	            }
	        }, {
	            key: 'destroy',
	            value: function destroy() {
	                this.removeFake();
	            }
	        }, {
	            key: 'action',
	            set: function set() {
	                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

	                this._action = action;

	                if (this._action !== 'copy' && this._action !== 'cut') {
	                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
	                }
	            },
	            get: function get() {
	                return this._action;
	            }
	        }, {
	            key: 'target',
	            set: function set(target) {
	                if (target !== undefined) {
	                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
	                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
	                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
	                        }

	                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
	                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
	                        }

	                        this._target = target;
	                    } else {
	                        throw new Error('Invalid "target" value, use a valid Element');
	                    }
	                }
	            },
	            get: function get() {
	                return this._target;
	            }
	        }]);

	        return ClipboardAction;
	    }();

	    module.exports = ClipboardAction;
	});

	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {

	var is = __webpack_require__(6);
	var delegate = __webpack_require__(5);

	/**
	 * Validates all params and calls the right
	 * listener function based on its target type.
	 *
	 * @param {String|HTMLElement|HTMLCollection|NodeList} target
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listen(target, type, callback) {
	    if (!target && !type && !callback) {
	        throw new Error('Missing required arguments');
	    }

	    if (!is.string(type)) {
	        throw new TypeError('Second argument must be a String');
	    }

	    if (!is.fn(callback)) {
	        throw new TypeError('Third argument must be a Function');
	    }

	    if (is.node(target)) {
	        return listenNode(target, type, callback);
	    }
	    else if (is.nodeList(target)) {
	        return listenNodeList(target, type, callback);
	    }
	    else if (is.string(target)) {
	        return listenSelector(target, type, callback);
	    }
	    else {
	        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
	    }
	}

	/**
	 * Adds an event listener to a HTML element
	 * and returns a remove listener function.
	 *
	 * @param {HTMLElement} node
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenNode(node, type, callback) {
	    node.addEventListener(type, callback);

	    return {
	        destroy: function() {
	            node.removeEventListener(type, callback);
	        }
	    }
	}

	/**
	 * Add an event listener to a list of HTML elements
	 * and returns a remove listener function.
	 *
	 * @param {NodeList|HTMLCollection} nodeList
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenNodeList(nodeList, type, callback) {
	    Array.prototype.forEach.call(nodeList, function(node) {
	        node.addEventListener(type, callback);
	    });

	    return {
	        destroy: function() {
	            Array.prototype.forEach.call(nodeList, function(node) {
	                node.removeEventListener(type, callback);
	            });
	        }
	    }
	}

	/**
	 * Add an event listener to a selector
	 * and returns a remove listener function.
	 *
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenSelector(selector, type, callback) {
	    return delegate(document.body, selector, type, callback);
	}

	module.exports = listen;


	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {

	function E () {
	  // Keep this empty so it's easier to inherit from
	  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
	}

	E.prototype = {
	  on: function (name, callback, ctx) {
	    var e = this.e || (this.e = {});

	    (e[name] || (e[name] = [])).push({
	      fn: callback,
	      ctx: ctx
	    });

	    return this;
	  },

	  once: function (name, callback, ctx) {
	    var self = this;
	    function listener () {
	      self.off(name, listener);
	      callback.apply(ctx, arguments);
	    }
	    listener._ = callback;
	    return this.on(name, listener, ctx);
	  },

	  emit: function (name) {
	    var data = [].slice.call(arguments, 1);
	    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
	    var i = 0;
	    var len = evtArr.length;

	    for (i; i < len; i++) {
	      evtArr[i].fn.apply(evtArr[i].ctx, data);
	    }

	    return this;
	  },

	  off: function (name, callback) {
	    var e = this.e || (this.e = {});
	    var evts = e[name];
	    var liveEvents = [];

	    if (evts && callback) {
	      for (var i = 0, len = evts.length; i < len; i++) {
	        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
	          liveEvents.push(evts[i]);
	      }
	    }

	    // Remove event from queue to prevent memory leak
	    // Suggested by https://github.com/lazd
	    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

	    (liveEvents.length)
	      ? e[name] = liveEvents
	      : delete e[name];

	    return this;
	  }
	};

	module.exports = E;


	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
					__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
					(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {

	    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

	    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

	    var _goodListener2 = _interopRequireDefault(_goodListener);

	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }

	    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	        return typeof obj;
	    } : function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };

	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }

	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }

	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();

	    function _possibleConstructorReturn(self, call) {
	        if (!self) {
	            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	        }

	        return call && (typeof call === "object" || typeof call === "function") ? call : self;
	    }

	    function _inherits(subClass, superClass) {
	        if (typeof superClass !== "function" && superClass !== null) {
	            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	        }

	        subClass.prototype = Object.create(superClass && superClass.prototype, {
	            constructor: {
	                value: subClass,
	                enumerable: false,
	                writable: true,
	                configurable: true
	            }
	        });
	        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	    }

	    var Clipboard = function (_Emitter) {
	        _inherits(Clipboard, _Emitter);

	        /**
	         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
	         * @param {Object} options
	         */
	        function Clipboard(trigger, options) {
	            _classCallCheck(this, Clipboard);

	            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

	            _this.resolveOptions(options);
	            _this.listenClick(trigger);
	            return _this;
	        }

	        /**
	         * Defines if attributes would be resolved using internal setter functions
	         * or custom functions that were passed in the constructor.
	         * @param {Object} options
	         */


	        _createClass(Clipboard, [{
	            key: 'resolveOptions',
	            value: function resolveOptions() {
	                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
	                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
	                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
	                this.container = _typeof(options.container) === 'object' ? options.container : document.body;
	            }
	        }, {
	            key: 'listenClick',
	            value: function listenClick(trigger) {
	                var _this2 = this;

	                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
	                    return _this2.onClick(e);
	                });
	            }
	        }, {
	            key: 'onClick',
	            value: function onClick(e) {
	                var trigger = e.delegateTarget || e.currentTarget;

	                if (this.clipboardAction) {
	                    this.clipboardAction = null;
	                }

	                this.clipboardAction = new _clipboardAction2.default({
	                    action: this.action(trigger),
	                    target: this.target(trigger),
	                    text: this.text(trigger),
	                    container: this.container,
	                    trigger: trigger,
	                    emitter: this
	                });
	            }
	        }, {
	            key: 'defaultAction',
	            value: function defaultAction(trigger) {
	                return getAttributeValue('action', trigger);
	            }
	        }, {
	            key: 'defaultTarget',
	            value: function defaultTarget(trigger) {
	                var selector = getAttributeValue('target', trigger);

	                if (selector) {
	                    return document.querySelector(selector);
	                }
	            }
	        }, {
	            key: 'defaultText',
	            value: function defaultText(trigger) {
	                return getAttributeValue('text', trigger);
	            }
	        }, {
	            key: 'destroy',
	            value: function destroy() {
	                this.listener.destroy();

	                if (this.clipboardAction) {
	                    this.clipboardAction.destroy();
	                    this.clipboardAction = null;
	                }
	            }
	        }], [{
	            key: 'isSupported',
	            value: function isSupported() {
	                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

	                var actions = typeof action === 'string' ? [action] : action;
	                var support = !!document.queryCommandSupported;

	                actions.forEach(function (action) {
	                    support = support && !!document.queryCommandSupported(action);
	                });

	                return support;
	            }
	        }]);

	        return Clipboard;
	    }(_tinyEmitter2.default);

	    /**
	     * Helper function to retrieve attribute value.
	     * @param {String} suffix
	     * @param {Element} element
	     */
	    function getAttributeValue(suffix, element) {
	        var attribute = 'data-clipboard-' + suffix;

	        if (!element.hasAttribute(attribute)) {
	            return;
	        }

	        return element.getAttribute(attribute);
	    }

	    module.exports = Clipboard;
	});

	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {

	var DOCUMENT_NODE_TYPE = 9;

	/**
	 * A polyfill for Element.matches()
	 */
	if (typeof Element !== 'undefined' && !Element.prototype.matches) {
	    var proto = Element.prototype;

	    proto.matches = proto.matchesSelector ||
	                    proto.mozMatchesSelector ||
	                    proto.msMatchesSelector ||
	                    proto.oMatchesSelector ||
	                    proto.webkitMatchesSelector;
	}

	/**
	 * Finds the closest parent that matches a selector.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @return {Function}
	 */
	function closest (element, selector) {
	    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
	        if (typeof element.matches === 'function' &&
	            element.matches(selector)) {
	          return element;
	        }
	        element = element.parentNode;
	    }
	}

	module.exports = closest;


	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {

	var closest = __webpack_require__(4);

	/**
	 * Delegates event to a selector.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @param {Boolean} useCapture
	 * @return {Object}
	 */
	function _delegate(element, selector, type, callback, useCapture) {
	    var listenerFn = listener.apply(this, arguments);

	    element.addEventListener(type, listenerFn, useCapture);

	    return {
	        destroy: function() {
	            element.removeEventListener(type, listenerFn, useCapture);
	        }
	    }
	}

	/**
	 * Delegates event to a selector.
	 *
	 * @param {Element|String|Array} [elements]
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @param {Boolean} useCapture
	 * @return {Object}
	 */
	function delegate(elements, selector, type, callback, useCapture) {
	    // Handle the regular Element usage
	    if (typeof elements.addEventListener === 'function') {
	        return _delegate.apply(null, arguments);
	    }

	    // Handle Element-less usage, it defaults to global delegation
	    if (typeof type === 'function') {
	        // Use `document` as the first parameter, then apply arguments
	        // This is a short way to .unshift `arguments` without running into deoptimizations
	        return _delegate.bind(null, document).apply(null, arguments);
	    }

	    // Handle Selector-based usage
	    if (typeof elements === 'string') {
	        elements = document.querySelectorAll(elements);
	    }

	    // Handle Array-like based usage
	    return Array.prototype.map.call(elements, function (element) {
	        return _delegate(element, selector, type, callback, useCapture);
	    });
	}

	/**
	 * Finds closest match and invokes callback.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Function}
	 */
	function listener(element, selector, type, callback) {
	    return function(e) {
	        e.delegateTarget = closest(e.target, selector);

	        if (e.delegateTarget) {
	            callback.call(element, e);
	        }
	    }
	}

	module.exports = delegate;


	/***/ }),
	/* 6 */
	/***/ (function(module, exports) {

	/**
	 * Check if argument is a HTML element.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.node = function(value) {
	    return value !== undefined
	        && value instanceof HTMLElement
	        && value.nodeType === 1;
	};

	/**
	 * Check if argument is a list of HTML elements.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.nodeList = function(value) {
	    var type = Object.prototype.toString.call(value);

	    return value !== undefined
	        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
	        && ('length' in value)
	        && (value.length === 0 || exports.node(value[0]));
	};

	/**
	 * Check if argument is a string.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.string = function(value) {
	    return typeof value === 'string'
	        || value instanceof String;
	};

	/**
	 * Check if argument is a function.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.fn = function(value) {
	    var type = Object.prototype.toString.call(value);

	    return type === '[object Function]';
	};


	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {

	function select(element) {
	    var selectedText;

	    if (element.nodeName === 'SELECT') {
	        element.focus();

	        selectedText = element.value;
	    }
	    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
	        var isReadOnly = element.hasAttribute('readonly');

	        if (!isReadOnly) {
	            element.setAttribute('readonly', '');
	        }

	        element.select();
	        element.setSelectionRange(0, element.value.length);

	        if (!isReadOnly) {
	            element.removeAttribute('readonly');
	        }

	        selectedText = element.value;
	    }
	    else {
	        if (element.hasAttribute('contenteditable')) {
	            element.focus();
	        }

	        var selection = window.getSelection();
	        var range = document.createRange();

	        range.selectNodeContents(element);
	        selection.removeAllRanges();
	        selection.addRange(range);

	        selectedText = selection.toString();
	    }

	    return selectedText;
	}

	module.exports = select;


	/***/ })
	/******/ ]);
	});
	});

	var ClipboardJS = unwrapExports(clipboard);

	function Copy ($module) {
	  this.$module = $module;
	}

	Copy.prototype.init = function () {
	  var $module = this.$module;
	  if (!$module) {
	    return
	  }
	  var $button = document.createElement('button');
	  $button.className = 'app-copy-button js-copy-button';
	  $button.setAttribute('aria-live', 'assertive');
	  $button.textContent = 'Copy';

	  $module.insertBefore($button, $module.firstChild);
	  this.copyAction();
	};
	Copy.prototype.copyAction = function () {
	  // Copy to clipboard
	  try {
	    new ClipboardJS('.js-copy-button', {
	      target: function (trigger) {
	        return trigger.nextElementSibling
	      }
	    }).on('success', function (e) {
	      e.trigger.textContent = 'Copied';
	      e.clearSelection();
	      setTimeout(function () {
	        e.trigger.textContent = 'Copy';
	      }, 5000);
	    });
	  } catch (err) {
	    if (err) {
	      console.log(err.message);
	    }
	  }
	};

	var nodeListForEach$1 = common.nodeListForEach;

	var navActiveClass = 'app-mobile-nav--active';
	var navTogglerActiveClass = 'app-header-mobile-nav-toggler--active';
	var subNavActiveClass = 'app-mobile-nav__subnav--active';
	var subNavTogglerActiveClass = 'app-mobile-nav__subnav-toggler--active';

	function MobileNav ($module) {
	  this.$module = $module || document;
	  this.$nav = this.$module.querySelector('.js-app-mobile-nav');
	  this.$navToggler = this.$module.querySelector('.js-app-mobile-nav-toggler');
	}

	MobileNav.prototype.bindUIEvents = function () {
	  var $nav = this.$nav;
	  var $navToggler = this.$navToggler;

	  $navToggler.addEventListener('click', function (e) {
	    if ($nav.classList.contains(navActiveClass)) {
	      $nav.classList.remove(navActiveClass);
	      $nav.setAttribute('aria-hidden', 'true');

	      $navToggler.classList.remove(navTogglerActiveClass);
	      $navToggler.setAttribute('aria-expanded', 'false');
	    } else {
	      $nav.classList.add(navActiveClass);
	      $nav.setAttribute('aria-hidden', 'false');

	      $navToggler.setAttribute('aria-expanded', 'true');
	      $navToggler.classList.add(navTogglerActiveClass);
	    }
	  });

	  $nav.addEventListener('click', function (event) {
	    var $toggler = event.target;
	    if (!$toggler.classList.contains('js-mobile-nav-subnav-toggler')) {
	      return
	    }
	    var $nextSubNav = $toggler.parentNode.querySelector('.js-app-mobile-nav-subnav');

	    if ($nextSubNav) {
	      if ($nextSubNav.classList.contains(subNavActiveClass)) {
	        $nextSubNav.classList.remove(subNavActiveClass);
	        $toggler.classList.remove(subNavTogglerActiveClass);

	        $nextSubNav.setAttribute('aria-hidden', 'true');
	        $toggler.setAttribute('aria-expanded', 'false');
	      } else {
	        $nextSubNav.classList.add(subNavActiveClass);
	        $toggler.classList.add(subNavTogglerActiveClass);

	        $nextSubNav.setAttribute('aria-hidden', 'false');
	        $toggler.setAttribute('aria-expanded', 'true');
	      }
	      event.preventDefault();
	    }
	  });
	};

	MobileNav.prototype.includeAria = function () {
	  this.$nav.setAttribute('aria-hidden', 'true');
	  this.$nav.setAttribute('aria-labelledby', 'app-header-mobile-nav-toggler');

	  var $navToggler = this.$navToggler;
	  $navToggler.setAttribute('aria-label', 'Toggle mobile menu');
	  $navToggler.setAttribute('aria-expanded', 'false');
	  $navToggler.setAttribute('aria-controls', 'app-mobile-nav');

	  var $subNavTogglers = this.$module.querySelectorAll('.js-mobile-nav-subnav-toggler');

	  nodeListForEach$1($subNavTogglers, function ($toggler, index) {
	    var $nextSubNav = $toggler.parentNode.querySelector('.js-app-mobile-nav-subnav');

	    if ($nextSubNav) {
	      var navIsOpen = $nextSubNav.classList.contains(subNavActiveClass);
	      var subNavTogglerId = 'js-mobile-nav-subnav-toggler-' + index;
	      var nextSubNavId = 'js-mobile-nav__subnav-' + index;

	      $nextSubNav.setAttribute('id', nextSubNavId);
	      $nextSubNav.setAttribute('aria-hidden', navIsOpen ? 'false' : 'true');
	      $nextSubNav.setAttribute('aria-labelledby', subNavTogglerId);

	      $toggler.setAttribute('id', subNavTogglerId);
	      $toggler.setAttribute('aria-label', 'Toggle subnavigation for ' + $toggler.innerText);
	      $toggler.setAttribute('aria-expanded', navIsOpen ? 'true' : 'false');
	      $toggler.setAttribute('aria-controls', nextSubNavId);
	    }
	  });
	};

	MobileNav.prototype.init = function () {
	  // Since the Mobile navigation is not included in IE8
	  // We detect features we need to use only available in IE9+ https://caniuse.com/#feat=addeventlistener
	  // http://responsivenews.co.uk/post/18948466399/cutting-the-mustard
	  var featuresNeeded = (
	    'querySelector' in document &&
	    'addEventListener' in window
	  );

	  if (!featuresNeeded) {
	    return
	  }

	  this.includeAria();
	  this.bindUIEvents();
	};

	var accessibleAutocomplete_min = createCommonjsModule(function (module, exports) {
	(function webpackUniversalModuleDefinition(e,t){module.exports=t();})(window,function(){return function(n){var r={};function o(e){if(r[e])return r[e].exports;var t=r[e]={i:e,l:!1,exports:{}};return n[e].call(t.exports,t,t.exports,o),t.l=!0,t.exports}return o.m=n,o.c=r,o.d=function(e,t,n){o.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n});},o.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});},o.t=function(t,e){if(1&e&&(t=o(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(o.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)o.d(n,r,function(e){return t[e]}.bind(null,r));return n},o.n=function(e){var t=e&&e.__esModule?function(){return e["default"]}:function(){return e};return o.d(t,"a",t),t},o.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},o.p="/",o(o.s=37)}([function(e,t,n){var m=n(1),v=n(6),y=n(7),_=n(16),b=n(18),g="prototype",x=function(e,t,n){var r,o,i,u,l=e&x.F,a=e&x.G,s=e&x.S,c=e&x.P,p=e&x.B,f=a?m:s?m[t]||(m[t]={}):(m[t]||{})[g],d=a?v:v[t]||(v[t]={}),h=d[g]||(d[g]={});for(r in a&&(n=t),n)i=((o=!l&&f&&f[r]!==undefined)?f:n)[r],u=p&&o?b(i,m):c&&"function"==typeof i?b(Function.call,i):i,f&&_(f,r,i,e&x.U),d[r]!=i&&y(d,r,u),c&&h[r]!=i&&(h[r]=i);};m.core=v,x.F=1,x.G=2,x.S=4,x.P=8,x.B=16,x.W=32,x.U=64,x.R=128,e.exports=x;},function(e,t){var n=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n);},function(e,t){e.exports=function(e){return"object"==typeof e?null!==e:"function"==typeof e};},function(e,t,n){e.exports=!n(4)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a});},function(e,t){e.exports=function(e){try{return!!e()}catch(t){return!0}};},function(e,t,n){n.r(t),n.d(t,"h",function(){return r}),n.d(t,"createElement",function(){return r}),n.d(t,"cloneElement",function(){return i}),n.d(t,"Component",function(){return _}),n.d(t,"render",function(){return b}),n.d(t,"rerender",function(){return f}),n.d(t,"options",function(){return E});var a=function a(){},E={},s=[],c=[];function r(e,t){var n,r,o,i,u=c;for(i=arguments.length;2<i--;)s.push(arguments[i]);for(t&&null!=t.children&&(s.length||s.push(t.children),delete t.children);s.length;)if((r=s.pop())&&r.pop!==undefined)for(i=r.length;i--;)s.push(r[i]);else"boolean"==typeof r&&(r=null),(o="function"!=typeof e)&&(null==r?r="":"number"==typeof r?r=String(r):"string"!=typeof r&&(o=!1)),o&&n?u[u.length-1]+=r:u===c?u=[r]:u.push(r),n=o;var l=new a;return l.nodeName=e,l.children=u,l.attributes=null==t?undefined:t,l.key=null==t?undefined:t.key,E.vnode!==undefined&&E.vnode(l),l}function N(e,t){for(var n in t)e[n]=t[n];return e}var o="function"==typeof Promise?Promise.resolve().then.bind(Promise.resolve()):setTimeout;function i(e,t){return r(e.nodeName,N(N({},e.attributes),t),2<arguments.length?[].slice.call(arguments,2):e.children)}var p=/acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,u=[];function l(e){!e._dirty&&(e._dirty=!0)&&1==u.push(e)&&(E.debounceRendering||o)(f);}function f(){var e,t=u;for(u=[];e=t.pop();)e._dirty&&V(e);}function k(e,t){return e.normalizedNodeName===t||e.nodeName.toLowerCase()===t.toLowerCase()}function I(e){var t=N({},e.attributes);t.children=e.children;var n=e.nodeName.defaultProps;if(n!==undefined)for(var r in n)t[r]===undefined&&(t[r]=n[r]);return t}function P(e){var t=e.parentNode;t&&t.removeChild(e);}function v(e,t,n,r,o){if("className"===t&&(t="class"),"key"===t);else if("ref"===t)n&&n(null),r&&r(e);else if("class"!==t||o)if("style"===t){if(r&&"string"!=typeof r&&"string"!=typeof n||(e.style.cssText=r||""),r&&"object"==typeof r){if("string"!=typeof n)for(var i in n)i in r||(e.style[i]="");for(var i in r)e.style[i]="number"==typeof r[i]&&!1===p.test(i)?r[i]+"px":r[i];}}else if("dangerouslySetInnerHTML"===t)r&&(e.innerHTML=r.__html||"");else if("o"==t[0]&&"n"==t[1]){var u=t!==(t=t.replace(/Capture$/,""));t=t.toLowerCase().substring(2),r?n||e.addEventListener(t,d,u):e.removeEventListener(t,d,u),(e._listeners||(e._listeners={}))[t]=r;}else if("list"!==t&&"type"!==t&&!o&&t in e){try{e[t]=null==r?"":r;}catch(a){}null!=r&&!1!==r||"spellcheck"==t||e.removeAttribute(t);}else{var l=o&&t!==(t=t.replace(/^xlink:?/,""));null==r||!1===r?l?e.removeAttributeNS("http://www.w3.org/1999/xlink",t.toLowerCase()):e.removeAttribute(t):"function"!=typeof r&&(l?e.setAttributeNS("http://www.w3.org/1999/xlink",t.toLowerCase(),r):e.setAttribute(t,r));}else e.className=r||"";}function d(e){return this._listeners[e.type](E.event&&E.event(e)||e)}var M=[],j=0,A=!1,T=!1;function L(){for(var e;e=M.pop();)E.afterMount&&E.afterMount(e),e.componentDidMount&&e.componentDidMount();}function B(e,t,n,r,o,i){j++||(A=null!=o&&o.ownerSVGElement!==undefined,T=null!=e&&!("__preactattr_"in e));var u=F(e,t,n,r,i);return o&&u.parentNode!==o&&o.appendChild(u),--j||(T=!1,i||L()),u}function F(e,t,n,r,o){var i=e,u=A;if(null!=t&&"boolean"!=typeof t||(t=""),"string"==typeof t||"number"==typeof t)return e&&e.splitText!==undefined&&e.parentNode&&(!e._component||o)?e.nodeValue!=t&&(e.nodeValue=t):(i=document.createTextNode(t),e&&(e.parentNode&&e.parentNode.replaceChild(i,e),D(e,!0))),i["__preactattr_"]=!0,i;var l=t.nodeName;if("function"==typeof l)return function d(e,t,n,r){var o=e&&e._component,i=o,u=e,l=o&&e._componentConstructor===t.nodeName,a=l,s=I(t);for(;o&&!a&&(o=o._parentComponent);)a=o.constructor===t.nodeName;o&&a&&(!r||o._component)?(U(o,s,3,n,r),e=o.base):(i&&!l&&(q(i),e=u=null),o=R(t.nodeName,s,n),e&&!o.nextBase&&(o.nextBase=e,u=null),U(o,s,1,n,r),e=o.base,u&&e!==u&&(u._component=null,D(u,!1)));return e}(e,t,n,r);if(A="svg"===l||"foreignObject"!==l&&A,l=String(l),(!e||!k(e,l))&&(i=function h(e,t){var n=t?document.createElementNS("http://www.w3.org/2000/svg",e):document.createElement(e);return n.normalizedNodeName=e,n}(l,A),e)){for(;e.firstChild;)i.appendChild(e.firstChild);e.parentNode&&e.parentNode.replaceChild(i,e),D(e,!0);}var a=i.firstChild,s=i["__preactattr_"],c=t.children;if(null==s){s=i["__preactattr_"]={};for(var p=i.attributes,f=p.length;f--;)s[p[f].name]=p[f].value;}return!T&&c&&1===c.length&&"string"==typeof c[0]&&null!=a&&a.splitText!==undefined&&null==a.nextSibling?a.nodeValue!=c[0]&&(a.nodeValue=c[0]):(c&&c.length||null!=a)&&function S(e,t,n,r,o){var i,u,l,a,s,c=e.childNodes,p=[],f={},d=0,h=0,m=c.length,v=0,y=t?t.length:0;if(0!==m)for(var _=0;_<m;_++){var b=c[_],g=b["__preactattr_"],x=y&&g?b._component?b._component.__key:g.key:null;null!=x?(d++,f[x]=b):(g||(b.splitText!==undefined?!o||b.nodeValue.trim():o))&&(p[v++]=b);}if(0!==y)for(var _=0;_<y;_++){a=t[_],s=null;var x=a.key;if(null!=x)d&&f[x]!==undefined&&(s=f[x],f[x]=undefined,d--);else if(h<v)for(i=h;i<v;i++)if(p[i]!==undefined&&(w=u=p[i],C=o,"string"==typeof(O=a)||"number"==typeof O?w.splitText!==undefined:"string"==typeof O.nodeName?!w._componentConstructor&&k(w,O.nodeName):C||w._componentConstructor===O.nodeName)){s=u,p[i]=undefined,i===v-1&&v--,i===h&&h++;break}s=F(s,a,n,r),l=c[_],s&&s!==e&&s!==l&&(null==l?e.appendChild(s):s===l.nextSibling?P(l):e.insertBefore(s,l));}var w,O,C;if(d)for(var _ in f)f[_]!==undefined&&D(f[_],!1);for(;h<=v;)(s=p[v--])!==undefined&&D(s,!1);}(i,c,n,r,T||null!=s.dangerouslySetInnerHTML),function m(e,t,n){var r;for(r in n)t&&null!=t[r]||null==n[r]||v(e,r,n[r],n[r]=undefined,A);for(r in t)"children"===r||"innerHTML"===r||r in n&&t[r]===("value"===r||"checked"===r?e[r]:n[r])||v(e,r,n[r],n[r]=t[r],A);}(i,t.attributes,s),A=u,i}function D(e,t){var n=e._component;n?q(n):(null!=e["__preactattr_"]&&e["__preactattr_"].ref&&e["__preactattr_"].ref(null),!1!==t&&null!=e["__preactattr_"]||P(e),h(e));}function h(e){for(e=e.lastChild;e;){var t=e.previousSibling;D(e,!0),e=t;}}var m=[];function R(e,t,n){var r,o=m.length;for(e.prototype&&e.prototype.render?(r=new e(t,n),_.call(r,t,n)):((r=new _(t,n)).constructor=e,r.render=y);o--;)if(m[o].constructor===e)return r.nextBase=m[o].nextBase,m.splice(o,1),r;return r}function y(e,t,n){return this.constructor(e,n)}function U(e,t,n,r,o){e._disable||(e._disable=!0,e.__ref=t.ref,e.__key=t.key,delete t.ref,delete t.key,"undefined"==typeof e.constructor.getDerivedStateFromProps&&(!e.base||o?e.componentWillMount&&e.componentWillMount():e.componentWillReceiveProps&&e.componentWillReceiveProps(t,r)),r&&r!==e.context&&(e.prevContext||(e.prevContext=e.context),e.context=r),e.prevProps||(e.prevProps=e.props),e.props=t,e._disable=!1,0!==n&&(1!==n&&!1===E.syncComponentUpdates&&e.base?l(e):V(e,1,o)),e.__ref&&e.__ref(e));}function V(e,t,n,r){if(!e._disable){var o,i,u,l=e.props,a=e.state,s=e.context,c=e.prevProps||l,p=e.prevState||a,f=e.prevContext||s,d=e.base,h=e.nextBase,m=d||h,v=e._component,y=!1,_=f;if(e.constructor.getDerivedStateFromProps&&(a=N(N({},a),e.constructor.getDerivedStateFromProps(l,a)),e.state=a),d&&(e.props=c,e.state=p,e.context=f,2!==t&&e.shouldComponentUpdate&&!1===e.shouldComponentUpdate(l,a,s)?y=!0:e.componentWillUpdate&&e.componentWillUpdate(l,a,s),e.props=l,e.state=a,e.context=s),e.prevProps=e.prevState=e.prevContext=e.nextBase=null,e._dirty=!1,!y){o=e.render(l,a,s),e.getChildContext&&(s=N(N({},s),e.getChildContext())),d&&e.getSnapshotBeforeUpdate&&(_=e.getSnapshotBeforeUpdate(c,p));var b,g,x=o&&o.nodeName;if("function"==typeof x){var w=I(o);(i=v)&&i.constructor===x&&w.key==i.__key?U(i,w,1,s,!1):(b=i,e._component=i=R(x,w,s),i.nextBase=i.nextBase||h,i._parentComponent=e,U(i,w,0,s,!1),V(i,1,n,!0)),g=i.base;}else u=m,(b=v)&&(u=e._component=null),(m||1===t)&&(u&&(u._component=null),g=function B(t,n,r,o,i,u){j++||(A=null!=i&&i.ownerSVGElement!==undefined,T=null!=t&&!("__preactattr_"in t));var l=F(t,n,r,o,u);return i&&l.parentNode!==i&&i.appendChild(l),--j||(T=!1,u||L()),l}(u,o,s,n||!d,m&&m.parentNode,!0));if(m&&g!==m&&i!==v){var O=m.parentNode;O&&g!==O&&(O.replaceChild(g,m),b||(m._component=null,D(m,!1)));}if(b&&q(b),(e.base=g)&&!r){for(var C=e,S=e;S=S._parentComponent;)(C=S).base=g;g._component=C,g._componentConstructor=C.constructor;}}for(!d||n?M.unshift(e):y||(e.componentDidUpdate&&e.componentDidUpdate(c,p,_),E.afterUpdate&&E.afterUpdate(e));e._renderCallbacks.length;)e._renderCallbacks.pop().call(e);j||r||L();}}function q(e){E.beforeUnmount&&E.beforeUnmount(e);var t=e.base;e._disable=!0,e.componentWillUnmount&&e.componentWillUnmount(),e.base=null;var n=e._component;n?q(n):t&&(t["__preactattr_"]&&t["__preactattr_"].ref&&t["__preactattr_"].ref(null),P(e.nextBase=t),m.push(e),h(t)),e.__ref&&e.__ref(null);}function _(e,t){this._dirty=!0,this.context=t,this.props=e,this.state=this.state||{},this._renderCallbacks=[];}function b(e,t,n){return B(n,e,{},!1,t,!1)}N(_.prototype,{setState:function(e,t){this.prevState||(this.prevState=this.state),this.state=N(N({},this.state),"function"==typeof e?e(this.state,this.props):e),t&&this._renderCallbacks.push(t),l(this);},forceUpdate:function(e){e&&this._renderCallbacks.push(e),V(this,2);},render:function b(){}});var g={h:r,createElement:r,cloneElement:i,Component:_,render:b,rerender:f,options:E};t["default"]=g;},function(e,t){var n=e.exports={version:"2.5.7"};"number"==typeof __e&&(__e=n);},function(e,t,n){var r=n(8),o=n(40);e.exports=n(3)?function(e,t,n){return r.f(e,t,o(1,n))}:function(e,t,n){return e[t]=n,e};},function(e,t,n){var o=n(9),i=n(38),u=n(39),l=Object.defineProperty;t.f=n(3)?Object.defineProperty:function(e,t,n){if(o(e),t=u(t,!0),o(n),i)try{return l(e,t,n)}catch(r){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(e[t]=n.value),e};},function(e,t,n){var r=n(2);e.exports=function(e){if(!r(e))throw TypeError(e+" is not an object!");return e};},function(e,t){var n=0,r=Math.random();e.exports=function(e){return"Symbol(".concat(e===undefined?"":e,")_",(++n+r).toString(36))};},function(e,t,n){var r=n(22);e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==r(e)?e.split(""):Object(e)};},function(e,t){e.exports=function(e){if(e==undefined)throw TypeError("Can't call method on  "+e);return e};},function(e,t,n){var r=n(4);e.exports=function(e,t){return!!e&&r(function(){t?e.call(null,function(){},1):e.call(null);})};},function(e,t,n){var r=n(0);r(r.S+r.F,"Object",{assign:n(41)});},function(e,t,n){var r=n(2),o=n(1).document,i=r(o)&&r(o.createElement);e.exports=function(e){return i?o.createElement(e):{}};},function(e,t,n){var i=n(1),u=n(7),l=n(17),a=n(10)("src"),r="toString",o=Function[r],s=(""+o).split(r);n(6).inspectSource=function(e){return o.call(e)},(e.exports=function(e,t,n,r){var o="function"==typeof n;o&&(l(n,"name")||u(n,"name",t)),e[t]!==n&&(o&&(l(n,a)||u(n,a,e[t]?""+e[t]:s.join(String(t)))),e===i?e[t]=n:r?e[t]?e[t]=n:u(e,t,n):(delete e[t],u(e,t,n)));})(Function.prototype,r,function(){return"function"==typeof this&&this[a]||o.call(this)});},function(e,t){var n={}.hasOwnProperty;e.exports=function(e,t){return n.call(e,t)};},function(e,t,n){var i=n(19);e.exports=function(r,o,e){if(i(r),o===undefined)return r;switch(e){case 1:return function(e){return r.call(o,e)};case 2:return function(e,t){return r.call(o,e,t)};case 3:return function(e,t,n){return r.call(o,e,t,n)}}return function(){return r.apply(o,arguments)}};},function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e};},function(e,t,n){var r=n(42),o=n(28);e.exports=Object.keys||function(e){return r(e,o)};},function(e,t,n){var r=n(11),o=n(12);e.exports=function(e){return r(o(e))};},function(e,t){var n={}.toString;e.exports=function(e){return n.call(e).slice(8,-1)};},function(e,t,n){var a=n(21),s=n(24),c=n(43);e.exports=function(l){return function(e,t,n){var r,o=a(e),i=s(o.length),u=c(n,i);if(l&&t!=t){for(;u<i;)if((r=o[u++])!=r)return!0}else for(;u<i;u++)if((l||u in o)&&o[u]===t)return l||u||0;return!l&&-1}};},function(e,t,n){var r=n(25),o=Math.min;e.exports=function(e){return 0<e?o(r(e),9007199254740991):0};},function(e,t){var n=Math.ceil,r=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(0<e?r:n)(e)};},function(e,t,n){var r=n(27)("keys"),o=n(10);e.exports=function(e){return r[e]||(r[e]=o(e))};},function(e,t,n){var r=n(6),o=n(1),i="__core-js_shared__",u=o[i]||(o[i]={});(e.exports=function(e,t){return u[e]||(u[e]=t!==undefined?t:{})})("versions",[]).push({version:r.version,mode:n(44)?"pure":"global",copyright:"© 2018 Denis Pushkarev (zloirock.ru)"});},function(e,t){e.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");},function(e,t,n){var r=n(12);e.exports=function(e){return Object(r(e))};},function(e,t,n){var r=n(8).f,o=Function.prototype,i=/^\s*function ([^ (]*)/;"name"in o||n(3)&&r(o,"name",{configurable:!0,get:function(){try{return(""+this).match(i)[1]}catch(e){return""}}});},function(e,t,n){var r=n(0),o=n(32)(1);r(r.P+r.F*!n(13)([].map,!0),"Array",{map:function(e){return o(this,e,arguments[1])}});},function(e,t,n){var b=n(18),g=n(11),x=n(29),w=n(24),r=n(47);e.exports=function(p,e){var f=1==p,d=2==p,h=3==p,m=4==p,v=6==p,y=5==p||v,_=e||r;return function(e,t,n){for(var r,o,i=x(e),u=g(i),l=b(t,n,3),a=w(u.length),s=0,c=f?_(e,a):d?_(e,0):undefined;s<a;s++)if((y||s in u)&&(o=l(r=u[s],s,i),p))if(f)c[s]=o;else if(o)switch(p){case 3:return!0;case 5:return r;case 6:return s;case 2:c.push(r);}else if(m)return!1;return v?-1:h||m?m:c}};},function(e,t,n){var r=n(22);e.exports=Array.isArray||function(e){return"Array"==r(e)};},function(e,t,n){var r=n(27)("wks"),o=n(10),i=n(1).Symbol,u="function"==typeof i;(e.exports=function(e){return r[e]||(r[e]=u&&i[e]||(u?i:o)("Symbol."+e))}).store=r;},function(e,t,n){var r=n(0),o=n(23)(!1),i=[].indexOf,u=!!i&&1/[1].indexOf(1,-0)<0;r(r.P+r.F*(u||!n(13)(i)),"Array",{indexOf:function(e){return u?i.apply(this,arguments)||0:o(this,e,arguments[1])}});},function(e,t,n){var r=n(0);r(r.S,"Object",{create:n(52)});},function(e,t,n){t.__esModule=!0,t["default"]=void 0,n(14),n(30),n(31),n(35),n(49),n(50);var r=n(5),o=function a(e){return e&&e.__esModule?e:{"default":e}}(n(51));function i(e){if(!e.element)throw new Error("element is not defined");if(!e.id)throw new Error("id is not defined");if(!e.source)throw new Error("source is not defined");Array.isArray(e.source)&&(e.source=u(e.source)),(0, r.render)((0, r.createElement)(o["default"],e),e.element);}var u=function u(n){return function(t,e){e(n.filter(function(e){return-1!==e.toLowerCase().indexOf(t.toLowerCase())}));}};i.enhanceSelectElement=function(n){if(!n.selectElement)throw new Error("selectElement is not defined");if(!n.source){var e=[].filter.call(n.selectElement.options,function(e){return e.value||n.preserveNullOptions});n.source=e.map(function(e){return e.textContent||e.innerText});}if(n.onConfirm=n.onConfirm||function(t){var e=[].filter.call(n.selectElement.options,function(e){return(e.textContent||e.innerText)===t})[0];e&&(e.selected=!0);},n.selectElement.value||n.defaultValue===undefined){var t=n.selectElement.options[n.selectElement.options.selectedIndex];n.defaultValue=t.textContent||t.innerText;}n.name===undefined&&(n.name=""),n.id===undefined&&(n.selectElement.id===undefined?n.id="":n.id=n.selectElement.id),n.autoselect===undefined&&(n.autoselect=!0);var r=document.createElement("span");n.selectElement.parentNode.insertBefore(r,n.selectElement),i(Object.assign({},n,{element:r})),n.selectElement.style.display="none",n.selectElement.id=n.selectElement.id+"-select";};var l=i;t["default"]=l;},function(e,t,n){e.exports=!n(3)&&!n(4)(function(){return 7!=Object.defineProperty(n(15)("div"),"a",{get:function(){return 7}}).a});},function(e,t,n){var o=n(2);e.exports=function(e,t){if(!o(e))return e;var n,r;if(t&&"function"==typeof(n=e.toString)&&!o(r=n.call(e)))return r;if("function"==typeof(n=e.valueOf)&&!o(r=n.call(e)))return r;if(!t&&"function"==typeof(n=e.toString)&&!o(r=n.call(e)))return r;throw TypeError("Can't convert object to primitive value")};},function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}};},function(e,t,n){var f=n(20),d=n(45),h=n(46),m=n(29),v=n(11),o=Object.assign;e.exports=!o||n(4)(function(){var e={},t={},n=Symbol(),r="abcdefghijklmnopqrst";return e[n]=7,r.split("").forEach(function(e){t[e]=e;}),7!=o({},e)[n]||Object.keys(o({},t)).join("")!=r})?function(e,t){for(var n=m(e),r=arguments.length,o=1,i=d.f,u=h.f;o<r;)for(var l,a=v(arguments[o++]),s=i?f(a).concat(i(a)):f(a),c=s.length,p=0;p<c;)u.call(a,l=s[p++])&&(n[l]=a[l]);return n}:o;},function(e,t,n){var u=n(17),l=n(21),a=n(23)(!1),s=n(26)("IE_PROTO");e.exports=function(e,t){var n,r=l(e),o=0,i=[];for(n in r)n!=s&&u(r,n)&&i.push(n);for(;t.length>o;)u(r,n=t[o++])&&(~a(i,n)||i.push(n));return i};},function(e,t,n){var r=n(25),o=Math.max,i=Math.min;e.exports=function(e,t){return(e=r(e))<0?o(e+t,0):i(e,t)};},function(e,t){e.exports=!1;},function(e,t){t.f=Object.getOwnPropertySymbols;},function(e,t){t.f={}.propertyIsEnumerable;},function(e,t,n){var r=n(48);e.exports=function(e,t){return new(r(e))(t)};},function(e,t,n){var r=n(2),o=n(33),i=n(34)("species");e.exports=function(e){var t;return o(e)&&("function"!=typeof(t=e.constructor)||t!==Array&&!o(t.prototype)||(t=undefined),r(t)&&null===(t=t[i])&&(t=undefined)),t===undefined?Array:t};},function(e,t,n){var r=n(0),o=n(32)(2);r(r.P+r.F*!n(13)([].filter,!0),"Array",{filter:function(e){return o(this,e,arguments[1])}});},function(e,t,n){var r=n(0);r(r.S,"Array",{isArray:n(33)});},function(e,t,n){t.__esModule=!0,t["default"]=void 0,n(14),n(36),n(31),n(35),n(30),n(55),n(58);var $=n(5),H=o(n(60)),r=o(n(61));function o(e){return e&&e.__esModule?e:{"default":e}}function Q(){return(Q=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r]);}return e}).apply(this,arguments)}function i(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}var u,l={13:"enter",27:"escape",32:"space",38:"up",40:"down"},z=((u=document.createElement("x")).style.cssText="pointer-events:auto","auto"===u.style.pointerEvents);function f(){return!(!navigator.userAgent.match(/(iPod|iPhone|iPad)/g)||!navigator.userAgent.match(/AppleWebKit/g))}var a=function(n){function e(e){var t;return(t=n.call(this,e)||this).elementReferences={},t.state={focused:null,hovered:null,clicked:null,menuOpen:!1,options:e.defaultValue?[e.defaultValue]:[],query:e.defaultValue,selected:null},t.handleComponentBlur=t.handleComponentBlur.bind(i(i(t))),t.handleKeyDown=t.handleKeyDown.bind(i(i(t))),t.handleUpArrow=t.handleUpArrow.bind(i(i(t))),t.handleDownArrow=t.handleDownArrow.bind(i(i(t))),t.handleEnter=t.handleEnter.bind(i(i(t))),t.handlePrintableKey=t.handlePrintableKey.bind(i(i(t))),t.handleListMouseLeave=t.handleListMouseLeave.bind(i(i(t))),t.handleOptionBlur=t.handleOptionBlur.bind(i(i(t))),t.handleOptionClick=t.handleOptionClick.bind(i(i(t))),t.handleOptionFocus=t.handleOptionFocus.bind(i(i(t))),t.handleOptionMouseEnter=t.handleOptionMouseEnter.bind(i(i(t))),t.handleInputBlur=t.handleInputBlur.bind(i(i(t))),t.handleInputChange=t.handleInputChange.bind(i(i(t))),t.handleInputFocus=t.handleInputFocus.bind(i(i(t))),t.pollInputElement=t.pollInputElement.bind(i(i(t))),t.getDirectInputChanges=t.getDirectInputChanges.bind(i(i(t))),t}(function r(e,t){e.prototype=Object.create(t.prototype),(e.prototype.constructor=e).__proto__=t;})(e,n);var t=e.prototype;return t.componentDidMount=function(){this.pollInputElement();},t.componentWillUnmount=function(){clearTimeout(this.$pollInput),clearTimeout(this.$blurInput);},t.pollInputElement=function(){var e=this;this.getDirectInputChanges(),this.$pollInput=setTimeout(function(){e.pollInputElement();},100);},t.getDirectInputChanges=function(){var e=this.elementReferences[-1];e&&e.value!==this.state.query&&this.handleInputChange({target:{value:e.value}});},t.componentDidUpdate=function(e,t){var n=this.state,r=n.focused,o=n.clicked,i=null===r,u=t.focused!==r;(u&&!i||null!==o)&&this.elementReferences[r].focus();var l=-1===r,a=u&&null===t.focused;if(l&&a){var s=this.elementReferences[r];s.setSelectionRange(0,s.value.length);}},t.hasAutoselect=function(){return!f()&&this.props.autoselect},t.templateInputValue=function(e){var t=this.props.templates&&this.props.templates.inputValue;return t?t(e):e},t.templateSuggestion=function(e){var t=this.props.templates&&this.props.templates.suggestion;return t?t(e):e},t.handleComponentBlur=function(e){var t,n=this.state,r=n.options,o=n.query,i=n.selected;this.props.confirmOnBlur?(t=e.query||o,this.props.onConfirm(r[i])):t=o,this.setState({focused:null,clicked:null,menuOpen:e.menuOpen||!1,query:t,selected:null});},t.handleListMouseLeave=function(e){this.setState({hovered:null});},t.handleOptionBlur=function(e,t){var n=this.state,r=n.focused,o=n.clicked,i=n.menuOpen,u=n.options,l=n.selected,a=null===e.relatedTarget&&null===o,s=e.relatedTarget===this.elementReferences[-1],c=r!==t&&-1!==r;if(!c&&a||!(c||s)){var p=i&&f();this.handleComponentBlur({menuOpen:p,query:this.templateInputValue(u[l])});}},t.handleInputBlur=function(e){var t=this,n=this.state,r=n.focused,o=n.menuOpen,i=n.options,u=n.query,l=n.selected,a=-1!==r;if(clearTimeout(this.$blurInput),!a){var s=o&&f(),c=f()?u:this.templateInputValue(i[l]);this.$blurInput=setTimeout(function(){return t.handleComponentBlur({menuOpen:s,query:c})},200);}},t.handleInputChange=function(e){var n=this,t=this.props,r=t.minLength,o=t.source,i=t.showAllValues,u=this.hasAutoselect(),l=e.target.value,a=0===l.length,s=this.state.query.length!==l.length,c=l.length>=r;this.setState({query:l}),i||!a&&s&&c?o(l,function(e){var t=0<e.length;n.setState({menuOpen:t,options:e,selected:u&&t?0:-1});}):!a&&c||this.setState({menuOpen:!1,options:[]});},t.handleInputClick=function(e){this.handleInputChange(e);},t.handleInputFocus=function(e){this.setState({focused:-1});},t.handleOptionFocus=function(e){this.setState({focused:e,hovered:null,selected:e});},t.handleOptionMouseEnter=function(e,t){f()||this.setState({hovered:t});},t.handleOptionClick=function(e,t){var n=this.state.options[t],r=this.templateInputValue(n);clearTimeout(this.$blurInput),this.props.onConfirm(n),this.setState({focused:-1,clicked:t,hovered:null,menuOpen:!1,query:r,selected:-1}),this.forceUpdate();},t.handleUpArrow=function(e){e.preventDefault();var t=this.state,n=t.menuOpen,r=t.selected;-1!==r&&n&&this.handleOptionFocus(r-1);},t.handleDownArrow=function(e){var t=this;if(e.preventDefault(),this.props.showAllValues&&!1===this.state.menuOpen)e.preventDefault(),this.props.source("",function(e){t.setState({menuOpen:!0,options:e,selected:0,focused:0,hovered:null});});else if(!0===this.state.menuOpen){var n=this.state,r=n.menuOpen,o=n.options,i=n.selected;i!==o.length-1&&r&&this.handleOptionFocus(i+1);}},t.handleSpace=function(e){var t=this;this.props.showAllValues&&!1===this.state.menuOpen&&""===this.state.query&&(e.preventDefault(),this.props.source("",function(e){t.setState({menuOpen:!0,options:e});})),-1!==this.state.focused&&(e.preventDefault(),this.handleOptionClick(e,this.state.focused));},t.handleEnter=function(e){this.state.menuOpen&&(e.preventDefault(),0<=this.state.selected&&this.handleOptionClick(e,this.state.selected));},t.handlePrintableKey=function(e){var t=this.elementReferences[-1];e.target===t||t.focus();},t.handleKeyDown=function(e){switch(l[e.keyCode]){case"up":this.handleUpArrow(e);break;case"down":this.handleDownArrow(e);break;case"space":this.handleSpace(e);break;case"enter":this.handleEnter(e);break;case"escape":this.handleComponentBlur({query:this.state.query});break;default:(function t(e){return 47<e&&e<58||32===e||8===e||64<e&&e<91||95<e&&e<112||185<e&&e<193||218<e&&e<223})(e.keyCode)&&this.handlePrintableKey(e);}},t.render=function(){var e,o=this,t=this.props,n=t.cssNamespace,r=t.displayMenu,i=t.id,u=t.minLength,l=t.name,a=t.placeholder,s=t.required,c=t.showAllValues,p=t.tNoResults,f=t.tStatusQueryTooShort,d=t.tStatusNoResults,h=t.tStatusSelectedOption,m=t.tStatusResults,v=t.dropdownArrow,y=this.state,_=y.focused,b=y.hovered,g=y.menuOpen,x=y.options,w=y.query,O=y.selected,C=this.hasAutoselect(),S=-1===_,E=0===x.length,N=0!==w.length,k=w.length>=u,I=this.props.showNoOptionsFound&&S&&E&&N&&k,P=n+"__wrapper",M=n+"__input",j=null!==_?" "+M+"--focused":"",A=this.props.showAllValues?" "+M+"--show-all-values":" "+M+"--default",T=n+"__dropdown-arrow-down",L=-1!==_&&null!==_,B=n+"__menu",F=B+"--"+r,D=B+"--"+(g||I?"visible":"hidden"),R=n+"__option",U=n+"__hint",V=this.templateInputValue(x[O]),q=V&&0===V.toLowerCase().indexOf(w.toLowerCase())&&C?w+V.substr(w.length):"",W=z&&q;return c&&"string"==typeof(e=v({className:T}))&&(e=(0, $.createElement)("div",{className:n+"__dropdown-arrow-down-wrapper",dangerouslySetInnerHTML:{__html:e}})),(0, $.createElement)("div",{className:P,onKeyDown:this.handleKeyDown,role:"combobox","aria-expanded":g?"true":"false"},(0, $.createElement)(H["default"],{length:x.length,queryLength:w.length,minQueryLength:u,selectedOption:this.templateInputValue(x[O]),selectedOptionIndex:O,tQueryTooShort:f,tNoResults:d,tSelectedOption:h,tResults:m}),W&&(0, $.createElement)("span",null,(0, $.createElement)("input",{className:U,readonly:!0,tabIndex:"-1",value:q})),(0, $.createElement)("input",Q({"aria-activedescendant":!!L&&i+"__option--"+_,"aria-owns":i+"__listbox",autoComplete:"off",className:""+M+j+A,id:i,onClick:function(e){return o.handleInputClick(e)},onBlur:this.handleInputBlur},function K(e){return{onInput:e}}(this.handleInputChange),{onFocus:this.handleInputFocus,name:l,placeholder:a,ref:function(e){o.elementReferences[-1]=e;},type:"text",role:"textbox",required:s,value:w})),e,(0, $.createElement)("ul",{className:B+" "+F+" "+D,onMouseLeave:function(e){return o.handleListMouseLeave(e)},id:i+"__listbox",role:"listbox"},x.map(function(e,t){var n=(-1===_?O===t:_===t)&&null===b?" "+R+"--focused":"",r=t%2?" "+R+"--odd":"";return(0, $.createElement)("li",{"aria-selected":_===t,className:""+R+n+r,dangerouslySetInnerHTML:{__html:o.templateSuggestion(e)},id:i+"__option--"+t,key:t,onBlur:function(e){return o.handleOptionBlur(e,t)},onClick:function(e){return o.handleOptionClick(e,t)},onMouseEnter:function(e){return o.handleOptionMouseEnter(e,t)},ref:function(e){o.elementReferences[t]=e;},role:"option",tabIndex:"-1"})}),I&&(0, $.createElement)("li",{className:R+" "+R+"--no-results"},p())))},e}($.Component);(t["default"]=a).defaultProps={autoselect:!1,cssNamespace:"autocomplete",defaultValue:"",displayMenu:"inline",minLength:0,name:"input-autocomplete",placeholder:"",onConfirm:function(){},confirmOnBlur:!0,showNoOptionsFound:!0,showAllValues:!1,required:!1,tNoResults:function(){return"No results found"},dropdownArrow:r["default"]};},function(e,t,r){var o=r(9),i=r(53),u=r(28),l=r(26)("IE_PROTO"),a=function(){},s="prototype",c=function(){var e,t=r(15)("iframe"),n=u.length;for(t.style.display="none",r(54).appendChild(t),t.src="javascript:",(e=t.contentWindow.document).open(),e.write("<script>document.F=Object<\/script>"),e.close(),c=e.F;n--;)delete c[s][u[n]];return c()};e.exports=Object.create||function(e,t){var n;return null!==e?(a[s]=o(e),n=new a,a[s]=null,n[l]=e):n=c(),t===undefined?n:i(n,t)};},function(e,t,n){var u=n(8),l=n(9),a=n(20);e.exports=n(3)?Object.defineProperties:function(e,t){l(e);for(var n,r=a(t),o=r.length,i=0;i<o;)u.f(e,n=r[i++],t[n]);return e};},function(e,t,n){var r=n(1).document;e.exports=r&&r.documentElement;},function(e,t,n){var r=n(0);r(r.P,"Function",{bind:n(56)});},function(e,t,n){var i=n(19),u=n(2),l=n(57),a=[].slice,s={};e.exports=Function.bind||function(t){var n=i(this),r=a.call(arguments,1),o=function(){var e=r.concat(a.call(arguments));return this instanceof o?function(e,t,n){if(!(t in s)){for(var r=[],o=0;o<t;o++)r[o]="a["+o+"]";s[t]=Function("F,a","return new F("+r.join(",")+")");}return s[t](e,n)}(n,e.length,e):l(n,e,t)};return u(n.prototype)&&(o.prototype=n.prototype),o};},function(e,t){e.exports=function(e,t,n){var r=n===undefined;switch(t.length){case 0:return r?e():e.call(n);case 1:return r?e(t[0]):e.call(n,t[0]);case 2:return r?e(t[0],t[1]):e.call(n,t[0],t[1]);case 3:return r?e(t[0],t[1],t[2]):e.call(n,t[0],t[1],t[2]);case 4:return r?e(t[0],t[1],t[2],t[3]):e.call(n,t[0],t[1],t[2],t[3])}return e.apply(n,t)};},function(e,t,n){n(59)("match",1,function(r,o,e){return[function(e){var t=r(this),n=e==undefined?undefined:e[o];return n!==undefined?n.call(e,t):new RegExp(e)[o](String(t))},e]});},function(e,t,n){var l=n(7),a=n(16),s=n(4),c=n(12),p=n(34);e.exports=function(t,e,n){var r=p(t),o=n(c,r,""[t]),i=o[0],u=o[1];s(function(){var e={};return e[r]=function(){return 7},7!=""[t](e)})&&(a(String.prototype,t,i),l(RegExp.prototype,r,2==e?function(e,t){return u.call(e,this,t)}:function(e){return u.call(e,this)}));};},function(e,t,n){t.__esModule=!0,t["default"]=void 0,n(36);var m=n(5);var r=function(o){function e(){for(var e,t=arguments.length,n=new Array(t),r=0;r<t;r++)n[r]=arguments[r];return(e=o.call.apply(o,[this].concat(n))||this).state={bump:!1},e}(function n(e,t){e.prototype=Object.create(t.prototype),(e.prototype.constructor=e).__proto__=t;})(e,o);var t=e.prototype;return t.componentWillReceiveProps=function(e){e.queryLength!==this.props.queryLength&&this.setState(function(e){return{bump:!e.bump}});},t.render=function(){var e=this.props,t=e.length,n=e.queryLength,r=e.minQueryLength,o=e.selectedOption,i=e.selectedOptionIndex,u=e.tQueryTooShort,l=e.tNoResults,a=e.tSelectedOption,s=e.tResults,c=this.state.bump,p=n<r,f=0===t,d=o?a(o,t,i):"",h=null;return h=p?u(r):f?l():s(t,d),(0, m.createElement)("div",{"aria-atomic":"true","aria-live":"polite",role:"status",style:{border:"0",clip:"rect(0 0 0 0)",height:"1px",marginBottom:"-1px",marginRight:"-1px",overflow:"hidden",padding:"0",position:"absolute",whiteSpace:"nowrap",width:"1px"}},h,(0, m.createElement)("span",null,c?",":",,"))},e}(m.Component);(t["default"]=r).defaultProps={tQueryTooShort:function(e){return"Type in "+e+" or more characters for results."},tNoResults:function(){return"No search results."},tSelectedOption:function(e,t,n){return e+" ("+(n+1)+" of "+t+") is selected."},tResults:function(e,t){return e+" "+(1===e?"result":"results")+" "+(1===e?"is":"are")+" available. "+t}};},function(e,t,n){t.__esModule=!0,t["default"]=void 0;var r=n(5),o=function i(e){var t=e.className;return(0, r.createElement)("svg",{version:"1.1",xmlns:"http://www.w3.org/2000/svg",className:t,focusable:"false"},(0, r.createElement)("g",{stroke:"none",fill:"none","fill-rule":"evenodd"},(0, r.createElement)("polygon",{fill:"#000000",points:"0 0 22 0 11 17"})))};t["default"]=o;}])["default"]});

	});

	var accessibleAutocomplete = unwrapExports(accessibleAutocomplete_min);

	var lunr = createCommonjsModule(function (module, exports) {
	(function(){

	/**
	 * A convenience function for configuring and constructing
	 * a new lunr Index.
	 *
	 * A lunr.Builder instance is created and the pipeline setup
	 * with a trimmer, stop word filter and stemmer.
	 *
	 * This builder object is yielded to the configuration function
	 * that is passed as a parameter, allowing the list of fields
	 * and other builder parameters to be customised.
	 *
	 * All documents _must_ be added within the passed config function.
	 *
	 * @example
	 * var idx = lunr(function () {
	 *   this.field('title')
	 *   this.field('body')
	 *   this.ref('id')
	 *
	 *   documents.forEach(function (doc) {
	 *     this.add(doc)
	 *   }, this)
	 * })
	 *
	 * @see {@link lunr.Builder}
	 * @see {@link lunr.Pipeline}
	 * @see {@link lunr.trimmer}
	 * @see {@link lunr.stopWordFilter}
	 * @see {@link lunr.stemmer}
	 * @namespace {function} lunr
	 */
	var lunr = function (config) {
	  var builder = new lunr.Builder;

	  builder.pipeline.add(
	    lunr.trimmer,
	    lunr.stopWordFilter,
	    lunr.stemmer
	  );

	  builder.searchPipeline.add(
	    lunr.stemmer
	  );

	  config.call(builder, builder);
	  return builder.build()
	};

	lunr.version = "2.3.1";
	/*!
	 * lunr.utils
	 * Copyright (C) 2018 Oliver Nightingale
	 */

	/**
	 * A namespace containing utils for the rest of the lunr library
	 * @namespace lunr.utils
	 */
	lunr.utils = {};

	/**
	 * Print a warning message to the console.
	 *
	 * @param {String} message The message to be printed.
	 * @memberOf lunr.utils
	 * @function
	 */
	lunr.utils.warn = (function (global) {
	  /* eslint-disable no-console */
	  return function (message) {
	    if (global.console && console.warn) {
	      console.warn(message);
	    }
	  }
	  /* eslint-enable no-console */
	})(this);

	/**
	 * Convert an object to a string.
	 *
	 * In the case of `null` and `undefined` the function returns
	 * the empty string, in all other cases the result of calling
	 * `toString` on the passed object is returned.
	 *
	 * @param {Any} obj The object to convert to a string.
	 * @return {String} string representation of the passed object.
	 * @memberOf lunr.utils
	 */
	lunr.utils.asString = function (obj) {
	  if (obj === void 0 || obj === null) {
	    return ""
	  } else {
	    return obj.toString()
	  }
	};

	/**
	 * Clones an object.
	 *
	 * Will create a copy of an existing object such that any mutations
	 * on the copy cannot affect the original.
	 *
	 * Only shallow objects are supported, passing a nested object to this
	 * function will cause a TypeError.
	 *
	 * Objects with primitives, and arrays of primitives are supported.
	 *
	 * @param {Object} obj The object to clone.
	 * @return {Object} a clone of the passed object.
	 * @throws {TypeError} when a nested object is passed.
	 * @memberOf Utils
	 */
	lunr.utils.clone = function (obj) {
	  if (obj === null || obj === undefined) {
	    return obj
	  }

	  var clone = Object.create(null),
	      keys = Object.keys(obj);

	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i],
	        val = obj[key];

	    if (Array.isArray(val)) {
	      clone[key] = val.slice();
	      continue
	    }

	    if (typeof val === 'string' ||
	        typeof val === 'number' ||
	        typeof val === 'boolean') {
	      clone[key] = val;
	      continue
	    }

	    throw new TypeError("clone is not deep and does not support nested objects")
	  }

	  return clone
	};
	lunr.FieldRef = function (docRef, fieldName, stringValue) {
	  this.docRef = docRef;
	  this.fieldName = fieldName;
	  this._stringValue = stringValue;
	};

	lunr.FieldRef.joiner = "/";

	lunr.FieldRef.fromString = function (s) {
	  var n = s.indexOf(lunr.FieldRef.joiner);

	  if (n === -1) {
	    throw "malformed field ref string"
	  }

	  var fieldRef = s.slice(0, n),
	      docRef = s.slice(n + 1);

	  return new lunr.FieldRef (docRef, fieldRef, s)
	};

	lunr.FieldRef.prototype.toString = function () {
	  if (this._stringValue == undefined) {
	    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef;
	  }

	  return this._stringValue
	};
	/*!
	 * lunr.Set
	 * Copyright (C) 2018 Oliver Nightingale
	 */

	/**
	 * A lunr set.
	 *
	 * @constructor
	 */
	lunr.Set = function (elements) {
	  this.elements = Object.create(null);

	  if (elements) {
	    this.length = elements.length;

	    for (var i = 0; i < this.length; i++) {
	      this.elements[elements[i]] = true;
	    }
	  } else {
	    this.length = 0;
	  }
	};

	/**
	 * A complete set that contains all elements.
	 *
	 * @static
	 * @readonly
	 * @type {lunr.Set}
	 */
	lunr.Set.complete = {
	  intersect: function (other) {
	    return other
	  },

	  union: function (other) {
	    return other
	  },

	  contains: function () {
	    return true
	  }
	};

	/**
	 * An empty set that contains no elements.
	 *
	 * @static
	 * @readonly
	 * @type {lunr.Set}
	 */
	lunr.Set.empty = {
	  intersect: function () {
	    return this
	  },

	  union: function (other) {
	    return other
	  },

	  contains: function () {
	    return false
	  }
	};

	/**
	 * Returns true if this set contains the specified object.
	 *
	 * @param {object} object - Object whose presence in this set is to be tested.
	 * @returns {boolean} - True if this set contains the specified object.
	 */
	lunr.Set.prototype.contains = function (object) {
	  return !!this.elements[object]
	};

	/**
	 * Returns a new set containing only the elements that are present in both
	 * this set and the specified set.
	 *
	 * @param {lunr.Set} other - set to intersect with this set.
	 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
	 */

	lunr.Set.prototype.intersect = function (other) {
	  var a, b, elements, intersection = [];

	  if (other === lunr.Set.complete) {
	    return this
	  }

	  if (other === lunr.Set.empty) {
	    return other
	  }

	  if (this.length < other.length) {
	    a = this;
	    b = other;
	  } else {
	    a = other;
	    b = this;
	  }

	  elements = Object.keys(a.elements);

	  for (var i = 0; i < elements.length; i++) {
	    var element = elements[i];
	    if (element in b.elements) {
	      intersection.push(element);
	    }
	  }

	  return new lunr.Set (intersection)
	};

	/**
	 * Returns a new set combining the elements of this and the specified set.
	 *
	 * @param {lunr.Set} other - set to union with this set.
	 * @return {lunr.Set} a new set that is the union of this and the specified set.
	 */

	lunr.Set.prototype.union = function (other) {
	  if (other === lunr.Set.complete) {
	    return lunr.Set.complete
	  }

	  if (other === lunr.Set.empty) {
	    return this
	  }

	  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
	};
	/**
	 * A function to calculate the inverse document frequency for
	 * a posting. This is shared between the builder and the index
	 *
	 * @private
	 * @param {object} posting - The posting for a given term
	 * @param {number} documentCount - The total number of documents.
	 */
	lunr.idf = function (posting, documentCount) {
	  var documentsWithTerm = 0;

	  for (var fieldName in posting) {
	    if (fieldName == '_index') continue // Ignore the term index, its not a field
	    documentsWithTerm += Object.keys(posting[fieldName]).length;
	  }

	  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5);

	  return Math.log(1 + Math.abs(x))
	};

	/**
	 * A token wraps a string representation of a token
	 * as it is passed through the text processing pipeline.
	 *
	 * @constructor
	 * @param {string} [str=''] - The string token being wrapped.
	 * @param {object} [metadata={}] - Metadata associated with this token.
	 */
	lunr.Token = function (str, metadata) {
	  this.str = str || "";
	  this.metadata = metadata || {};
	};

	/**
	 * Returns the token string that is being wrapped by this object.
	 *
	 * @returns {string}
	 */
	lunr.Token.prototype.toString = function () {
	  return this.str
	};

	/**
	 * A token update function is used when updating or optionally
	 * when cloning a token.
	 *
	 * @callback lunr.Token~updateFunction
	 * @param {string} str - The string representation of the token.
	 * @param {Object} metadata - All metadata associated with this token.
	 */

	/**
	 * Applies the given function to the wrapped string token.
	 *
	 * @example
	 * token.update(function (str, metadata) {
	 *   return str.toUpperCase()
	 * })
	 *
	 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
	 * @returns {lunr.Token}
	 */
	lunr.Token.prototype.update = function (fn) {
	  this.str = fn(this.str, this.metadata);
	  return this
	};

	/**
	 * Creates a clone of this token. Optionally a function can be
	 * applied to the cloned token.
	 *
	 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
	 * @returns {lunr.Token}
	 */
	lunr.Token.prototype.clone = function (fn) {
	  fn = fn || function (s) { return s };
	  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
	};
	/*!
	 * lunr.tokenizer
	 * Copyright (C) 2018 Oliver Nightingale
	 */

	/**
	 * A function for splitting a string into tokens ready to be inserted into
	 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
	 * the value of this property to change how strings are split into tokens.
	 *
	 * This tokenizer will convert its parameter to a string by calling `toString` and
	 * then will split this string on the character in `lunr.tokenizer.separator`.
	 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
	 *
	 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
	 * added as metadata to every token that is created from the object to be tokenized.
	 *
	 * @static
	 * @param {?(string|object|object[])} obj - The object to convert into tokens
	 * @param {?object} metadata - Optional metadata to associate with every token
	 * @returns {lunr.Token[]}
	 * @see {@link lunr.Pipeline}
	 */
	lunr.tokenizer = function (obj, metadata) {
	  if (obj == null || obj == undefined) {
	    return []
	  }

	  if (Array.isArray(obj)) {
	    return obj.map(function (t) {
	      return new lunr.Token(
	        lunr.utils.asString(t).toLowerCase(),
	        lunr.utils.clone(metadata)
	      )
	    })
	  }

	  var str = obj.toString().trim().toLowerCase(),
	      len = str.length,
	      tokens = [];

	  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
	    var char = str.charAt(sliceEnd),
	        sliceLength = sliceEnd - sliceStart;

	    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

	      if (sliceLength > 0) {
	        var tokenMetadata = lunr.utils.clone(metadata) || {};
	        tokenMetadata["position"] = [sliceStart, sliceLength];
	        tokenMetadata["index"] = tokens.length;

	        tokens.push(
	          new lunr.Token (
	            str.slice(sliceStart, sliceEnd),
	            tokenMetadata
	          )
	        );
	      }

	      sliceStart = sliceEnd + 1;
	    }

	  }

	  return tokens
	};

	/**
	 * The separator used to split a string into tokens. Override this property to change the behaviour of
	 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
	 *
	 * @static
	 * @see lunr.tokenizer
	 */
	lunr.tokenizer.separator = /[\s\-]+/;
	/*!
	 * lunr.Pipeline
	 * Copyright (C) 2018 Oliver Nightingale
	 */

	/**
	 * lunr.Pipelines maintain an ordered list of functions to be applied to all
	 * tokens in documents entering the search index and queries being ran against
	 * the index.
	 *
	 * An instance of lunr.Index created with the lunr shortcut will contain a
	 * pipeline with a stop word filter and an English language stemmer. Extra
	 * functions can be added before or after either of these functions or these
	 * default functions can be removed.
	 *
	 * When run the pipeline will call each function in turn, passing a token, the
	 * index of that token in the original list of all tokens and finally a list of
	 * all the original tokens.
	 *
	 * The output of functions in the pipeline will be passed to the next function
	 * in the pipeline. To exclude a token from entering the index the function
	 * should return undefined, the rest of the pipeline will not be called with
	 * this token.
	 *
	 * For serialisation of pipelines to work, all functions used in an instance of
	 * a pipeline should be registered with lunr.Pipeline. Registered functions can
	 * then be loaded. If trying to load a serialised pipeline that uses functions
	 * that are not registered an error will be thrown.
	 *
	 * If not planning on serialising the pipeline then registering pipeline functions
	 * is not necessary.
	 *
	 * @constructor
	 */
	lunr.Pipeline = function () {
	  this._stack = [];
	};

	lunr.Pipeline.registeredFunctions = Object.create(null);

	/**
	 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
	 * string as well as all known metadata. A pipeline function can mutate the token string
	 * or mutate (or add) metadata for a given token.
	 *
	 * A pipeline function can indicate that the passed token should be discarded by returning
	 * null. This token will not be passed to any downstream pipeline functions and will not be
	 * added to the index.
	 *
	 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
	 * to any downstream pipeline functions and all will returned tokens will be added to the index.
	 *
	 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
	 *
	 * @interface lunr.PipelineFunction
	 * @param {lunr.Token} token - A token from the document being processed.
	 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
	 * @param {lunr.Token[]} tokens - All tokens for this document/field.
	 * @returns {(?lunr.Token|lunr.Token[])}
	 */

	/**
	 * Register a function with the pipeline.
	 *
	 * Functions that are used in the pipeline should be registered if the pipeline
	 * needs to be serialised, or a serialised pipeline needs to be loaded.
	 *
	 * Registering a function does not add it to a pipeline, functions must still be
	 * added to instances of the pipeline for them to be used when running a pipeline.
	 *
	 * @param {lunr.PipelineFunction} fn - The function to check for.
	 * @param {String} label - The label to register this function with
	 */
	lunr.Pipeline.registerFunction = function (fn, label) {
	  if (label in this.registeredFunctions) {
	    lunr.utils.warn('Overwriting existing registered function: ' + label);
	  }

	  fn.label = label;
	  lunr.Pipeline.registeredFunctions[fn.label] = fn;
	};

	/**
	 * Warns if the function is not registered as a Pipeline function.
	 *
	 * @param {lunr.PipelineFunction} fn - The function to check for.
	 * @private
	 */
	lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
	  var isRegistered = fn.label && (fn.label in this.registeredFunctions);

	  if (!isRegistered) {
	    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn);
	  }
	};

	/**
	 * Loads a previously serialised pipeline.
	 *
	 * All functions to be loaded must already be registered with lunr.Pipeline.
	 * If any function from the serialised data has not been registered then an
	 * error will be thrown.
	 *
	 * @param {Object} serialised - The serialised pipeline to load.
	 * @returns {lunr.Pipeline}
	 */
	lunr.Pipeline.load = function (serialised) {
	  var pipeline = new lunr.Pipeline;

	  serialised.forEach(function (fnName) {
	    var fn = lunr.Pipeline.registeredFunctions[fnName];

	    if (fn) {
	      pipeline.add(fn);
	    } else {
	      throw new Error('Cannot load unregistered function: ' + fnName)
	    }
	  });

	  return pipeline
	};

	/**
	 * Adds new functions to the end of the pipeline.
	 *
	 * Logs a warning if the function has not been registered.
	 *
	 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
	 */
	lunr.Pipeline.prototype.add = function () {
	  var fns = Array.prototype.slice.call(arguments);

	  fns.forEach(function (fn) {
	    lunr.Pipeline.warnIfFunctionNotRegistered(fn);
	    this._stack.push(fn);
	  }, this);
	};

	/**
	 * Adds a single function after a function that already exists in the
	 * pipeline.
	 *
	 * Logs a warning if the function has not been registered.
	 *
	 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
	 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
	 */
	lunr.Pipeline.prototype.after = function (existingFn, newFn) {
	  lunr.Pipeline.warnIfFunctionNotRegistered(newFn);

	  var pos = this._stack.indexOf(existingFn);
	  if (pos == -1) {
	    throw new Error('Cannot find existingFn')
	  }

	  pos = pos + 1;
	  this._stack.splice(pos, 0, newFn);
	};

	/**
	 * Adds a single function before a function that already exists in the
	 * pipeline.
	 *
	 * Logs a warning if the function has not been registered.
	 *
	 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
	 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
	 */
	lunr.Pipeline.prototype.before = function (existingFn, newFn) {
	  lunr.Pipeline.warnIfFunctionNotRegistered(newFn);

	  var pos = this._stack.indexOf(existingFn);
	  if (pos == -1) {
	    throw new Error('Cannot find existingFn')
	  }

	  this._stack.splice(pos, 0, newFn);
	};

	/**
	 * Removes a function from the pipeline.
	 *
	 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
	 */
	lunr.Pipeline.prototype.remove = function (fn) {
	  var pos = this._stack.indexOf(fn);
	  if (pos == -1) {
	    return
	  }

	  this._stack.splice(pos, 1);
	};

	/**
	 * Runs the current list of functions that make up the pipeline against the
	 * passed tokens.
	 *
	 * @param {Array} tokens The tokens to run through the pipeline.
	 * @returns {Array}
	 */
	lunr.Pipeline.prototype.run = function (tokens) {
	  var stackLength = this._stack.length;

	  for (var i = 0; i < stackLength; i++) {
	    var fn = this._stack[i];
	    var memo = [];

	    for (var j = 0; j < tokens.length; j++) {
	      var result = fn(tokens[j], j, tokens);

	      if (result === void 0 || result === '') continue

	      if (result instanceof Array) {
	        for (var k = 0; k < result.length; k++) {
	          memo.push(result[k]);
	        }
	      } else {
	        memo.push(result);
	      }
	    }

	    tokens = memo;
	  }

	  return tokens
	};

	/**
	 * Convenience method for passing a string through a pipeline and getting
	 * strings out. This method takes care of wrapping the passed string in a
	 * token and mapping the resulting tokens back to strings.
	 *
	 * @param {string} str - The string to pass through the pipeline.
	 * @param {?object} metadata - Optional metadata to associate with the token
	 * passed to the pipeline.
	 * @returns {string[]}
	 */
	lunr.Pipeline.prototype.runString = function (str, metadata) {
	  var token = new lunr.Token (str, metadata);

	  return this.run([token]).map(function (t) {
	    return t.toString()
	  })
	};

	/**
	 * Resets the pipeline by removing any existing processors.
	 *
	 */
	lunr.Pipeline.prototype.reset = function () {
	  this._stack = [];
	};

	/**
	 * Returns a representation of the pipeline ready for serialisation.
	 *
	 * Logs a warning if the function has not been registered.
	 *
	 * @returns {Array}
	 */
	lunr.Pipeline.prototype.toJSON = function () {
	  return this._stack.map(function (fn) {
	    lunr.Pipeline.warnIfFunctionNotRegistered(fn);

	    return fn.label
	  })
	};
	/*!
	 * lunr.Vector
	 * Copyright (C) 2018 Oliver Nightingale
	 */

	/**
	 * A vector is used to construct the vector space of documents and queries. These
	 * vectors support operations to determine the similarity between two documents or
	 * a document and a query.
	 *
	 * Normally no parameters are required for initializing a vector, but in the case of
	 * loading a previously dumped vector the raw elements can be provided to the constructor.
	 *
	 * For performance reasons vectors are implemented with a flat array, where an elements
	 * index is immediately followed by its value. E.g. [index, value, index, value]. This
	 * allows the underlying array to be as sparse as possible and still offer decent
	 * performance when being used for vector calculations.
	 *
	 * @constructor
	 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
	 */
	lunr.Vector = function (elements) {
	  this._magnitude = 0;
	  this.elements = elements || [];
	};


	/**
	 * Calculates the position within the vector to insert a given index.
	 *
	 * This is used internally by insert and upsert. If there are duplicate indexes then
	 * the position is returned as if the value for that index were to be updated, but it
	 * is the callers responsibility to check whether there is a duplicate at that index
	 *
	 * @param {Number} insertIdx - The index at which the element should be inserted.
	 * @returns {Number}
	 */
	lunr.Vector.prototype.positionForIndex = function (index) {
	  // For an empty vector the tuple can be inserted at the beginning
	  if (this.elements.length == 0) {
	    return 0
	  }

	  var start = 0,
	      end = this.elements.length / 2,
	      sliceLength = end - start,
	      pivotPoint = Math.floor(sliceLength / 2),
	      pivotIndex = this.elements[pivotPoint * 2];

	  while (sliceLength > 1) {
	    if (pivotIndex < index) {
	      start = pivotPoint;
	    }

	    if (pivotIndex > index) {
	      end = pivotPoint;
	    }

	    if (pivotIndex == index) {
	      break
	    }

	    sliceLength = end - start;
	    pivotPoint = start + Math.floor(sliceLength / 2);
	    pivotIndex = this.elements[pivotPoint * 2];
	  }

	  if (pivotIndex == index) {
	    return pivotPoint * 2
	  }

	  if (pivotIndex > index) {
	    return pivotPoint * 2
	  }

	  if (pivotIndex < index) {
	    return (pivotPoint + 1) * 2
	  }
	};

	/**
	 * Inserts an element at an index within the vector.
	 *
	 * Does not allow duplicates, will throw an error if there is already an entry
	 * for this index.
	 *
	 * @param {Number} insertIdx - The index at which the element should be inserted.
	 * @param {Number} val - The value to be inserted into the vector.
	 */
	lunr.Vector.prototype.insert = function (insertIdx, val) {
	  this.upsert(insertIdx, val, function () {
	    throw "duplicate index"
	  });
	};

	/**
	 * Inserts or updates an existing index within the vector.
	 *
	 * @param {Number} insertIdx - The index at which the element should be inserted.
	 * @param {Number} val - The value to be inserted into the vector.
	 * @param {function} fn - A function that is called for updates, the existing value and the
	 * requested value are passed as arguments
	 */
	lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
	  this._magnitude = 0;
	  var position = this.positionForIndex(insertIdx);

	  if (this.elements[position] == insertIdx) {
	    this.elements[position + 1] = fn(this.elements[position + 1], val);
	  } else {
	    this.elements.splice(position, 0, insertIdx, val);
	  }
	};

	/**
	 * Calculates the magnitude of this vector.
	 *
	 * @returns {Number}
	 */
	lunr.Vector.prototype.magnitude = function () {
	  if (this._magnitude) return this._magnitude

	  var sumOfSquares = 0,
	      elementsLength = this.elements.length;

	  for (var i = 1; i < elementsLength; i += 2) {
	    var val = this.elements[i];
	    sumOfSquares += val * val;
	  }

	  return this._magnitude = Math.sqrt(sumOfSquares)
	};

	/**
	 * Calculates the dot product of this vector and another vector.
	 *
	 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
	 * @returns {Number}
	 */
	lunr.Vector.prototype.dot = function (otherVector) {
	  var dotProduct = 0,
	      a = this.elements, b = otherVector.elements,
	      aLen = a.length, bLen = b.length,
	      aVal = 0, bVal = 0,
	      i = 0, j = 0;

	  while (i < aLen && j < bLen) {
	    aVal = a[i], bVal = b[j];
	    if (aVal < bVal) {
	      i += 2;
	    } else if (aVal > bVal) {
	      j += 2;
	    } else if (aVal == bVal) {
	      dotProduct += a[i + 1] * b[j + 1];
	      i += 2;
	      j += 2;
	    }
	  }

	  return dotProduct
	};

	/**
	 * Calculates the similarity between this vector and another vector.
	 *
	 * @param {lunr.Vector} otherVector - The other vector to calculate the
	 * similarity with.
	 * @returns {Number}
	 */
	lunr.Vector.prototype.similarity = function (otherVector) {
	  return this.dot(otherVector) / this.magnitude() || 0
	};

	/**
	 * Converts the vector to an array of the elements within the vector.
	 *
	 * @returns {Number[]}
	 */
	lunr.Vector.prototype.toArray = function () {
	  var output = new Array (this.elements.length / 2);

	  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
	    output[j] = this.elements[i];
	  }

	  return output
	};

	/**
	 * A JSON serializable representation of the vector.
	 *
	 * @returns {Number[]}
	 */
	lunr.Vector.prototype.toJSON = function () {
	  return this.elements
	};
	/* eslint-disable */
	/*!
	 * lunr.stemmer
	 * Copyright (C) 2018 Oliver Nightingale
	 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
	 */

	/**
	 * lunr.stemmer is an english language stemmer, this is a JavaScript
	 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
	 *
	 * @static
	 * @implements {lunr.PipelineFunction}
	 * @param {lunr.Token} token - The string to stem
	 * @returns {lunr.Token}
	 * @see {@link lunr.Pipeline}
	 * @function
	 */
	lunr.stemmer = (function(){
	  var step2list = {
	      "ational" : "ate",
	      "tional" : "tion",
	      "enci" : "ence",
	      "anci" : "ance",
	      "izer" : "ize",
	      "bli" : "ble",
	      "alli" : "al",
	      "entli" : "ent",
	      "eli" : "e",
	      "ousli" : "ous",
	      "ization" : "ize",
	      "ation" : "ate",
	      "ator" : "ate",
	      "alism" : "al",
	      "iveness" : "ive",
	      "fulness" : "ful",
	      "ousness" : "ous",
	      "aliti" : "al",
	      "iviti" : "ive",
	      "biliti" : "ble",
	      "logi" : "log"
	    },

	    step3list = {
	      "icate" : "ic",
	      "ative" : "",
	      "alize" : "al",
	      "iciti" : "ic",
	      "ical" : "ic",
	      "ful" : "",
	      "ness" : ""
	    },

	    c = "[^aeiou]",          // consonant
	    v = "[aeiouy]",          // vowel
	    C = c + "[^aeiouy]*",    // consonant sequence
	    V = v + "[aeiou]*",      // vowel sequence

	    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
	    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
	    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
	    s_v = "^(" + C + ")?" + v;                   // vowel in stem

	  var re_mgr0 = new RegExp(mgr0);
	  var re_mgr1 = new RegExp(mgr1);
	  var re_meq1 = new RegExp(meq1);
	  var re_s_v = new RegExp(s_v);

	  var re_1a = /^(.+?)(ss|i)es$/;
	  var re2_1a = /^(.+?)([^s])s$/;
	  var re_1b = /^(.+?)eed$/;
	  var re2_1b = /^(.+?)(ed|ing)$/;
	  var re_1b_2 = /.$/;
	  var re2_1b_2 = /(at|bl|iz)$/;
	  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
	  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

	  var re_1c = /^(.+?[^aeiou])y$/;
	  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

	  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

	  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
	  var re2_4 = /^(.+?)(s|t)(ion)$/;

	  var re_5 = /^(.+?)e$/;
	  var re_5_1 = /ll$/;
	  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

	  var porterStemmer = function porterStemmer(w) {
	    var stem,
	      suffix,
	      firstch,
	      re,
	      re2,
	      re3,
	      re4;

	    if (w.length < 3) { return w; }

	    firstch = w.substr(0,1);
	    if (firstch == "y") {
	      w = firstch.toUpperCase() + w.substr(1);
	    }

	    // Step 1a
	    re = re_1a;
	    re2 = re2_1a;

	    if (re.test(w)) { w = w.replace(re,"$1$2"); }
	    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

	    // Step 1b
	    re = re_1b;
	    re2 = re2_1b;
	    if (re.test(w)) {
	      var fp = re.exec(w);
	      re = re_mgr0;
	      if (re.test(fp[1])) {
	        re = re_1b_2;
	        w = w.replace(re,"");
	      }
	    } else if (re2.test(w)) {
	      var fp = re2.exec(w);
	      stem = fp[1];
	      re2 = re_s_v;
	      if (re2.test(stem)) {
	        w = stem;
	        re2 = re2_1b_2;
	        re3 = re3_1b_2;
	        re4 = re4_1b_2;
	        if (re2.test(w)) { w = w + "e"; }
	        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
	        else if (re4.test(w)) { w = w + "e"; }
	      }
	    }

	    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
	    re = re_1c;
	    if (re.test(w)) {
	      var fp = re.exec(w);
	      stem = fp[1];
	      w = stem + "i";
	    }

	    // Step 2
	    re = re_2;
	    if (re.test(w)) {
	      var fp = re.exec(w);
	      stem = fp[1];
	      suffix = fp[2];
	      re = re_mgr0;
	      if (re.test(stem)) {
	        w = stem + step2list[suffix];
	      }
	    }

	    // Step 3
	    re = re_3;
	    if (re.test(w)) {
	      var fp = re.exec(w);
	      stem = fp[1];
	      suffix = fp[2];
	      re = re_mgr0;
	      if (re.test(stem)) {
	        w = stem + step3list[suffix];
	      }
	    }

	    // Step 4
	    re = re_4;
	    re2 = re2_4;
	    if (re.test(w)) {
	      var fp = re.exec(w);
	      stem = fp[1];
	      re = re_mgr1;
	      if (re.test(stem)) {
	        w = stem;
	      }
	    } else if (re2.test(w)) {
	      var fp = re2.exec(w);
	      stem = fp[1] + fp[2];
	      re2 = re_mgr1;
	      if (re2.test(stem)) {
	        w = stem;
	      }
	    }

	    // Step 5
	    re = re_5;
	    if (re.test(w)) {
	      var fp = re.exec(w);
	      stem = fp[1];
	      re = re_mgr1;
	      re2 = re_meq1;
	      re3 = re3_5;
	      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
	        w = stem;
	      }
	    }

	    re = re_5_1;
	    re2 = re_mgr1;
	    if (re.test(w) && re2.test(w)) {
	      re = re_1b_2;
	      w = w.replace(re,"");
	    }

	    // and turn initial Y back to y

	    if (firstch == "y") {
	      w = firstch.toLowerCase() + w.substr(1);
	    }

	    return w;
	  };

	  return function (token) {
	    return token.update(porterStemmer);
	  }
	})();

	lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer');
	/*!
	 * lunr.stopWordFilter
	 * Copyright (C) 2018 Oliver Nightingale
	 */

	/**
	 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
	 * list of stop words.
	 *
	 * The built in lunr.stopWordFilter is built using this generator and can be used
	 * to generate custom stopWordFilters for applications or non English languages.
	 *
	 * @function
	 * @param {Array} token The token to pass through the filter
	 * @returns {lunr.PipelineFunction}
	 * @see lunr.Pipeline
	 * @see lunr.stopWordFilter
	 */
	lunr.generateStopWordFilter = function (stopWords) {
	  var words = stopWords.reduce(function (memo, stopWord) {
	    memo[stopWord] = stopWord;
	    return memo
	  }, {});

	  return function (token) {
	    if (token && words[token.toString()] !== token.toString()) return token
	  }
	};

	/**
	 * lunr.stopWordFilter is an English language stop word list filter, any words
	 * contained in the list will not be passed through the filter.
	 *
	 * This is intended to be used in the Pipeline. If the token does not pass the
	 * filter then undefined will be returned.
	 *
	 * @function
	 * @implements {lunr.PipelineFunction}
	 * @params {lunr.Token} token - A token to check for being a stop word.
	 * @returns {lunr.Token}
	 * @see {@link lunr.Pipeline}
	 */
	lunr.stopWordFilter = lunr.generateStopWordFilter([
	  'a',
	  'able',
	  'about',
	  'across',
	  'after',
	  'all',
	  'almost',
	  'also',
	  'am',
	  'among',
	  'an',
	  'and',
	  'any',
	  'are',
	  'as',
	  'at',
	  'be',
	  'because',
	  'been',
	  'but',
	  'by',
	  'can',
	  'cannot',
	  'could',
	  'dear',
	  'did',
	  'do',
	  'does',
	  'either',
	  'else',
	  'ever',
	  'every',
	  'for',
	  'from',
	  'get',
	  'got',
	  'had',
	  'has',
	  'have',
	  'he',
	  'her',
	  'hers',
	  'him',
	  'his',
	  'how',
	  'however',
	  'i',
	  'if',
	  'in',
	  'into',
	  'is',
	  'it',
	  'its',
	  'just',
	  'least',
	  'let',
	  'like',
	  'likely',
	  'may',
	  'me',
	  'might',
	  'most',
	  'must',
	  'my',
	  'neither',
	  'no',
	  'nor',
	  'not',
	  'of',
	  'off',
	  'often',
	  'on',
	  'only',
	  'or',
	  'other',
	  'our',
	  'own',
	  'rather',
	  'said',
	  'say',
	  'says',
	  'she',
	  'should',
	  'since',
	  'so',
	  'some',
	  'than',
	  'that',
	  'the',
	  'their',
	  'them',
	  'then',
	  'there',
	  'these',
	  'they',
	  'this',
	  'tis',
	  'to',
	  'too',
	  'twas',
	  'us',
	  'wants',
	  'was',
	  'we',
	  'were',
	  'what',
	  'when',
	  'where',
	  'which',
	  'while',
	  'who',
	  'whom',
	  'why',
	  'will',
	  'with',
	  'would',
	  'yet',
	  'you',
	  'your'
	]);

	lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter');
	/*!
	 * lunr.trimmer
	 * Copyright (C) 2018 Oliver Nightingale
	 */

	/**
	 * lunr.trimmer is a pipeline function for trimming non word
	 * characters from the beginning and end of tokens before they
	 * enter the index.
	 *
	 * This implementation may not work correctly for non latin
	 * characters and should either be removed or adapted for use
	 * with languages with non-latin characters.
	 *
	 * @static
	 * @implements {lunr.PipelineFunction}
	 * @param {lunr.Token} token The token to pass through the filter
	 * @returns {lunr.Token}
	 * @see lunr.Pipeline
	 */
	lunr.trimmer = function (token) {
	  return token.update(function (s) {
	    return s.replace(/^\W+/, '').replace(/\W+$/, '')
	  })
	};

	lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer');
	/*!
	 * lunr.TokenSet
	 * Copyright (C) 2018 Oliver Nightingale
	 */

	/**
	 * A token set is used to store the unique list of all tokens
	 * within an index. Token sets are also used to represent an
	 * incoming query to the index, this query token set and index
	 * token set are then intersected to find which tokens to look
	 * up in the inverted index.
	 *
	 * A token set can hold multiple tokens, as in the case of the
	 * index token set, or it can hold a single token as in the
	 * case of a simple query token set.
	 *
	 * Additionally token sets are used to perform wildcard matching.
	 * Leading, contained and trailing wildcards are supported, and
	 * from this edit distance matching can also be provided.
	 *
	 * Token sets are implemented as a minimal finite state automata,
	 * where both common prefixes and suffixes are shared between tokens.
	 * This helps to reduce the space used for storing the token set.
	 *
	 * @constructor
	 */
	lunr.TokenSet = function () {
	  this.final = false;
	  this.edges = {};
	  this.id = lunr.TokenSet._nextId;
	  lunr.TokenSet._nextId += 1;
	};

	/**
	 * Keeps track of the next, auto increment, identifier to assign
	 * to a new tokenSet.
	 *
	 * TokenSets require a unique identifier to be correctly minimised.
	 *
	 * @private
	 */
	lunr.TokenSet._nextId = 1;

	/**
	 * Creates a TokenSet instance from the given sorted array of words.
	 *
	 * @param {String[]} arr - A sorted array of strings to create the set from.
	 * @returns {lunr.TokenSet}
	 * @throws Will throw an error if the input array is not sorted.
	 */
	lunr.TokenSet.fromArray = function (arr) {
	  var builder = new lunr.TokenSet.Builder;

	  for (var i = 0, len = arr.length; i < len; i++) {
	    builder.insert(arr[i]);
	  }

	  builder.finish();
	  return builder.root
	};

	/**
	 * Creates a token set from a query clause.
	 *
	 * @private
	 * @param {Object} clause - A single clause from lunr.Query.
	 * @param {string} clause.term - The query clause term.
	 * @param {number} [clause.editDistance] - The optional edit distance for the term.
	 * @returns {lunr.TokenSet}
	 */
	lunr.TokenSet.fromClause = function (clause) {
	  if ('editDistance' in clause) {
	    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
	  } else {
	    return lunr.TokenSet.fromString(clause.term)
	  }
	};

	/**
	 * Creates a token set representing a single string with a specified
	 * edit distance.
	 *
	 * Insertions, deletions, substitutions and transpositions are each
	 * treated as an edit distance of 1.
	 *
	 * Increasing the allowed edit distance will have a dramatic impact
	 * on the performance of both creating and intersecting these TokenSets.
	 * It is advised to keep the edit distance less than 3.
	 *
	 * @param {string} str - The string to create the token set from.
	 * @param {number} editDistance - The allowed edit distance to match.
	 * @returns {lunr.Vector}
	 */
	lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
	  var root = new lunr.TokenSet;

	  var stack = [{
	    node: root,
	    editsRemaining: editDistance,
	    str: str
	  }];

	  while (stack.length) {
	    var frame = stack.pop();

	    // no edit
	    if (frame.str.length > 0) {
	      var char = frame.str.charAt(0),
	          noEditNode;

	      if (char in frame.node.edges) {
	        noEditNode = frame.node.edges[char];
	      } else {
	        noEditNode = new lunr.TokenSet;
	        frame.node.edges[char] = noEditNode;
	      }

	      if (frame.str.length == 1) {
	        noEditNode.final = true;
	      } else {
	        stack.push({
	          node: noEditNode,
	          editsRemaining: frame.editsRemaining,
	          str: frame.str.slice(1)
	        });
	      }
	    }

	    // deletion
	    // can only do a deletion if we have enough edits remaining
	    // and if there are characters left to delete in the string
	    if (frame.editsRemaining > 0 && frame.str.length > 1) {
	      var char = frame.str.charAt(1),
	          deletionNode;

	      if (char in frame.node.edges) {
	        deletionNode = frame.node.edges[char];
	      } else {
	        deletionNode = new lunr.TokenSet;
	        frame.node.edges[char] = deletionNode;
	      }

	      if (frame.str.length <= 2) {
	        deletionNode.final = true;
	      } else {
	        stack.push({
	          node: deletionNode,
	          editsRemaining: frame.editsRemaining - 1,
	          str: frame.str.slice(2)
	        });
	      }
	    }

	    // deletion
	    // just removing the last character from the str
	    if (frame.editsRemaining > 0 && frame.str.length == 1) {
	      frame.node.final = true;
	    }

	    // substitution
	    // can only do a substitution if we have enough edits remaining
	    // and if there are characters left to substitute
	    if (frame.editsRemaining > 0 && frame.str.length >= 1) {
	      if ("*" in frame.node.edges) {
	        var substitutionNode = frame.node.edges["*"];
	      } else {
	        var substitutionNode = new lunr.TokenSet;
	        frame.node.edges["*"] = substitutionNode;
	      }

	      if (frame.str.length == 1) {
	        substitutionNode.final = true;
	      } else {
	        stack.push({
	          node: substitutionNode,
	          editsRemaining: frame.editsRemaining - 1,
	          str: frame.str.slice(1)
	        });
	      }
	    }

	    // insertion
	    // can only do insertion if there are edits remaining
	    if (frame.editsRemaining > 0) {
	      if ("*" in frame.node.edges) {
	        var insertionNode = frame.node.edges["*"];
	      } else {
	        var insertionNode = new lunr.TokenSet;
	        frame.node.edges["*"] = insertionNode;
	      }

	      if (frame.str.length == 0) {
	        insertionNode.final = true;
	      } else {
	        stack.push({
	          node: insertionNode,
	          editsRemaining: frame.editsRemaining - 1,
	          str: frame.str
	        });
	      }
	    }

	    // transposition
	    // can only do a transposition if there are edits remaining
	    // and there are enough characters to transpose
	    if (frame.editsRemaining > 0 && frame.str.length > 1) {
	      var charA = frame.str.charAt(0),
	          charB = frame.str.charAt(1),
	          transposeNode;

	      if (charB in frame.node.edges) {
	        transposeNode = frame.node.edges[charB];
	      } else {
	        transposeNode = new lunr.TokenSet;
	        frame.node.edges[charB] = transposeNode;
	      }

	      if (frame.str.length == 1) {
	        transposeNode.final = true;
	      } else {
	        stack.push({
	          node: transposeNode,
	          editsRemaining: frame.editsRemaining - 1,
	          str: charA + frame.str.slice(2)
	        });
	      }
	    }
	  }

	  return root
	};

	/**
	 * Creates a TokenSet from a string.
	 *
	 * The string may contain one or more wildcard characters (*)
	 * that will allow wildcard matching when intersecting with
	 * another TokenSet.
	 *
	 * @param {string} str - The string to create a TokenSet from.
	 * @returns {lunr.TokenSet}
	 */
	lunr.TokenSet.fromString = function (str) {
	  var node = new lunr.TokenSet,
	      root = node,
	      wildcardFound = false;

	  /*
	   * Iterates through all characters within the passed string
	   * appending a node for each character.
	   *
	   * As soon as a wildcard character is found then a self
	   * referencing edge is introduced to continually match
	   * any number of any characters.
	   */
	  for (var i = 0, len = str.length; i < len; i++) {
	    var char = str[i],
	        final = (i == len - 1);

	    if (char == "*") {
	      wildcardFound = true;
	      node.edges[char] = node;
	      node.final = final;

	    } else {
	      var next = new lunr.TokenSet;
	      next.final = final;

	      node.edges[char] = next;
	      node = next;

	      // TODO: is this needed anymore?
	      if (wildcardFound) {
	        node.edges["*"] = root;
	      }
	    }
	  }

	  return root
	};

	/**
	 * Converts this TokenSet into an array of strings
	 * contained within the TokenSet.
	 *
	 * @returns {string[]}
	 */
	lunr.TokenSet.prototype.toArray = function () {
	  var words = [];

	  var stack = [{
	    prefix: "",
	    node: this
	  }];

	  while (stack.length) {
	    var frame = stack.pop(),
	        edges = Object.keys(frame.node.edges),
	        len = edges.length;

	    if (frame.node.final) {
	      /* In Safari, at this point the prefix is sometimes corrupted, see:
	       * https://github.com/olivernn/lunr.js/issues/279 Calling any
	       * String.prototype method forces Safari to "cast" this string to what
	       * it's supposed to be, fixing the bug. */
	      frame.prefix.charAt(0);
	      words.push(frame.prefix);
	    }

	    for (var i = 0; i < len; i++) {
	      var edge = edges[i];

	      stack.push({
	        prefix: frame.prefix.concat(edge),
	        node: frame.node.edges[edge]
	      });
	    }
	  }

	  return words
	};

	/**
	 * Generates a string representation of a TokenSet.
	 *
	 * This is intended to allow TokenSets to be used as keys
	 * in objects, largely to aid the construction and minimisation
	 * of a TokenSet. As such it is not designed to be a human
	 * friendly representation of the TokenSet.
	 *
	 * @returns {string}
	 */
	lunr.TokenSet.prototype.toString = function () {
	  // NOTE: Using Object.keys here as this.edges is very likely
	  // to enter 'hash-mode' with many keys being added
	  //
	  // avoiding a for-in loop here as it leads to the function
	  // being de-optimised (at least in V8). From some simple
	  // benchmarks the performance is comparable, but allowing
	  // V8 to optimize may mean easy performance wins in the future.

	  if (this._str) {
	    return this._str
	  }

	  var str = this.final ? '1' : '0',
	      labels = Object.keys(this.edges).sort(),
	      len = labels.length;

	  for (var i = 0; i < len; i++) {
	    var label = labels[i],
	        node = this.edges[label];

	    str = str + label + node.id;
	  }

	  return str
	};

	/**
	 * Returns a new TokenSet that is the intersection of
	 * this TokenSet and the passed TokenSet.
	 *
	 * This intersection will take into account any wildcards
	 * contained within the TokenSet.
	 *
	 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
	 * @returns {lunr.TokenSet}
	 */
	lunr.TokenSet.prototype.intersect = function (b) {
	  var output = new lunr.TokenSet,
	      frame = undefined;

	  var stack = [{
	    qNode: b,
	    output: output,
	    node: this
	  }];

	  while (stack.length) {
	    frame = stack.pop();

	    // NOTE: As with the #toString method, we are using
	    // Object.keys and a for loop instead of a for-in loop
	    // as both of these objects enter 'hash' mode, causing
	    // the function to be de-optimised in V8
	    var qEdges = Object.keys(frame.qNode.edges),
	        qLen = qEdges.length,
	        nEdges = Object.keys(frame.node.edges),
	        nLen = nEdges.length;

	    for (var q = 0; q < qLen; q++) {
	      var qEdge = qEdges[q];

	      for (var n = 0; n < nLen; n++) {
	        var nEdge = nEdges[n];

	        if (nEdge == qEdge || qEdge == '*') {
	          var node = frame.node.edges[nEdge],
	              qNode = frame.qNode.edges[qEdge],
	              final = node.final && qNode.final,
	              next = undefined;

	          if (nEdge in frame.output.edges) {
	            // an edge already exists for this character
	            // no need to create a new node, just set the finality
	            // bit unless this node is already final
	            next = frame.output.edges[nEdge];
	            next.final = next.final || final;

	          } else {
	            // no edge exists yet, must create one
	            // set the finality bit and insert it
	            // into the output
	            next = new lunr.TokenSet;
	            next.final = final;
	            frame.output.edges[nEdge] = next;
	          }

	          stack.push({
	            qNode: qNode,
	            output: next,
	            node: node
	          });
	        }
	      }
	    }
	  }

	  return output
	};
	lunr.TokenSet.Builder = function () {
	  this.previousWord = "";
	  this.root = new lunr.TokenSet;
	  this.uncheckedNodes = [];
	  this.minimizedNodes = {};
	};

	lunr.TokenSet.Builder.prototype.insert = function (word) {
	  var node,
	      commonPrefix = 0;

	  if (word < this.previousWord) {
	    throw new Error ("Out of order word insertion")
	  }

	  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
	    if (word[i] != this.previousWord[i]) break
	    commonPrefix++;
	  }

	  this.minimize(commonPrefix);

	  if (this.uncheckedNodes.length == 0) {
	    node = this.root;
	  } else {
	    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child;
	  }

	  for (var i = commonPrefix; i < word.length; i++) {
	    var nextNode = new lunr.TokenSet,
	        char = word[i];

	    node.edges[char] = nextNode;

	    this.uncheckedNodes.push({
	      parent: node,
	      char: char,
	      child: nextNode
	    });

	    node = nextNode;
	  }

	  node.final = true;
	  this.previousWord = word;
	};

	lunr.TokenSet.Builder.prototype.finish = function () {
	  this.minimize(0);
	};

	lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
	  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
	    var node = this.uncheckedNodes[i],
	        childKey = node.child.toString();

	    if (childKey in this.minimizedNodes) {
	      node.parent.edges[node.char] = this.minimizedNodes[childKey];
	    } else {
	      // Cache the key for this node since
	      // we know it can't change anymore
	      node.child._str = childKey;

	      this.minimizedNodes[childKey] = node.child;
	    }

	    this.uncheckedNodes.pop();
	  }
	};
	/*!
	 * lunr.Index
	 * Copyright (C) 2018 Oliver Nightingale
	 */

	/**
	 * An index contains the built index of all documents and provides a query interface
	 * to the index.
	 *
	 * Usually instances of lunr.Index will not be created using this constructor, instead
	 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
	 * used to load previously built and serialized indexes.
	 *
	 * @constructor
	 * @param {Object} attrs - The attributes of the built search index.
	 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
	 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
	 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
	 * @param {string[]} attrs.fields - The names of indexed document fields.
	 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
	 */
	lunr.Index = function (attrs) {
	  this.invertedIndex = attrs.invertedIndex;
	  this.fieldVectors = attrs.fieldVectors;
	  this.tokenSet = attrs.tokenSet;
	  this.fields = attrs.fields;
	  this.pipeline = attrs.pipeline;
	};

	/**
	 * A result contains details of a document matching a search query.
	 * @typedef {Object} lunr.Index~Result
	 * @property {string} ref - The reference of the document this result represents.
	 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
	 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
	 */

	/**
	 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
	 * query language which itself is parsed into an instance of lunr.Query.
	 *
	 * For programmatically building queries it is advised to directly use lunr.Query, the query language
	 * is best used for human entered text rather than program generated text.
	 *
	 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
	 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
	 * or 'world', though those that contain both will rank higher in the results.
	 *
	 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
	 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
	 * wildcards will increase the number of documents that will be found but can also have a negative
	 * impact on query performance, especially with wildcards at the beginning of a term.
	 *
	 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
	 * hello in the title field will match this query. Using a field not present in the index will lead
	 * to an error being thrown.
	 *
	 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
	 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
	 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
	 * Avoid large values for edit distance to improve query performance.
	 *
	 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
	 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
	 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
	 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
	 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
	 *
	 * To escape special characters the backslash character '\' can be used, this allows searches to include
	 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
	 * of attempting to apply a boost of 2 to the search term "foo".
	 *
	 * @typedef {string} lunr.Index~QueryString
	 * @example <caption>Simple single term query</caption>
	 * hello
	 * @example <caption>Multiple term query</caption>
	 * hello world
	 * @example <caption>term scoped to a field</caption>
	 * title:hello
	 * @example <caption>term with a boost of 10</caption>
	 * hello^10
	 * @example <caption>term with an edit distance of 2</caption>
	 * hello~2
	 * @example <caption>terms with presence modifiers</caption>
	 * -foo +bar baz
	 */

	/**
	 * Performs a search against the index using lunr query syntax.
	 *
	 * Results will be returned sorted by their score, the most relevant results
	 * will be returned first.  For details on how the score is calculated, please see
	 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
	 *
	 * For more programmatic querying use lunr.Index#query.
	 *
	 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
	 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
	 * @returns {lunr.Index~Result[]}
	 */
	lunr.Index.prototype.search = function (queryString) {
	  return this.query(function (query) {
	    var parser = new lunr.QueryParser(queryString, query);
	    parser.parse();
	  })
	};

	/**
	 * A query builder callback provides a query object to be used to express
	 * the query to perform on the index.
	 *
	 * @callback lunr.Index~queryBuilder
	 * @param {lunr.Query} query - The query object to build up.
	 * @this lunr.Query
	 */

	/**
	 * Performs a query against the index using the yielded lunr.Query object.
	 *
	 * If performing programmatic queries against the index, this method is preferred
	 * over lunr.Index#search so as to avoid the additional query parsing overhead.
	 *
	 * A query object is yielded to the supplied function which should be used to
	 * express the query to be run against the index.
	 *
	 * Note that although this function takes a callback parameter it is _not_ an
	 * asynchronous operation, the callback is just yielded a query object to be
	 * customized.
	 *
	 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
	 * @returns {lunr.Index~Result[]}
	 */
	lunr.Index.prototype.query = function (fn) {
	  // for each query clause
	  // * process terms
	  // * expand terms from token set
	  // * find matching documents and metadata
	  // * get document vectors
	  // * score documents

	  var query = new lunr.Query(this.fields),
	      matchingFields = Object.create(null),
	      queryVectors = Object.create(null),
	      termFieldCache = Object.create(null),
	      requiredMatches = Object.create(null),
	      prohibitedMatches = Object.create(null);

	  /*
	   * To support field level boosts a query vector is created per
	   * field. An empty vector is eagerly created to support negated
	   * queries.
	   */
	  for (var i = 0; i < this.fields.length; i++) {
	    queryVectors[this.fields[i]] = new lunr.Vector;
	  }

	  fn.call(query, query);

	  for (var i = 0; i < query.clauses.length; i++) {
	    /*
	     * Unless the pipeline has been disabled for this term, which is
	     * the case for terms with wildcards, we need to pass the clause
	     * term through the search pipeline. A pipeline returns an array
	     * of processed terms. Pipeline functions may expand the passed
	     * term, which means we may end up performing multiple index lookups
	     * for a single query term.
	     */
	    var clause = query.clauses[i],
	        terms = null,
	        clauseMatches = lunr.Set.complete;

	    if (clause.usePipeline) {
	      terms = this.pipeline.runString(clause.term, {
	        fields: clause.fields
	      });
	    } else {
	      terms = [clause.term];
	    }

	    for (var m = 0; m < terms.length; m++) {
	      var term = terms[m];

	      /*
	       * Each term returned from the pipeline needs to use the same query
	       * clause object, e.g. the same boost and or edit distance. The
	       * simplest way to do this is to re-use the clause object but mutate
	       * its term property.
	       */
	      clause.term = term;

	      /*
	       * From the term in the clause we create a token set which will then
	       * be used to intersect the indexes token set to get a list of terms
	       * to lookup in the inverted index
	       */
	      var termTokenSet = lunr.TokenSet.fromClause(clause),
	          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray();

	      /*
	       * If a term marked as required does not exist in the tokenSet it is
	       * impossible for the search to return any matches. We set all the field
	       * scoped required matches set to empty and stop examining any further
	       * clauses.
	       */
	      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
	        for (var k = 0; k < clause.fields.length; k++) {
	          var field = clause.fields[k];
	          requiredMatches[field] = lunr.Set.empty;
	        }

	        break
	      }

	      for (var j = 0; j < expandedTerms.length; j++) {
	        /*
	         * For each term get the posting and termIndex, this is required for
	         * building the query vector.
	         */
	        var expandedTerm = expandedTerms[j],
	            posting = this.invertedIndex[expandedTerm],
	            termIndex = posting._index;

	        for (var k = 0; k < clause.fields.length; k++) {
	          /*
	           * For each field that this query term is scoped by (by default
	           * all fields are in scope) we need to get all the document refs
	           * that have this term in that field.
	           *
	           * The posting is the entry in the invertedIndex for the matching
	           * term from above.
	           */
	          var field = clause.fields[k],
	              fieldPosting = posting[field],
	              matchingDocumentRefs = Object.keys(fieldPosting),
	              termField = expandedTerm + "/" + field,
	              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs);

	          /*
	           * if the presence of this term is required ensure that the matching
	           * documents are added to the set of required matches for this clause.
	           *
	           */
	          if (clause.presence == lunr.Query.presence.REQUIRED) {
	            clauseMatches = clauseMatches.union(matchingDocumentsSet);

	            if (requiredMatches[field] === undefined) {
	              requiredMatches[field] = lunr.Set.complete;
	            }
	          }

	          /*
	           * if the presence of this term is prohibited ensure that the matching
	           * documents are added to the set of prohibited matches for this field,
	           * creating that set if it does not yet exist.
	           */
	          if (clause.presence == lunr.Query.presence.PROHIBITED) {
	            if (prohibitedMatches[field] === undefined) {
	              prohibitedMatches[field] = lunr.Set.empty;
	            }

	            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet);

	            /*
	             * Prohibited matches should not be part of the query vector used for
	             * similarity scoring and no metadata should be extracted so we continue
	             * to the next field
	             */
	            continue
	          }

	          /*
	           * The query field vector is populated using the termIndex found for
	           * the term and a unit value with the appropriate boost applied.
	           * Using upsert because there could already be an entry in the vector
	           * for the term we are working with. In that case we just add the scores
	           * together.
	           */
	          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b });

	          /**
	           * If we've already seen this term, field combo then we've already collected
	           * the matching documents and metadata, no need to go through all that again
	           */
	          if (termFieldCache[termField]) {
	            continue
	          }

	          for (var l = 0; l < matchingDocumentRefs.length; l++) {
	            /*
	             * All metadata for this term/field/document triple
	             * are then extracted and collected into an instance
	             * of lunr.MatchData ready to be returned in the query
	             * results
	             */
	            var matchingDocumentRef = matchingDocumentRefs[l],
	                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
	                metadata = fieldPosting[matchingDocumentRef],
	                fieldMatch;

	            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
	              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata);
	            } else {
	              fieldMatch.add(expandedTerm, field, metadata);
	            }

	          }

	          termFieldCache[termField] = true;
	        }
	      }
	    }

	    /**
	     * If the presence was required we need to update the requiredMatches field sets.
	     * We do this after all fields for the term have collected their matches because
	     * the clause terms presence is required in _any_ of the fields not _all_ of the
	     * fields.
	     */
	    if (clause.presence === lunr.Query.presence.REQUIRED) {
	      for (var k = 0; k < clause.fields.length; k++) {
	        var field = clause.fields[k];
	        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches);
	      }
	    }
	  }

	  /**
	   * Need to combine the field scoped required and prohibited
	   * matching documents into a global set of required and prohibited
	   * matches
	   */
	  var allRequiredMatches = lunr.Set.complete,
	      allProhibitedMatches = lunr.Set.empty;

	  for (var i = 0; i < this.fields.length; i++) {
	    var field = this.fields[i];

	    if (requiredMatches[field]) {
	      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field]);
	    }

	    if (prohibitedMatches[field]) {
	      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field]);
	    }
	  }

	  var matchingFieldRefs = Object.keys(matchingFields),
	      results = [],
	      matches = Object.create(null);

	  /*
	   * If the query is negated (contains only prohibited terms)
	   * we need to get _all_ fieldRefs currently existing in the
	   * index. This is only done when we know that the query is
	   * entirely prohibited terms to avoid any cost of getting all
	   * fieldRefs unnecessarily.
	   *
	   * Additionally, blank MatchData must be created to correctly
	   * populate the results.
	   */
	  if (query.isNegated()) {
	    matchingFieldRefs = Object.keys(this.fieldVectors);

	    for (var i = 0; i < matchingFieldRefs.length; i++) {
	      var matchingFieldRef = matchingFieldRefs[i];
	      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef);
	      matchingFields[matchingFieldRef] = new lunr.MatchData;
	    }
	  }

	  for (var i = 0; i < matchingFieldRefs.length; i++) {
	    /*
	     * Currently we have document fields that match the query, but we
	     * need to return documents. The matchData and scores are combined
	     * from multiple fields belonging to the same document.
	     *
	     * Scores are calculated by field, using the query vectors created
	     * above, and combined into a final document score using addition.
	     */
	    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
	        docRef = fieldRef.docRef;

	    if (!allRequiredMatches.contains(docRef)) {
	      continue
	    }

	    if (allProhibitedMatches.contains(docRef)) {
	      continue
	    }

	    var fieldVector = this.fieldVectors[fieldRef],
	        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
	        docMatch;

	    if ((docMatch = matches[docRef]) !== undefined) {
	      docMatch.score += score;
	      docMatch.matchData.combine(matchingFields[fieldRef]);
	    } else {
	      var match = {
	        ref: docRef,
	        score: score,
	        matchData: matchingFields[fieldRef]
	      };
	      matches[docRef] = match;
	      results.push(match);
	    }
	  }

	  /*
	   * Sort the results objects by score, highest first.
	   */
	  return results.sort(function (a, b) {
	    return b.score - a.score
	  })
	};

	/**
	 * Prepares the index for JSON serialization.
	 *
	 * The schema for this JSON blob will be described in a
	 * separate JSON schema file.
	 *
	 * @returns {Object}
	 */
	lunr.Index.prototype.toJSON = function () {
	  var invertedIndex = Object.keys(this.invertedIndex)
	    .sort()
	    .map(function (term) {
	      return [term, this.invertedIndex[term]]
	    }, this);

	  var fieldVectors = Object.keys(this.fieldVectors)
	    .map(function (ref) {
	      return [ref, this.fieldVectors[ref].toJSON()]
	    }, this);

	  return {
	    version: lunr.version,
	    fields: this.fields,
	    fieldVectors: fieldVectors,
	    invertedIndex: invertedIndex,
	    pipeline: this.pipeline.toJSON()
	  }
	};

	/**
	 * Loads a previously serialized lunr.Index
	 *
	 * @param {Object} serializedIndex - A previously serialized lunr.Index
	 * @returns {lunr.Index}
	 */
	lunr.Index.load = function (serializedIndex) {
	  var attrs = {},
	      fieldVectors = {},
	      serializedVectors = serializedIndex.fieldVectors,
	      invertedIndex = {},
	      serializedInvertedIndex = serializedIndex.invertedIndex,
	      tokenSetBuilder = new lunr.TokenSet.Builder,
	      pipeline = lunr.Pipeline.load(serializedIndex.pipeline);

	  if (serializedIndex.version != lunr.version) {
	    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'");
	  }

	  for (var i = 0; i < serializedVectors.length; i++) {
	    var tuple = serializedVectors[i],
	        ref = tuple[0],
	        elements = tuple[1];

	    fieldVectors[ref] = new lunr.Vector(elements);
	  }

	  for (var i = 0; i < serializedInvertedIndex.length; i++) {
	    var tuple = serializedInvertedIndex[i],
	        term = tuple[0],
	        posting = tuple[1];

	    tokenSetBuilder.insert(term);
	    invertedIndex[term] = posting;
	  }

	  tokenSetBuilder.finish();

	  attrs.fields = serializedIndex.fields;

	  attrs.fieldVectors = fieldVectors;
	  attrs.invertedIndex = invertedIndex;
	  attrs.tokenSet = tokenSetBuilder.root;
	  attrs.pipeline = pipeline;

	  return new lunr.Index(attrs)
	};
	/*!
	 * lunr.Builder
	 * Copyright (C) 2018 Oliver Nightingale
	 */

	/**
	 * lunr.Builder performs indexing on a set of documents and
	 * returns instances of lunr.Index ready for querying.
	 *
	 * All configuration of the index is done via the builder, the
	 * fields to index, the document reference, the text processing
	 * pipeline and document scoring parameters are all set on the
	 * builder before indexing.
	 *
	 * @constructor
	 * @property {string} _ref - Internal reference to the document reference field.
	 * @property {string[]} _fields - Internal reference to the document fields to index.
	 * @property {object} invertedIndex - The inverted index maps terms to document fields.
	 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
	 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
	 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
	 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
	 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
	 * @property {number} documentCount - Keeps track of the total number of documents indexed.
	 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
	 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
	 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
	 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
	 */
	lunr.Builder = function () {
	  this._ref = "id";
	  this._fields = Object.create(null);
	  this._documents = Object.create(null);
	  this.invertedIndex = Object.create(null);
	  this.fieldTermFrequencies = {};
	  this.fieldLengths = {};
	  this.tokenizer = lunr.tokenizer;
	  this.pipeline = new lunr.Pipeline;
	  this.searchPipeline = new lunr.Pipeline;
	  this.documentCount = 0;
	  this._b = 0.75;
	  this._k1 = 1.2;
	  this.termIndex = 0;
	  this.metadataWhitelist = [];
	};

	/**
	 * Sets the document field used as the document reference. Every document must have this field.
	 * The type of this field in the document should be a string, if it is not a string it will be
	 * coerced into a string by calling toString.
	 *
	 * The default ref is 'id'.
	 *
	 * The ref should _not_ be changed during indexing, it should be set before any documents are
	 * added to the index. Changing it during indexing can lead to inconsistent results.
	 *
	 * @param {string} ref - The name of the reference field in the document.
	 */
	lunr.Builder.prototype.ref = function (ref) {
	  this._ref = ref;
	};

	/**
	 * A function that is used to extract a field from a document.
	 *
	 * Lunr expects a field to be at the top level of a document, if however the field
	 * is deeply nested within a document an extractor function can be used to extract
	 * the right field for indexing.
	 *
	 * @callback fieldExtractor
	 * @param {object} doc - The document being added to the index.
	 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
	 * @example <caption>Extracting a nested field</caption>
	 * function (doc) { return doc.nested.field }
	 */

	/**
	 * Adds a field to the list of document fields that will be indexed. Every document being
	 * indexed should have this field. Null values for this field in indexed documents will
	 * not cause errors but will limit the chance of that document being retrieved by searches.
	 *
	 * All fields should be added before adding documents to the index. Adding fields after
	 * a document has been indexed will have no effect on already indexed documents.
	 *
	 * Fields can be boosted at build time. This allows terms within that field to have more
	 * importance when ranking search results. Use a field boost to specify that matches within
	 * one field are more important than other fields.
	 *
	 * @param {string} fieldName - The name of a field to index in all documents.
	 * @param {object} attributes - Optional attributes associated with this field.
	 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
	 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
	 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
	 */
	lunr.Builder.prototype.field = function (fieldName, attributes) {
	  if (/\//.test(fieldName)) {
	    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
	  }

	  this._fields[fieldName] = attributes || {};
	};

	/**
	 * A parameter to tune the amount of field length normalisation that is applied when
	 * calculating relevance scores. A value of 0 will completely disable any normalisation
	 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
	 * will be clamped to the range 0 - 1.
	 *
	 * @param {number} number - The value to set for this tuning parameter.
	 */
	lunr.Builder.prototype.b = function (number) {
	  if (number < 0) {
	    this._b = 0;
	  } else if (number > 1) {
	    this._b = 1;
	  } else {
	    this._b = number;
	  }
	};

	/**
	 * A parameter that controls the speed at which a rise in term frequency results in term
	 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
	 * slower saturation levels, a lower value will result in quicker saturation.
	 *
	 * @param {number} number - The value to set for this tuning parameter.
	 */
	lunr.Builder.prototype.k1 = function (number) {
	  this._k1 = number;
	};

	/**
	 * Adds a document to the index.
	 *
	 * Before adding fields to the index the index should have been fully setup, with the document
	 * ref and all fields to index already having been specified.
	 *
	 * The document must have a field name as specified by the ref (by default this is 'id') and
	 * it should have all fields defined for indexing, though null or undefined values will not
	 * cause errors.
	 *
	 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
	 * this document should rank higher in search results than other documents.
	 *
	 * @param {object} doc - The document to add to the index.
	 * @param {object} attributes - Optional attributes associated with this document.
	 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
	 */
	lunr.Builder.prototype.add = function (doc, attributes) {
	  var docRef = doc[this._ref],
	      fields = Object.keys(this._fields);

	  this._documents[docRef] = attributes || {};
	  this.documentCount += 1;

	  for (var i = 0; i < fields.length; i++) {
	    var fieldName = fields[i],
	        extractor = this._fields[fieldName].extractor,
	        field = extractor ? extractor(doc) : doc[fieldName],
	        tokens = this.tokenizer(field, {
	          fields: [fieldName]
	        }),
	        terms = this.pipeline.run(tokens),
	        fieldRef = new lunr.FieldRef (docRef, fieldName),
	        fieldTerms = Object.create(null);

	    this.fieldTermFrequencies[fieldRef] = fieldTerms;
	    this.fieldLengths[fieldRef] = 0;

	    // store the length of this field for this document
	    this.fieldLengths[fieldRef] += terms.length;

	    // calculate term frequencies for this field
	    for (var j = 0; j < terms.length; j++) {
	      var term = terms[j];

	      if (fieldTerms[term] == undefined) {
	        fieldTerms[term] = 0;
	      }

	      fieldTerms[term] += 1;

	      // add to inverted index
	      // create an initial posting if one doesn't exist
	      if (this.invertedIndex[term] == undefined) {
	        var posting = Object.create(null);
	        posting["_index"] = this.termIndex;
	        this.termIndex += 1;

	        for (var k = 0; k < fields.length; k++) {
	          posting[fields[k]] = Object.create(null);
	        }

	        this.invertedIndex[term] = posting;
	      }

	      // add an entry for this term/fieldName/docRef to the invertedIndex
	      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
	        this.invertedIndex[term][fieldName][docRef] = Object.create(null);
	      }

	      // store all whitelisted metadata about this token in the
	      // inverted index
	      for (var l = 0; l < this.metadataWhitelist.length; l++) {
	        var metadataKey = this.metadataWhitelist[l],
	            metadata = term.metadata[metadataKey];

	        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
	          this.invertedIndex[term][fieldName][docRef][metadataKey] = [];
	        }

	        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata);
	      }
	    }

	  }
	};

	/**
	 * Calculates the average document length for this index
	 *
	 * @private
	 */
	lunr.Builder.prototype.calculateAverageFieldLengths = function () {

	  var fieldRefs = Object.keys(this.fieldLengths),
	      numberOfFields = fieldRefs.length,
	      accumulator = {},
	      documentsWithField = {};

	  for (var i = 0; i < numberOfFields; i++) {
	    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
	        field = fieldRef.fieldName;

	    documentsWithField[field] || (documentsWithField[field] = 0);
	    documentsWithField[field] += 1;

	    accumulator[field] || (accumulator[field] = 0);
	    accumulator[field] += this.fieldLengths[fieldRef];
	  }

	  var fields = Object.keys(this._fields);

	  for (var i = 0; i < fields.length; i++) {
	    var fieldName = fields[i];
	    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName];
	  }

	  this.averageFieldLength = accumulator;
	};

	/**
	 * Builds a vector space model of every document using lunr.Vector
	 *
	 * @private
	 */
	lunr.Builder.prototype.createFieldVectors = function () {
	  var fieldVectors = {},
	      fieldRefs = Object.keys(this.fieldTermFrequencies),
	      fieldRefsLength = fieldRefs.length,
	      termIdfCache = Object.create(null);

	  for (var i = 0; i < fieldRefsLength; i++) {
	    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
	        fieldName = fieldRef.fieldName,
	        fieldLength = this.fieldLengths[fieldRef],
	        fieldVector = new lunr.Vector,
	        termFrequencies = this.fieldTermFrequencies[fieldRef],
	        terms = Object.keys(termFrequencies),
	        termsLength = terms.length;


	    var fieldBoost = this._fields[fieldName].boost || 1,
	        docBoost = this._documents[fieldRef.docRef].boost || 1;

	    for (var j = 0; j < termsLength; j++) {
	      var term = terms[j],
	          tf = termFrequencies[term],
	          termIndex = this.invertedIndex[term]._index,
	          idf, score, scoreWithPrecision;

	      if (termIdfCache[term] === undefined) {
	        idf = lunr.idf(this.invertedIndex[term], this.documentCount);
	        termIdfCache[term] = idf;
	      } else {
	        idf = termIdfCache[term];
	      }

	      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf);
	      score *= fieldBoost;
	      score *= docBoost;
	      scoreWithPrecision = Math.round(score * 1000) / 1000;
	      // Converts 1.23456789 to 1.234.
	      // Reducing the precision so that the vectors take up less
	      // space when serialised. Doing it now so that they behave
	      // the same before and after serialisation. Also, this is
	      // the fastest approach to reducing a number's precision in
	      // JavaScript.

	      fieldVector.insert(termIndex, scoreWithPrecision);
	    }

	    fieldVectors[fieldRef] = fieldVector;
	  }

	  this.fieldVectors = fieldVectors;
	};

	/**
	 * Creates a token set of all tokens in the index using lunr.TokenSet
	 *
	 * @private
	 */
	lunr.Builder.prototype.createTokenSet = function () {
	  this.tokenSet = lunr.TokenSet.fromArray(
	    Object.keys(this.invertedIndex).sort()
	  );
	};

	/**
	 * Builds the index, creating an instance of lunr.Index.
	 *
	 * This completes the indexing process and should only be called
	 * once all documents have been added to the index.
	 *
	 * @returns {lunr.Index}
	 */
	lunr.Builder.prototype.build = function () {
	  this.calculateAverageFieldLengths();
	  this.createFieldVectors();
	  this.createTokenSet();

	  return new lunr.Index({
	    invertedIndex: this.invertedIndex,
	    fieldVectors: this.fieldVectors,
	    tokenSet: this.tokenSet,
	    fields: Object.keys(this._fields),
	    pipeline: this.searchPipeline
	  })
	};

	/**
	 * Applies a plugin to the index builder.
	 *
	 * A plugin is a function that is called with the index builder as its context.
	 * Plugins can be used to customise or extend the behaviour of the index
	 * in some way. A plugin is just a function, that encapsulated the custom
	 * behaviour that should be applied when building the index.
	 *
	 * The plugin function will be called with the index builder as its argument, additional
	 * arguments can also be passed when calling use. The function will be called
	 * with the index builder as its context.
	 *
	 * @param {Function} plugin The plugin to apply.
	 */
	lunr.Builder.prototype.use = function (fn) {
	  var args = Array.prototype.slice.call(arguments, 1);
	  args.unshift(this);
	  fn.apply(this, args);
	};
	/**
	 * Contains and collects metadata about a matching document.
	 * A single instance of lunr.MatchData is returned as part of every
	 * lunr.Index~Result.
	 *
	 * @constructor
	 * @param {string} term - The term this match data is associated with
	 * @param {string} field - The field in which the term was found
	 * @param {object} metadata - The metadata recorded about this term in this field
	 * @property {object} metadata - A cloned collection of metadata associated with this document.
	 * @see {@link lunr.Index~Result}
	 */
	lunr.MatchData = function (term, field, metadata) {
	  var clonedMetadata = Object.create(null),
	      metadataKeys = Object.keys(metadata || {});

	  // Cloning the metadata to prevent the original
	  // being mutated during match data combination.
	  // Metadata is kept in an array within the inverted
	  // index so cloning the data can be done with
	  // Array#slice
	  for (var i = 0; i < metadataKeys.length; i++) {
	    var key = metadataKeys[i];
	    clonedMetadata[key] = metadata[key].slice();
	  }

	  this.metadata = Object.create(null);

	  if (term !== undefined) {
	    this.metadata[term] = Object.create(null);
	    this.metadata[term][field] = clonedMetadata;
	  }
	};

	/**
	 * An instance of lunr.MatchData will be created for every term that matches a
	 * document. However only one instance is required in a lunr.Index~Result. This
	 * method combines metadata from another instance of lunr.MatchData with this
	 * objects metadata.
	 *
	 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
	 * @see {@link lunr.Index~Result}
	 */
	lunr.MatchData.prototype.combine = function (otherMatchData) {
	  var terms = Object.keys(otherMatchData.metadata);

	  for (var i = 0; i < terms.length; i++) {
	    var term = terms[i],
	        fields = Object.keys(otherMatchData.metadata[term]);

	    if (this.metadata[term] == undefined) {
	      this.metadata[term] = Object.create(null);
	    }

	    for (var j = 0; j < fields.length; j++) {
	      var field = fields[j],
	          keys = Object.keys(otherMatchData.metadata[term][field]);

	      if (this.metadata[term][field] == undefined) {
	        this.metadata[term][field] = Object.create(null);
	      }

	      for (var k = 0; k < keys.length; k++) {
	        var key = keys[k];

	        if (this.metadata[term][field][key] == undefined) {
	          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key];
	        } else {
	          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key]);
	        }

	      }
	    }
	  }
	};

	/**
	 * Add metadata for a term/field pair to this instance of match data.
	 *
	 * @param {string} term - The term this match data is associated with
	 * @param {string} field - The field in which the term was found
	 * @param {object} metadata - The metadata recorded about this term in this field
	 */
	lunr.MatchData.prototype.add = function (term, field, metadata) {
	  if (!(term in this.metadata)) {
	    this.metadata[term] = Object.create(null);
	    this.metadata[term][field] = metadata;
	    return
	  }

	  if (!(field in this.metadata[term])) {
	    this.metadata[term][field] = metadata;
	    return
	  }

	  var metadataKeys = Object.keys(metadata);

	  for (var i = 0; i < metadataKeys.length; i++) {
	    var key = metadataKeys[i];

	    if (key in this.metadata[term][field]) {
	      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key]);
	    } else {
	      this.metadata[term][field][key] = metadata[key];
	    }
	  }
	};
	/**
	 * A lunr.Query provides a programmatic way of defining queries to be performed
	 * against a {@link lunr.Index}.
	 *
	 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
	 * so the query object is pre-initialized with the right index fields.
	 *
	 * @constructor
	 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
	 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
	 */
	lunr.Query = function (allFields) {
	  this.clauses = [];
	  this.allFields = allFields;
	};

	/**
	 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
	 *
	 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
	 * concatenation.
	 *
	 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
	 *
	 * @constant
	 * @default
	 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
	 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
	 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
	 * @see lunr.Query~Clause
	 * @see lunr.Query#clause
	 * @see lunr.Query#term
	 * @example <caption>query term with trailing wildcard</caption>
	 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
	 * @example <caption>query term with leading and trailing wildcard</caption>
	 * query.term('foo', {
	 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
	 * })
	 */

	lunr.Query.wildcard = new String ("*");
	lunr.Query.wildcard.NONE = 0;
	lunr.Query.wildcard.LEADING = 1;
	lunr.Query.wildcard.TRAILING = 2;

	/**
	 * Constants for indicating what kind of presence a term must have in matching documents.
	 *
	 * @constant
	 * @enum {number}
	 * @see lunr.Query~Clause
	 * @see lunr.Query#clause
	 * @see lunr.Query#term
	 * @example <caption>query term with required presence</caption>
	 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
	 */
	lunr.Query.presence = {
	  /**
	   * Term's presence in a document is optional, this is the default value.
	   */
	  OPTIONAL: 1,

	  /**
	   * Term's presence in a document is required, documents that do not contain
	   * this term will not be returned.
	   */
	  REQUIRED: 2,

	  /**
	   * Term's presence in a document is prohibited, documents that do contain
	   * this term will not be returned.
	   */
	  PROHIBITED: 3
	};

	/**
	 * A single clause in a {@link lunr.Query} contains a term and details on how to
	 * match that term against a {@link lunr.Index}.
	 *
	 * @typedef {Object} lunr.Query~Clause
	 * @property {string[]} fields - The fields in an index this clause should be matched against.
	 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
	 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
	 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
	 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
	 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
	 */

	/**
	 * Adds a {@link lunr.Query~Clause} to this query.
	 *
	 * Unless the clause contains the fields to be matched all fields will be matched. In addition
	 * a default boost of 1 is applied to the clause.
	 *
	 * @param {lunr.Query~Clause} clause - The clause to add to this query.
	 * @see lunr.Query~Clause
	 * @returns {lunr.Query}
	 */
	lunr.Query.prototype.clause = function (clause) {
	  if (!('fields' in clause)) {
	    clause.fields = this.allFields;
	  }

	  if (!('boost' in clause)) {
	    clause.boost = 1;
	  }

	  if (!('usePipeline' in clause)) {
	    clause.usePipeline = true;
	  }

	  if (!('wildcard' in clause)) {
	    clause.wildcard = lunr.Query.wildcard.NONE;
	  }

	  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
	    clause.term = "*" + clause.term;
	  }

	  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
	    clause.term = "" + clause.term + "*";
	  }

	  if (!('presence' in clause)) {
	    clause.presence = lunr.Query.presence.OPTIONAL;
	  }

	  this.clauses.push(clause);

	  return this
	};

	/**
	 * A negated query is one in which every clause has a presence of
	 * prohibited. These queries require some special processing to return
	 * the expected results.
	 *
	 * @returns boolean
	 */
	lunr.Query.prototype.isNegated = function () {
	  for (var i = 0; i < this.clauses.length; i++) {
	    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
	      return false
	    }
	  }

	  return true
	};

	/**
	 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
	 * to the list of clauses that make up this query.
	 *
	 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
	 * to a token or token-like string should be done before calling this method.
	 *
	 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
	 * array, each term in the array will share the same options.
	 *
	 * @param {object|object[]} term - The term(s) to add to the query.
	 * @param {object} [options] - Any additional properties to add to the query clause.
	 * @returns {lunr.Query}
	 * @see lunr.Query#clause
	 * @see lunr.Query~Clause
	 * @example <caption>adding a single term to a query</caption>
	 * query.term("foo")
	 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
	 * query.term("foo", {
	 *   fields: ["title"],
	 *   boost: 10,
	 *   wildcard: lunr.Query.wildcard.TRAILING
	 * })
	 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
	 * query.term(lunr.tokenizer("foo bar"))
	 */
	lunr.Query.prototype.term = function (term, options) {
	  if (Array.isArray(term)) {
	    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)); }, this);
	    return this
	  }

	  var clause = options || {};
	  clause.term = term.toString();

	  this.clause(clause);

	  return this
	};
	lunr.QueryParseError = function (message, start, end) {
	  this.name = "QueryParseError";
	  this.message = message;
	  this.start = start;
	  this.end = end;
	};

	lunr.QueryParseError.prototype = new Error;
	lunr.QueryLexer = function (str) {
	  this.lexemes = [];
	  this.str = str;
	  this.length = str.length;
	  this.pos = 0;
	  this.start = 0;
	  this.escapeCharPositions = [];
	};

	lunr.QueryLexer.prototype.run = function () {
	  var state = lunr.QueryLexer.lexText;

	  while (state) {
	    state = state(this);
	  }
	};

	lunr.QueryLexer.prototype.sliceString = function () {
	  var subSlices = [],
	      sliceStart = this.start,
	      sliceEnd = this.pos;

	  for (var i = 0; i < this.escapeCharPositions.length; i++) {
	    sliceEnd = this.escapeCharPositions[i];
	    subSlices.push(this.str.slice(sliceStart, sliceEnd));
	    sliceStart = sliceEnd + 1;
	  }

	  subSlices.push(this.str.slice(sliceStart, this.pos));
	  this.escapeCharPositions.length = 0;

	  return subSlices.join('')
	};

	lunr.QueryLexer.prototype.emit = function (type) {
	  this.lexemes.push({
	    type: type,
	    str: this.sliceString(),
	    start: this.start,
	    end: this.pos
	  });

	  this.start = this.pos;
	};

	lunr.QueryLexer.prototype.escapeCharacter = function () {
	  this.escapeCharPositions.push(this.pos - 1);
	  this.pos += 1;
	};

	lunr.QueryLexer.prototype.next = function () {
	  if (this.pos >= this.length) {
	    return lunr.QueryLexer.EOS
	  }

	  var char = this.str.charAt(this.pos);
	  this.pos += 1;
	  return char
	};

	lunr.QueryLexer.prototype.width = function () {
	  return this.pos - this.start
	};

	lunr.QueryLexer.prototype.ignore = function () {
	  if (this.start == this.pos) {
	    this.pos += 1;
	  }

	  this.start = this.pos;
	};

	lunr.QueryLexer.prototype.backup = function () {
	  this.pos -= 1;
	};

	lunr.QueryLexer.prototype.acceptDigitRun = function () {
	  var char, charCode;

	  do {
	    char = this.next();
	    charCode = char.charCodeAt(0);
	  } while (charCode > 47 && charCode < 58)

	  if (char != lunr.QueryLexer.EOS) {
	    this.backup();
	  }
	};

	lunr.QueryLexer.prototype.more = function () {
	  return this.pos < this.length
	};

	lunr.QueryLexer.EOS = 'EOS';
	lunr.QueryLexer.FIELD = 'FIELD';
	lunr.QueryLexer.TERM = 'TERM';
	lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE';
	lunr.QueryLexer.BOOST = 'BOOST';
	lunr.QueryLexer.PRESENCE = 'PRESENCE';

	lunr.QueryLexer.lexField = function (lexer) {
	  lexer.backup();
	  lexer.emit(lunr.QueryLexer.FIELD);
	  lexer.ignore();
	  return lunr.QueryLexer.lexText
	};

	lunr.QueryLexer.lexTerm = function (lexer) {
	  if (lexer.width() > 1) {
	    lexer.backup();
	    lexer.emit(lunr.QueryLexer.TERM);
	  }

	  lexer.ignore();

	  if (lexer.more()) {
	    return lunr.QueryLexer.lexText
	  }
	};

	lunr.QueryLexer.lexEditDistance = function (lexer) {
	  lexer.ignore();
	  lexer.acceptDigitRun();
	  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE);
	  return lunr.QueryLexer.lexText
	};

	lunr.QueryLexer.lexBoost = function (lexer) {
	  lexer.ignore();
	  lexer.acceptDigitRun();
	  lexer.emit(lunr.QueryLexer.BOOST);
	  return lunr.QueryLexer.lexText
	};

	lunr.QueryLexer.lexEOS = function (lexer) {
	  if (lexer.width() > 0) {
	    lexer.emit(lunr.QueryLexer.TERM);
	  }
	};

	// This matches the separator used when tokenising fields
	// within a document. These should match otherwise it is
	// not possible to search for some tokens within a document.
	//
	// It is possible for the user to change the separator on the
	// tokenizer so it _might_ clash with any other of the special
	// characters already used within the search string, e.g. :.
	//
	// This means that it is possible to change the separator in
	// such a way that makes some words unsearchable using a search
	// string.
	lunr.QueryLexer.termSeparator = lunr.tokenizer.separator;

	lunr.QueryLexer.lexText = function (lexer) {
	  while (true) {
	    var char = lexer.next();

	    if (char == lunr.QueryLexer.EOS) {
	      return lunr.QueryLexer.lexEOS
	    }

	    // Escape character is '\'
	    if (char.charCodeAt(0) == 92) {
	      lexer.escapeCharacter();
	      continue
	    }

	    if (char == ":") {
	      return lunr.QueryLexer.lexField
	    }

	    if (char == "~") {
	      lexer.backup();
	      if (lexer.width() > 0) {
	        lexer.emit(lunr.QueryLexer.TERM);
	      }
	      return lunr.QueryLexer.lexEditDistance
	    }

	    if (char == "^") {
	      lexer.backup();
	      if (lexer.width() > 0) {
	        lexer.emit(lunr.QueryLexer.TERM);
	      }
	      return lunr.QueryLexer.lexBoost
	    }

	    // "+" indicates term presence is required
	    // checking for length to ensure that only
	    // leading "+" are considered
	    if (char == "+" && lexer.width() === 1) {
	      lexer.emit(lunr.QueryLexer.PRESENCE);
	      return lunr.QueryLexer.lexText
	    }

	    // "-" indicates term presence is prohibited
	    // checking for length to ensure that only
	    // leading "-" are considered
	    if (char == "-" && lexer.width() === 1) {
	      lexer.emit(lunr.QueryLexer.PRESENCE);
	      return lunr.QueryLexer.lexText
	    }

	    if (char.match(lunr.QueryLexer.termSeparator)) {
	      return lunr.QueryLexer.lexTerm
	    }
	  }
	};

	lunr.QueryParser = function (str, query) {
	  this.lexer = new lunr.QueryLexer (str);
	  this.query = query;
	  this.currentClause = {};
	  this.lexemeIdx = 0;
	};

	lunr.QueryParser.prototype.parse = function () {
	  this.lexer.run();
	  this.lexemes = this.lexer.lexemes;

	  var state = lunr.QueryParser.parseClause;

	  while (state) {
	    state = state(this);
	  }

	  return this.query
	};

	lunr.QueryParser.prototype.peekLexeme = function () {
	  return this.lexemes[this.lexemeIdx]
	};

	lunr.QueryParser.prototype.consumeLexeme = function () {
	  var lexeme = this.peekLexeme();
	  this.lexemeIdx += 1;
	  return lexeme
	};

	lunr.QueryParser.prototype.nextClause = function () {
	  var completedClause = this.currentClause;
	  this.query.clause(completedClause);
	  this.currentClause = {};
	};

	lunr.QueryParser.parseClause = function (parser) {
	  var lexeme = parser.peekLexeme();

	  if (lexeme == undefined) {
	    return
	  }

	  switch (lexeme.type) {
	    case lunr.QueryLexer.PRESENCE:
	      return lunr.QueryParser.parsePresence
	    case lunr.QueryLexer.FIELD:
	      return lunr.QueryParser.parseField
	    case lunr.QueryLexer.TERM:
	      return lunr.QueryParser.parseTerm
	    default:
	      var errorMessage = "expected either a field or a term, found " + lexeme.type;

	      if (lexeme.str.length >= 1) {
	        errorMessage += " with value '" + lexeme.str + "'";
	      }

	      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
	  }
	};

	lunr.QueryParser.parsePresence = function (parser) {
	  var lexeme = parser.consumeLexeme();

	  if (lexeme == undefined) {
	    return
	  }

	  switch (lexeme.str) {
	    case "-":
	      parser.currentClause.presence = lunr.Query.presence.PROHIBITED;
	      break
	    case "+":
	      parser.currentClause.presence = lunr.Query.presence.REQUIRED;
	      break
	    default:
	      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'";
	      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
	  }

	  var nextLexeme = parser.peekLexeme();

	  if (nextLexeme == undefined) {
	    var errorMessage = "expecting term or field, found nothing";
	    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
	  }

	  switch (nextLexeme.type) {
	    case lunr.QueryLexer.FIELD:
	      return lunr.QueryParser.parseField
	    case lunr.QueryLexer.TERM:
	      return lunr.QueryParser.parseTerm
	    default:
	      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'";
	      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
	  }
	};

	lunr.QueryParser.parseField = function (parser) {
	  var lexeme = parser.consumeLexeme();

	  if (lexeme == undefined) {
	    return
	  }

	  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
	    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
	        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields;

	    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
	  }

	  parser.currentClause.fields = [lexeme.str];

	  var nextLexeme = parser.peekLexeme();

	  if (nextLexeme == undefined) {
	    var errorMessage = "expecting term, found nothing";
	    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
	  }

	  switch (nextLexeme.type) {
	    case lunr.QueryLexer.TERM:
	      return lunr.QueryParser.parseTerm
	    default:
	      var errorMessage = "expecting term, found '" + nextLexeme.type + "'";
	      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
	  }
	};

	lunr.QueryParser.parseTerm = function (parser) {
	  var lexeme = parser.consumeLexeme();

	  if (lexeme == undefined) {
	    return
	  }

	  parser.currentClause.term = lexeme.str.toLowerCase();

	  if (lexeme.str.indexOf("*") != -1) {
	    parser.currentClause.usePipeline = false;
	  }

	  var nextLexeme = parser.peekLexeme();

	  if (nextLexeme == undefined) {
	    parser.nextClause();
	    return
	  }

	  switch (nextLexeme.type) {
	    case lunr.QueryLexer.TERM:
	      parser.nextClause();
	      return lunr.QueryParser.parseTerm
	    case lunr.QueryLexer.FIELD:
	      parser.nextClause();
	      return lunr.QueryParser.parseField
	    case lunr.QueryLexer.EDIT_DISTANCE:
	      return lunr.QueryParser.parseEditDistance
	    case lunr.QueryLexer.BOOST:
	      return lunr.QueryParser.parseBoost
	    case lunr.QueryLexer.PRESENCE:
	      parser.nextClause();
	      return lunr.QueryParser.parsePresence
	    default:
	      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'";
	      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
	  }
	};

	lunr.QueryParser.parseEditDistance = function (parser) {
	  var lexeme = parser.consumeLexeme();

	  if (lexeme == undefined) {
	    return
	  }

	  var editDistance = parseInt(lexeme.str, 10);

	  if (isNaN(editDistance)) {
	    var errorMessage = "edit distance must be numeric";
	    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
	  }

	  parser.currentClause.editDistance = editDistance;

	  var nextLexeme = parser.peekLexeme();

	  if (nextLexeme == undefined) {
	    parser.nextClause();
	    return
	  }

	  switch (nextLexeme.type) {
	    case lunr.QueryLexer.TERM:
	      parser.nextClause();
	      return lunr.QueryParser.parseTerm
	    case lunr.QueryLexer.FIELD:
	      parser.nextClause();
	      return lunr.QueryParser.parseField
	    case lunr.QueryLexer.EDIT_DISTANCE:
	      return lunr.QueryParser.parseEditDistance
	    case lunr.QueryLexer.BOOST:
	      return lunr.QueryParser.parseBoost
	    default:
	      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'";
	      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
	  }
	};

	lunr.QueryParser.parseBoost = function (parser) {
	  var lexeme = parser.consumeLexeme();

	  if (lexeme == undefined) {
	    return
	  }

	  var boost = parseInt(lexeme.str, 10);

	  if (isNaN(boost)) {
	    var errorMessage = "boost must be numeric";
	    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
	  }

	  parser.currentClause.boost = boost;

	  var nextLexeme = parser.peekLexeme();

	  if (nextLexeme == undefined) {
	    parser.nextClause();
	    return
	  }

	  switch (nextLexeme.type) {
	    case lunr.QueryLexer.TERM:
	      parser.nextClause();
	      return lunr.QueryParser.parseTerm
	    case lunr.QueryLexer.FIELD:
	      parser.nextClause();
	      return lunr.QueryParser.parseField
	    case lunr.QueryLexer.EDIT_DISTANCE:
	      return lunr.QueryParser.parseEditDistance
	    case lunr.QueryLexer.BOOST:
	      return lunr.QueryParser.parseBoost
	    default:
	      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'";
	      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
	  }
	}

	  /**
	   * export the module via AMD, CommonJS or as a browser global
	   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
	   */
	  ;(function (root, factory) {
	    if (typeof undefined === 'function' && undefined.amd) {
	      // AMD. Register as an anonymous module.
	      undefined(factory);
	    } else {
	      /**
	       * Node. Does not work with strict CommonJS, but
	       * only CommonJS-like enviroments that support module.exports,
	       * like Node.
	       */
	      module.exports = factory();
	    }
	  }(this, function () {
	    /**
	     * Just return a value to define the module export.
	     * This example returns an object, but the module
	     * can return a function as the exported value.
	     */
	    return lunr
	  }));
	})();
	});

	function addToDataLayer (payload) {
	  window.dataLayer = window.dataLayer || [];
	  window.dataLayer.push(payload);
	}

	function stripPossiblePII (string) {
	  // Try to detect emails and redact it.
	  string = string.replace(/\S*@\S*\s?/g, '[blocked]');
	  // If someone has typed in a number it's likely not related so redact it
	  string = string.replace(/0|1|2|3|4|5|6|7|8|9/g, '[blocked]');
	  return string
	}

	function trackConfirm (searchQuery, searchResults, result) {
	  if (window.DO_NOT_TRACK_ENABLED) {
	    return
	  }

	  var searchTerm = stripPossiblePII(searchQuery);
	  var products =
	    searchResults
	      .map(function (result, key) {
	        return {
	          name: result.title,
	          category: result.section,
	          list: searchTerm, // Used to match an searchTerm with results
	          position: (key + 1)
	        }
	      })
	      .filter(function (product) {
	        // Only return the product that matches what was clicked
	        return product.name === result.title
	      });

	  addToDataLayer({
	    event: 'site-search',
	    eventDetails: {
	      category: 'site search',
	      action: 'click',
	      label: searchTerm + ' | ' + result.title
	    },
	    ecommerce: {
	      click: {
	        actionField: { list: searchTerm },
	        products: products
	      }
	    }
	  });
	}

	function trackSearchResults (searchQuery, searchResults) {
	  if (window.DO_NOT_TRACK_ENABLED) {
	    return
	  }

	  var searchTerm = stripPossiblePII(searchQuery);

	  var hasResults = (searchResults.length > 0);
	  // Impressions is Google Analytics lingo for what people have seen.
	  var impressions = searchResults.map(function (result, key) {
	    return {
	      name: result.title,
	      category: result.section,
	      list: searchTerm, // Used to match an searchTerm with results
	      position: (key + 1)
	    }
	  });

	  addToDataLayer({
	    event: 'site-search',
	    eventDetails: {
	      category: 'site search',
	      action: hasResults ? 'results' : 'no result',
	      label: searchTerm
	    },
	    ecommerce: {
	      impressions: impressions
	    }
	  });
	}

	/* global XMLHttpRequest */

	// CONSTANTS
	var TIMEOUT = 10; // Time to wait before giving up fetching the search index
	var STATE_DONE = 4; // XHR client readyState DONE

	// LunrJS Search index
	var searchIndex = null;
	var documentStore = null;

	var statusMessage = null;
	var searchQuery = '';
	var searchCallback = function () {};
	// Results that are rendered by the autocomplete
	var searchResults = [];

	// Timer that allows us to only fire events after a user has finished typing
	var inputDebounceTimer = null;

	// We want to wait a bit before firing events to indicate that
	// someone is looking at a result and not that it's come up in passing.
	var DEBOUNCE_TIME_TO_WAIT = function () {
	  // We want to be able to reduce this timeout in order to make sure
	  // our tests do not run very slowly.
	  var timeout = window.__SITE_SEARCH_TRACKING_TIMEOUT;
	  return (typeof timeout !== 'undefined') ? timeout : 2000 // milliseconds
	};

	function Search ($module) {
	  this.$module = $module;
	}

	Search.prototype.fetchSearchIndex = function (indexUrl, callback) {
	  var request = new XMLHttpRequest();
	  request.open('GET', indexUrl, true);
	  request.timeout = TIMEOUT * 1000;
	  statusMessage = 'Loading search index';
	  request.onreadystatechange = function () {
	    if (request.readyState === STATE_DONE) {
	      if (request.status === 200) {
	        var response = request.responseText;
	        var json = JSON.parse(response);
	        statusMessage = 'No results found';
	        searchIndex = lunr.Index.load(json.index);
	        documentStore = json.store;
	        callback(json);
	      } else {
	        statusMessage = 'Failed to load the search index';
	        // Log to analytics?
	      }
	    }
	  };
	  request.send();
	};

	Search.prototype.renderResults = function () {
	  if (!searchIndex || !documentStore) {
	    return searchCallback(searchResults)
	  }
	  var lunrSearchResults = searchIndex.query(function (q) {
	    q.term(lunr.tokenizer(searchQuery), {
	      wildcard: lunr.Query.wildcard.TRAILING
	    });
	  });
	  searchResults = lunrSearchResults.map(function (result) {
	    return documentStore[result.ref]
	  });
	  searchCallback(searchResults);
	};

	Search.prototype.handleSearchQuery = function (query, callback) {
	  searchQuery = query;
	  searchCallback = callback;

	  clearTimeout(inputDebounceTimer);
	  inputDebounceTimer = setTimeout(function () {
	    trackSearchResults(searchQuery, searchResults);
	  }, DEBOUNCE_TIME_TO_WAIT());

	  this.renderResults();
	};

	Search.prototype.handleOnConfirm = function (result) {
	  var path = result.path;
	  if (!path) {
	    return
	  }
	  trackConfirm(searchQuery, searchResults, result);
	  window.location.href = '/' + path;
	};

	Search.prototype.inputValueTemplate = function (result) {
	  if (result) {
	    return result.title
	  }
	};

	Search.prototype.resultTemplate = function (result) {
	  // add rest of the data here to build the item
	  if (result) {
	    var elem = document.createElement('span');
	    var resultTitle = result.title;
	    elem.textContent = resultTitle;
	    if (result.aliases) {
	      var aliases = result.aliases.split(',').map(function (item) {
	        return item.trim()
	      });
	      var matchedAliases = [];
	      // only show a matching alias if there are no matches in the title
	      if (resultTitle.toLowerCase().indexOf(searchQuery) === -1) {
	        // it would be confusing to show the user
	        // aliases that don't match the typed query
	        matchedAliases = aliases.filter(function (alias) {
	          return alias.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1
	        });
	      }
	      if (matchedAliases.length > 0) {
	        var aliasesContainer = document.createElement('span');
	        aliasesContainer.className = 'app-site-search__aliases';
	        aliasesContainer.textContent = matchedAliases.join(', ');
	        elem.appendChild(aliasesContainer);
	      }
	    }
	    var section = document.createElement('span');
	    section.className = 'app-site-search--section';
	    section.innerHTML = result.section;

	    elem.appendChild(section);
	    return elem.innerHTML
	  }
	};

	Search.prototype.init = function () {
	  var $module = this.$module;
	  if (!$module) {
	    return
	  }

	  // The Accessible Autocomplete only works in IE9+ so we can use newer JavaScript features here
	  // but need to check for browsers that do not have these features and force the fallback by returning early.
	  // http://responsivenews.co.uk/post/18948466399/cutting-the-mustard
	  var featuresNeeded = (
	    'querySelector' in document &&
	    'addEventListener' in window &&
	    !!(Array.prototype && Array.prototype.forEach)
	  );

	  if (!featuresNeeded) {
	    return
	  }

	  accessibleAutocomplete({
	    element: $module,
	    id: 'app-site-search__input',
	    cssNamespace: 'app-site-search',
	    displayMenu: 'overlay',
	    placeholder: 'Search Design System',
	    confirmOnBlur: false,
	    autoselect: true,
	    source: this.handleSearchQuery.bind(this),
	    onConfirm: this.handleOnConfirm,
	    templates: {
	      inputValue: this.inputValueTemplate,
	      suggestion: this.resultTemplate
	    },
	    tNoResults: function () { return statusMessage }
	  });

	  var $wrapper = $module.querySelector('.app-site-search__wrapper');
	  var $input = $module.querySelector('.app-site-search__input');

	  // Ensure if the user stops using the search that we do not send tracking events
	  $input.addEventListener('blur', function (event) {
	    clearTimeout(inputDebounceTimer);
	  });

	  // Ensure the Button (which is a background image of the wrapper) focuses the input when clicked.
	  $wrapper.addEventListener('click', function (event) {
	    // Only focus the input if the user clicks the wrapper and not the input.
	    if (event.target === $wrapper) {
	      $input.focus();
	    }
	  });

	  var searchIndexUrl = $module.getAttribute('data-search-index');
	  this.fetchSearchIndex(searchIndexUrl, function () {
	    this.renderResults();
	  }.bind(this));
	};

	var OptionsTable = {
	  init: function () {
	    OptionsTable.expandMacroOptions();
	  },
	  // Open Nunjucks tab and expand macro options details when URL hash is '#options-[exampleName]'
	  expandMacroOptions: function () {
	    var hash = window.location.hash;

	    if (hash.match('^#options-')) {
	      var exampleName = hash.split('#options-')[1];

	      // Is hash for a specific options table? eg. #options-example-default--hint
	      var isLinkToTable = hash.indexOf('--') > -1;
	      if (isLinkToTable) {
	        exampleName = exampleName.split('--')[0];
	      }

	      if (exampleName) {
	        var tabLink = document.querySelector('a[href="#' + exampleName + '-nunjucks"]');
	        var tabHeading = tabLink ? tabLink.parentNode : null;
	        var optionsDetailsElement = document.getElementById('options-' + exampleName + '-details');

	        if (tabHeading && optionsDetailsElement) {
	          var tabsElement = optionsDetailsElement.parentNode;
	          var detailsSummary = optionsDetailsElement.querySelector('.govuk-details__summary');
	          var detailsText = optionsDetailsElement.querySelector('.govuk-details__text');

	          if (detailsSummary && detailsText) {
	            tabLink.setAttribute('aria-expanded', true);
	            tabHeading.className += ' app-tabs__item--current';
	            tabsElement.classList.remove('app-tabs__container--hidden');
	            tabsElement.setAttribute('aria-hidden', false);

	            optionsDetailsElement.setAttribute('open', 'open');
	            detailsSummary.setAttribute('aria-expanded', true);
	            detailsText.setAttribute('aria-hidden', false);
	            detailsText.style.display = '';
	            window.setTimeout(function () {
	              tabLink.focus();
	              if (isLinkToTable) document.querySelector(hash).scrollIntoView();
	            }, 0);
	          }
	        }
	      }
	    }
	  }
	};

	var nodeListForEach$2 = common.nodeListForEach;

	// Add cookie message
	CookieBanner.addCookieMessage();

	// Initialise example frames
	var $examples = document.querySelectorAll('[data-module="app-example-frame"]');
	nodeListForEach$2($examples, function ($example) {
	  new Example($example).init();
	});

	// Initialise tabs
	var $tabs = document.querySelectorAll('[data-module="app-tabs"]');
	nodeListForEach$2($tabs, function ($tabs) {
	  new AppTabs($tabs).init();
	});

	// Do this after initialising tabs
	OptionsTable.init();

	// Add copy to clipboard to code blocks inside tab containers
	var $codeBlocks = document.querySelectorAll('[data-module="app-copy"]');
	nodeListForEach$2($codeBlocks, function ($codeBlock) {
	  new Copy($codeBlock).init();
	});

	// Initialise mobile navigation
	new MobileNav().init();

	// Initialise search
	var $searchContainer = document.querySelector('[data-module="app-search"]');
	new Search($searchContainer).init();

}());
